var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    {
      staticClass: "mx-0",
      class: { fullSize: _vm.loading },
      attrs: { "align-center": "", "justify-center": "" },
    },
    [
      _c(
        "v-col",
        { staticClass: "pa-0 generalClass-table-padding" },
        [
          _vm.loading
            ? _c("loading-page")
            : _vm.error || !_vm.definitions.length
            ? _c("default-page", {
                attrs: {
                  imageUrl: "/img/dynamic-src-images/configurations-2.svg",
                  title: "Configurations",
                  text: "It seems that you don't have any configurations|Click Get Started below to add a configuration",
                  buttonText: _vm.error ? "Reload" : "Get Started",
                  errorMessage: _vm.error ? _vm.errorMessage.message : "",
                },
                on: { "button-clicked": _vm.getStarted },
              })
            : _c(
                "div",
                [
                  _c("confirm-dialog", {
                    attrs: {
                      dialog: _vm.confirmDialog,
                      text: _vm.itemDeletionText,
                      text2: _vm.itemDeletionText2,
                      acceptButton: "Delete",
                      cantDelete: _vm.cantDelete,
                    },
                    on: {
                      "confirmation-event": function ($event) {
                        _vm.cantDelete
                          ? _vm.terminateAndDeleteConfig($event)
                          : _vm.deleteConfig($event)
                      },
                      "mutate-confirm-dialog": _vm.mutateConfirmDialog,
                    },
                  }),
                  _c(
                    "v-dialog",
                    {
                      attrs: {
                        transition: "scroll-x-transition",
                        "overlay-color": "grey darken-2",
                        "content-class":
                          "ec-confirmation-dialog overflowY-auto",
                        width: "600",
                        persistent: "",
                      },
                      model: {
                        value: _vm.journalFiltersDialogModel,
                        callback: function ($$v) {
                          _vm.journalFiltersDialogModel = $$v
                        },
                        expression: "journalFiltersDialogModel",
                      },
                    },
                    [
                      _c(
                        "v-card",
                        { attrs: { color: "accent", width: "600" } },
                        [
                          _vm.currentJournalFilter
                            ? _c(
                                "v-card-title",
                                {
                                  staticStyle: {
                                    "background-color": "#47bd96",
                                    color: "white",
                                  },
                                  attrs: { dark: "" },
                                },
                                [
                                  _vm._v(
                                    " Editing filter: " +
                                      _vm._s(_vm.currentJournalFilter.Name) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "v-card-text",
                            { staticClass: "pb-0 pt-5 text-center" },
                            [
                              _vm.currentJournalFilter
                                ? _c(
                                    "v-row",
                                    _vm._l(
                                      _vm.journalFilterFields,
                                      function (field) {
                                        return _c(
                                          "v-col",
                                          {
                                            key: field.name,
                                            staticClass: "pb-0 pt-1",
                                            attrs: { cols: "12", sm: "6" },
                                          },
                                          [
                                            field.type === "textfield" &&
                                            field.valueType === "text"
                                              ? _c("v-text-field", {
                                                  attrs: {
                                                    dense: "",
                                                    outlined: "",
                                                    label: field.name,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.currentJournalFilter[
                                                        field.name
                                                      ],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.currentJournalFilter,
                                                        field.name,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "currentJournalFilter[field.name]",
                                                  },
                                                })
                                              : _vm._e(),
                                            field.type === "textfield" &&
                                            field.valueType === "number"
                                              ? _c("v-text-field", {
                                                  attrs: {
                                                    type: "number",
                                                    dense: "",
                                                    outlined: "",
                                                    label: field.name,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.currentJournalFilter[
                                                        field.name
                                                      ],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.currentJournalFilter,
                                                        field.name,
                                                        _vm._n($$v)
                                                      )
                                                    },
                                                    expression:
                                                      "currentJournalFilter[field.name]",
                                                  },
                                                })
                                              : field.type === "group"
                                              ? _c("v-select", {
                                                  ref: "vSelectParsers",
                                                  refInFor: true,
                                                  attrs: {
                                                    items:
                                                      _vm.currentJournalFilter
                                                        .Parsers,
                                                    "menu-props": {
                                                      offsetY: true,
                                                      bottom: true,
                                                      maxHeight: "250",
                                                    },
                                                    dense: "",
                                                    outlined: "",
                                                    "return-object": "",
                                                    "item-text": "Name",
                                                    "item-value": "id",
                                                    multiple: "",
                                                    label: field.name,
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "no-data",
                                                        fn: function () {
                                                          return [
                                                            _c("div", {
                                                              staticStyle: {
                                                                "border-top":
                                                                  "none !important",
                                                              },
                                                            }),
                                                          ]
                                                        },
                                                        proxy: true,
                                                      },
                                                      {
                                                        key: "prepend-item",
                                                        fn: function () {
                                                          return [
                                                            _c(
                                                              "v-list-item",
                                                              {
                                                                staticStyle: {
                                                                  "max-height":
                                                                    "40px",
                                                                  "border-bottom":
                                                                    "1px solid #7f7f7f",
                                                                },
                                                                attrs: {
                                                                  ripple: "",
                                                                },
                                                                on: {
                                                                  click:
                                                                    _vm.addCustomParser,
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list-item-content",
                                                                  [
                                                                    _c(
                                                                      "v-list-item-title",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            "font-size":
                                                                              "14px !important",
                                                                            "font-weight":
                                                                              "400",
                                                                          },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "i",
                                                                          {
                                                                            staticClass:
                                                                              "fas fa-plus-circle mr-1",
                                                                            staticStyle:
                                                                              {
                                                                                color:
                                                                                  "#47bd96",
                                                                              },
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          " Custom parser "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        },
                                                        proxy: true,
                                                      },
                                                      {
                                                        key: "item",
                                                        fn: function ({
                                                          item,
                                                        }) {
                                                          return [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "mb-0 char-lim-tabs",
                                                              },
                                                              [
                                                                _c("div", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.Name
                                                                    )
                                                                  ),
                                                                ]),
                                                              ]
                                                            ),
                                                            _c("v-spacer", {
                                                              staticStyle: {
                                                                "border-top":
                                                                  "none !important",
                                                              },
                                                            }),
                                                            _c(
                                                              "v-btn",
                                                              {
                                                                staticClass:
                                                                  "mr-1",
                                                                staticStyle: {
                                                                  "margin-top":
                                                                    "1px",
                                                                },
                                                                attrs: {
                                                                  small: "",
                                                                  icon: "",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                      return _vm.editCustomJournalFilterParser(
                                                                        item
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "icon-edit-21x21",
                                                                    staticStyle:
                                                                      {
                                                                        "font-size":
                                                                          "27px",
                                                                        "margin-bottom":
                                                                          "2px",
                                                                      },
                                                                  },
                                                                  [
                                                                    _c("span", {
                                                                      staticClass:
                                                                        "path1 letterSpacing0",
                                                                    }),
                                                                    _c("span", {
                                                                      staticClass:
                                                                        "path2",
                                                                    }),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "v-btn",
                                                              {
                                                                staticStyle: {
                                                                  "margin-top":
                                                                    "1px",
                                                                },
                                                                attrs: {
                                                                  small: "",
                                                                  icon: "",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                      return _vm.deleteCustomJournalFilterParser(
                                                                        item
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "icon-delete-21x21",
                                                                    staticStyle:
                                                                      {
                                                                        "font-size":
                                                                          "27px",
                                                                        "margin-bottom":
                                                                          "2px",
                                                                      },
                                                                  },
                                                                  [
                                                                    _c("span", {
                                                                      staticClass:
                                                                        "path1 letterSpacing0",
                                                                    }),
                                                                    _c("span", {
                                                                      staticClass:
                                                                        "path2",
                                                                    }),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                  model: {
                                                    value:
                                                      _vm.selectedJournalFilterParsers,
                                                    callback: function ($$v) {
                                                      _vm.selectedJournalFilterParsers =
                                                        $$v
                                                    },
                                                    expression:
                                                      "selectedJournalFilterParsers",
                                                  },
                                                })
                                              : _vm._e(),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    1
                                  )
                                : _c("p", [
                                    _vm._v("Oops! Something went wrong..."),
                                  ]),
                              _vm.currentParserEditing
                                ? _c("p", { staticClass: "text-start ml-1" }, [
                                    _vm._v(
                                      " Custom Parser: " +
                                        _vm._s(_vm.currentParserEditing.Name) +
                                        " "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm.currentParserEditing
                                ? _c(
                                    "v-row",
                                    _vm._l(
                                      _vm.journalFilterParserFields,
                                      function (parserField) {
                                        return _c(
                                          "v-col",
                                          {
                                            key: parserField.id,
                                            staticClass: "pb-0 pt-1",
                                            attrs: { cols: "12", sm: "6" },
                                          },
                                          [
                                            parserField.type === "textfield"
                                              ? _c("v-text-field", {
                                                  attrs: {
                                                    dense: "",
                                                    outlined: "",
                                                    label: parserField.name,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.currentParserEditing[
                                                        parserField.name
                                                      ],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.currentParserEditing,
                                                        parserField.name,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "currentParserEditing[parserField.name]",
                                                  },
                                                })
                                              : _vm._e(),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "v-card-actions",
                            { staticClass: "pt-0" },
                            [
                              _c("v-spacer"),
                              _c(
                                "v-btn",
                                {
                                  attrs: { text: "" },
                                  on: {
                                    click: function ($event) {
                                      _vm.journalFiltersDialogModel = false
                                    },
                                  },
                                },
                                [_vm._v("Cancel ")]
                              ),
                              _c(
                                "v-btn",
                                {
                                  attrs: { color: "primary", text: "" },
                                  on: { click: _vm.saveJournalFilter },
                                },
                                [_vm._v("Save ")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("quote-connection-edit-dialog", {
                    attrs: {
                      quoteConnectionEditDialog: _vm.quoteConnectionEditDialog,
                      quoteConnectionType: _vm.quoteConnectionSelected,
                      currentEncryptionMethods: _vm.currentEncryptionMethods,
                      currentDefinition: _vm.currentDefinition,
                    },
                    on: {
                      "update-quote-dialog": (ev) =>
                        (_vm.quoteConnectionEditDialog = ev),
                      "save-quote-connection": _vm.saveQuoteConnection,
                      "add-encryption-method": (method) =>
                        _vm.currentEncryptionMethods.unshift(method),
                    },
                  }),
                  _c(
                    "v-row",
                    { attrs: { "no-gutters": "" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("v-data-table", {
                            staticClass: "main_page_table",
                            attrs: {
                              "mobile-breakpoint": 0,
                              height: `${
                                _vm.$vuetify.breakpoint.mdAndUp
                                  ? _vm.windowSizeY - 100
                                  : _vm.windowSizeY - 96
                              }px`,
                              "items-per-page": _vm.itemsPerPage,
                              page: _vm.page,
                              "fixed-header": "",
                              "custom-sort": _vm.currentSortingAlgo,
                              "hide-default-header": "",
                              "hide-default-footer": "",
                              dense: "",
                              headers: _vm.headers,
                              "sort-by": "id",
                              items: _vm.tableItems,
                              "single-expand": "",
                              expanded: _vm.expanded,
                            },
                            on: {
                              "update:page": function ($event) {
                                _vm.page = $event
                              },
                              "update:expanded": function ($event) {
                                _vm.expanded = $event
                              },
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "header",
                                fn: function ({ props: { headers } }) {
                                  return [
                                    _c("thead", [
                                      _c(
                                        "tr",
                                        _vm._l(
                                          headers.filter((el, index) => {
                                            return (
                                              index + 1 <= _vm.headersCounter
                                            )
                                          }),
                                          function (header) {
                                            return _c(
                                              "th",
                                              {
                                                key: header.value,
                                                staticClass: "allTableHeaders",
                                              },
                                              [
                                                _c(
                                                  "v-row",
                                                  [
                                                    _c(
                                                      "v-col",
                                                      {
                                                        attrs: {
                                                          height: "100%",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-row",
                                                          {
                                                            class:
                                                              header.value ===
                                                              "configuration"
                                                                ? "pl-0"
                                                                : "pl-3",
                                                            style:
                                                              header.value ===
                                                                "configuration" ||
                                                              _vm.headersCounter ===
                                                                1
                                                                ? "justify-content: center;"
                                                                : "",
                                                          },
                                                          [
                                                            _c("v-hover", {
                                                              scopedSlots:
                                                                _vm._u(
                                                                  [
                                                                    {
                                                                      key: "default",
                                                                      fn: function ({
                                                                        hover,
                                                                      }) {
                                                                        return [
                                                                          _c(
                                                                            "p",
                                                                            {
                                                                              staticClass:
                                                                                "my-0 fullHeight",
                                                                              class:
                                                                                header.value ===
                                                                                "configuration"
                                                                                  ? "text-center"
                                                                                  : "allTableHeadersHover",
                                                                              on: {
                                                                                click:
                                                                                  function (
                                                                                    $event
                                                                                  ) {
                                                                                    _vm.currentSortingAlgo =
                                                                                      _vm.getNewSortingAlgo(
                                                                                        header
                                                                                      )
                                                                                    _vm.selectedHeader =
                                                                                      header.value
                                                                                  },
                                                                              },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    header.text
                                                                                  ) +
                                                                                  " "
                                                                              ),
                                                                              _c(
                                                                                "v-icon",
                                                                                {
                                                                                  directives:
                                                                                    [
                                                                                      {
                                                                                        name: "show",
                                                                                        rawName:
                                                                                          "v-show",
                                                                                        value:
                                                                                          header.value !==
                                                                                          "configuration",
                                                                                        expression:
                                                                                          "header.value !== 'configuration'",
                                                                                      },
                                                                                    ],
                                                                                  staticStyle:
                                                                                    {
                                                                                      "font-size":
                                                                                        "12px",
                                                                                      "margin-left":
                                                                                        "2px",
                                                                                    },
                                                                                  style:
                                                                                    !hover &&
                                                                                    _vm.selectedHeader !==
                                                                                      header.value
                                                                                      ? "opacity: 0.5;"
                                                                                      : "opacity: 1;",
                                                                                  attrs:
                                                                                    {
                                                                                      color:
                                                                                        "#a693f3",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      _vm.getSortingIcon(
                                                                                        header.currentSortAlg
                                                                                      )
                                                                                    ) +
                                                                                      " "
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ],
                                                                            1
                                                                          ),
                                                                        ]
                                                                      },
                                                                    },
                                                                  ],
                                                                  null,
                                                                  true
                                                                ),
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]),
                                  ]
                                },
                              },
                              {
                                key: "item",
                                fn: function ({ item, index }) {
                                  return [
                                    _c(
                                      "tr",
                                      {
                                        staticClass: "table_Row rowClick",
                                        attrs: {
                                          id: _vm.$vuetify.theme.dark
                                            ? "dataTableRow_dark"
                                            : "dataTableRow_light",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.expandRow(item)
                                          },
                                        },
                                      },
                                      [
                                        _vm._l(
                                          _vm.headersCounter !==
                                            _vm.headers.length
                                            ? _vm.headersCounter
                                            : _vm.headersCounter - 1,
                                          function (header, index) {
                                            return _c(
                                              "td",
                                              { key: index },
                                              [
                                                _c(
                                                  "v-row",
                                                  [
                                                    _vm.headersCounter === 1
                                                      ? _c("p", {
                                                          style: `margin-left: 30% !important;`,
                                                        })
                                                      : _vm._e(),
                                                    _vm.headers[index].value ===
                                                      "name" &&
                                                    _vm.headersCounter !==
                                                      _vm.headers.length
                                                      ? _c(
                                                          "v-icon",
                                                          {
                                                            class:
                                                              _vm.expanded.some(
                                                                (el) =>
                                                                  el.id ===
                                                                  item.id
                                                              )
                                                                ? "red--text pr-1 ml-2"
                                                                : "primary--text pr-1 ml-2",
                                                            staticStyle: {
                                                              "font-size":
                                                                "16px",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.expanded.some(
                                                                    (el) =>
                                                                      el.id ===
                                                                      item.id
                                                                  )
                                                                    ? "fas fa-times-circle"
                                                                    : "fas fa-chevron-circle-down"
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm.headers[index].value !==
                                                      "application.name" &&
                                                    _vm.headers[index].value !==
                                                      "server.name"
                                                      ? _c(
                                                          "v-tooltip",
                                                          {
                                                            attrs: {
                                                              disabled:
                                                                !_vm.isAdmin ||
                                                                _vm.isNotDesktop ||
                                                                _vm.headers[
                                                                  index
                                                                ].value !==
                                                                  "name",
                                                              bottom: "",
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "activator",
                                                                  fn: function ({
                                                                    on,
                                                                  }) {
                                                                    return [
                                                                      _c(
                                                                        "p",
                                                                        _vm._g(
                                                                          {
                                                                            class:
                                                                              _vm.getCellTextClass(
                                                                                _vm
                                                                                  .headers[
                                                                                  index
                                                                                ]
                                                                                  .value
                                                                              ),
                                                                          },
                                                                          on
                                                                        ),
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                item[
                                                                                  _vm
                                                                                    .headers[
                                                                                    index
                                                                                  ]
                                                                                    .value
                                                                                ]
                                                                              ) +
                                                                              " "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          },
                                                          [
                                                            _c("span", [
                                                              item.id
                                                                ? _c("div", [
                                                                    _vm._v(
                                                                      "ID: " +
                                                                        _vm._s(
                                                                          item.id
                                                                        )
                                                                    ),
                                                                  ])
                                                                : _vm._e(),
                                                            ]),
                                                          ]
                                                        )
                                                      : _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "d-inline ml-3",
                                                            staticStyle: {
                                                              "margin-bottom":
                                                                "3px",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  item[
                                                                    _vm.getProperties(
                                                                      _vm
                                                                        .headers[
                                                                        index
                                                                      ].value,
                                                                      true
                                                                    )
                                                                  ][
                                                                    _vm.getProperties(
                                                                      _vm
                                                                        .headers[
                                                                        index
                                                                      ].value,
                                                                      false
                                                                    )
                                                                  ]
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        _vm.headersCounter ===
                                        _vm.headers.length
                                          ? _c(
                                              "td",
                                              { staticClass: "text-center" },
                                              [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      id: `edit-config${index}`,
                                                      icon: "",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.editConfiguration(
                                                          item
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "icon-edit-21x21",
                                                        staticStyle: {
                                                          "font-size": "28px",
                                                        },
                                                      },
                                                      [
                                                        _c("span", {
                                                          staticClass:
                                                            "path1 letterSpacing0",
                                                        }),
                                                        _c("span", {
                                                          staticClass: "path2",
                                                        }),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "v-tooltip",
                                                  {
                                                    staticClass: "mt-3 ml-1",
                                                    attrs: {
                                                      activator: `#edit-config${index}`,
                                                      bottom: "",
                                                    },
                                                  },
                                                  [_c("span", [_vm._v("Edit")])]
                                                ),
                                                _c(
                                                  "v-badge",
                                                  {
                                                    class: {
                                                      "badge-small":
                                                        item.cantDelete,
                                                    },
                                                    attrs: {
                                                      "offset-x": "18",
                                                      "offset-y": "12",
                                                      value: item.cantDelete,
                                                      color: "red",
                                                      icon: "fas fa-exclamation",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        attrs: {
                                                          id: `delete-config${index}`,
                                                          icon: "",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.confirmationDialog(
                                                              item
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "icon-delete-21x21",
                                                            staticStyle: {
                                                              "font-size":
                                                                "28px",
                                                            },
                                                          },
                                                          [
                                                            _c("span", {
                                                              staticClass:
                                                                "path1 letterSpacing0",
                                                            }),
                                                            _c("span", {
                                                              staticClass:
                                                                "path2",
                                                            }),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-tooltip",
                                                  {
                                                    staticClass: "mt-3 ml-1",
                                                    attrs: {
                                                      activator: `#delete-config${index}`,
                                                      bottom: "",
                                                    },
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v("Delete"),
                                                    ]),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "expanded-item",
                                fn: function ({ item }) {
                                  return _vm._l(
                                    _vm.headers.length - _vm.headersCounter,
                                    function (headerIndex, index) {
                                      return _c(
                                        "tr",
                                        {
                                          key: index,
                                          staticClass: "expandBackground",
                                        },
                                        [
                                          _c(
                                            "v-row",
                                            {
                                              staticClass:
                                                "expandRowClass_Border mx-0 table_Row",
                                              staticStyle: { height: "32px" },
                                            },
                                            [
                                              _vm.$vuetify.breakpoint.width <
                                              411
                                                ? _c("v-col", {
                                                    attrs: { cols: "1" },
                                                  })
                                                : _vm._e(),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "py-0 pl-2pr-0",
                                                  attrs: { cols: "3" },
                                                },
                                                [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass: "ml-1 my-1",
                                                      staticStyle: {
                                                        "font-weight": "600",
                                                        "font-size": "14px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.headers[
                                                              index +
                                                                _vm.headersCounter
                                                            ].text
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "py-0",
                                                  attrs: { cols: "8" },
                                                },
                                                [
                                                  _vm.headers[
                                                    index + _vm.headersCounter
                                                  ].value ===
                                                    "application.name" ||
                                                  _vm.headers[
                                                    index + _vm.headersCounter
                                                  ].value === "server.name"
                                                    ? _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "ml-1 my-1 text-center",
                                                          staticStyle: {
                                                            "font-size": "14px",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                item[
                                                                  _vm.getProperties(
                                                                    _vm.headers[
                                                                      index +
                                                                        _vm.headersCounter
                                                                    ].value,
                                                                    true
                                                                  )
                                                                ][
                                                                  _vm.getProperties(
                                                                    _vm.headers[
                                                                      index +
                                                                        _vm.headersCounter
                                                                    ].value,
                                                                    false
                                                                  )
                                                                ]
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    : headerIndex <
                                                      _vm.headers.length -
                                                        _vm.headersCounter
                                                    ? _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "ml-1 my-1 text-center char-lim-mobile",
                                                          staticStyle: {
                                                            "font-size": "14px",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                item[
                                                                  _vm.headers[
                                                                    index +
                                                                      _vm.headersCounter
                                                                  ].value
                                                                ]
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    : _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "text-center",
                                                        },
                                                        [
                                                          _c(
                                                            "v-tooltip",
                                                            {
                                                              staticClass:
                                                                "mt-3 ml-1",
                                                              attrs: {
                                                                disabled:
                                                                  _vm.isNotDesktop,
                                                                bottom: "",
                                                              },
                                                              scopedSlots:
                                                                _vm._u(
                                                                  [
                                                                    {
                                                                      key: "activator",
                                                                      fn: function ({
                                                                        on,
                                                                      }) {
                                                                        return [
                                                                          _c(
                                                                            "v-btn",
                                                                            _vm._g(
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    height:
                                                                                      "32",
                                                                                    width:
                                                                                      "32",
                                                                                    icon: "",
                                                                                  },
                                                                                on: {
                                                                                  click:
                                                                                    function (
                                                                                      $event
                                                                                    ) {
                                                                                      return _vm.editConfiguration(
                                                                                        item
                                                                                      )
                                                                                    },
                                                                                },
                                                                              },
                                                                              on
                                                                            ),
                                                                            [
                                                                              _c(
                                                                                "span",
                                                                                {
                                                                                  staticClass:
                                                                                    "icon-edit-21x21",
                                                                                  staticStyle:
                                                                                    {
                                                                                      "font-size":
                                                                                        "28px",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "span",
                                                                                    {
                                                                                      staticClass:
                                                                                        "path1 letterSpacing0",
                                                                                    }
                                                                                  ),
                                                                                  _c(
                                                                                    "span",
                                                                                    {
                                                                                      staticClass:
                                                                                        "path2",
                                                                                    }
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      },
                                                                    },
                                                                  ],
                                                                  null,
                                                                  true
                                                                ),
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v("Edit"),
                                                              ]),
                                                            ]
                                                          ),
                                                          _c(
                                                            "v-tooltip",
                                                            {
                                                              staticClass:
                                                                "mt-3",
                                                              attrs: {
                                                                disabled:
                                                                  _vm.isNotDesktop,
                                                                bottom: "",
                                                              },
                                                              scopedSlots:
                                                                _vm._u(
                                                                  [
                                                                    {
                                                                      key: "activator",
                                                                      fn: function ({
                                                                        on,
                                                                      }) {
                                                                        return [
                                                                          _c(
                                                                            "v-btn",
                                                                            _vm._g(
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    height:
                                                                                      "32",
                                                                                    width:
                                                                                      "32",
                                                                                    icon: "",
                                                                                  },
                                                                                on: {
                                                                                  click:
                                                                                    function (
                                                                                      $event
                                                                                    ) {
                                                                                      return _vm.confirmationDialog(
                                                                                        item
                                                                                      )
                                                                                    },
                                                                                },
                                                                              },
                                                                              on
                                                                            ),
                                                                            [
                                                                              _c(
                                                                                "span",
                                                                                {
                                                                                  staticClass:
                                                                                    "icon-delete-21x21",
                                                                                  staticStyle:
                                                                                    {
                                                                                      "font-size":
                                                                                        "28px",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "span",
                                                                                    {
                                                                                      staticClass:
                                                                                        "path1 letterSpacing0",
                                                                                    }
                                                                                  ),
                                                                                  _c(
                                                                                    "span",
                                                                                    {
                                                                                      staticClass:
                                                                                        "path2",
                                                                                    }
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      },
                                                                    },
                                                                  ],
                                                                  null,
                                                                  true
                                                                ),
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  "Delete"
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._l(
                                            _vm.headersCounter - 1,
                                            function (header) {
                                              return _c("td", {
                                                key: header,
                                                staticStyle: { border: "none" },
                                              })
                                            }
                                          ),
                                        ],
                                        2
                                      )
                                    }
                                  )
                                },
                              },
                              {
                                key: "no-data",
                                fn: function () {
                                  return [
                                    _c(
                                      "v-alert",
                                      {
                                        attrs: {
                                          value: true,
                                          color: "primary",
                                          icon: "warning",
                                          outlined: "",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " It seems that you don't have any configurations. Click at "
                                        ),
                                        _c("v-icon", [_vm._v("add")]),
                                        _vm._v(" to create a configuration! "),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                          }),
                          _c(
                            "div",
                            { staticClass: "text-center custom-table-footer" },
                            [
                              _c(
                                "v-row",
                                {
                                  staticClass: "mx-0",
                                  attrs: {
                                    justify: "space-between",
                                    "justify-sm": "end",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "ml-2 pagination-item-1" },
                                    [
                                      _vm.$vuetify.breakpoint.smAndUp
                                        ? _c("div", { staticClass: "mr-6" }, [
                                            _vm._v(" Rows per page: "),
                                          ])
                                        : _vm._e(),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "footer-items-wrapper",
                                          class: {
                                            "mr-1":
                                              _vm.$vuetify.breakpoint.smAndUp,
                                          },
                                        },
                                        [
                                          _c("v-select", {
                                            staticClass:
                                              "footer-items-per-page mt-0",
                                            attrs: {
                                              dense: "",
                                              "hide-details": "",
                                              "menu-props": {
                                                top: true,
                                                offsetY: true,
                                              },
                                              items: [10, 25, 50, 100],
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.paginationChangeHandler(
                                                  1
                                                )
                                              },
                                            },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "item",
                                                fn: function ({ item }) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "mb-0 char-lim-tabs page-rows-selection",
                                                      },
                                                      [
                                                        item === -1
                                                          ? _c("div", [
                                                              _vm._v("All"),
                                                            ])
                                                          : _c("div", [
                                                              _vm._v(
                                                                _vm._s(item)
                                                              ),
                                                            ]),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                              {
                                                key: "selection",
                                                fn: function ({ item }) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "page-rows-selection",
                                                      },
                                                      [
                                                        item === -1
                                                          ? _c("div", [
                                                              _vm._v("All"),
                                                            ])
                                                          : _c("div", [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(item) +
                                                                  " "
                                                              ),
                                                            ]),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ]),
                                            model: {
                                              value: _vm.itemsPerPage,
                                              callback: function ($$v) {
                                                _vm.itemsPerPage = $$v
                                              },
                                              expression: "itemsPerPage",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                  _c("v-pagination", {
                                    staticClass: "pagination",
                                    attrs: {
                                      length: _vm.totalPages,
                                      "total-visible": _vm.$vuetify.breakpoint
                                        .xsOnly
                                        ? 5
                                        : 7,
                                      circle: "",
                                    },
                                    on: { input: _vm.paginationChangeHandler },
                                    model: {
                                      value: _vm.page,
                                      callback: function ($$v) {
                                        _vm.page = $$v
                                      },
                                      expression: "page",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
          _vm.definitions.length > 0 && _vm.isAdmin === true
            ? _c(
                "v-btn",
                {
                  style: { bottom: "70px" },
                  attrs: {
                    fab: "",
                    bottom: "",
                    right: "",
                    color: _vm.$vuetify.theme.dark ? "#685AA1" : "primary",
                    dark: "",
                    fixed: "",
                  },
                  on: { click: _vm.openDefinitionDialog },
                },
                [_c("v-icon", [_vm._v("add")])],
                1
              )
            : _vm._e(),
          _c(
            "v-dialog",
            {
              attrs: {
                transition: "scroll-x-transition",
                "overlay-color": "grey darken-2",
                "content-class": "configurations-dialog",
                width: "750px",
                scrollable: "",
                persistent: "",
              },
              model: {
                value: _vm.dialog,
                callback: function ($$v) {
                  _vm.dialog = $$v
                },
                expression: "dialog",
              },
            },
            [
              _c(
                "v-card",
                { staticClass: "accent" },
                [
                  _c(
                    "v-card-title",
                    {
                      staticStyle: {
                        "background-color": "#47bd96",
                        color: "white",
                      },
                      attrs: { dark: "" },
                    },
                    [_vm._v(" Application Configuration ")]
                  ),
                  _c(
                    "v-form",
                    {
                      ref: "confForm",
                      staticClass: "pt-4",
                      staticStyle: {
                        "overflow-y": "auto",
                        "margin-bottom": "14px",
                      },
                      model: {
                        value: _vm.valid,
                        callback: function ($$v) {
                          _vm.valid = $$v
                        },
                        expression: "valid",
                      },
                    },
                    [
                      _c(
                        "v-container",
                        { staticClass: "py-0" },
                        [
                          _c(
                            "v-tabs-items",
                            {
                              staticStyle: { "background-color": "initial" },
                              model: {
                                value: _vm.analyticsConfigModel,
                                callback: function ($$v) {
                                  _vm.analyticsConfigModel = $$v
                                },
                                expression: "analyticsConfigModel",
                              },
                            },
                            [
                              _c(
                                "v-tab-item",
                                [
                                  _c(
                                    "v-row",
                                    { attrs: { justify: "center" } },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "pb-0 pt-1",
                                          attrs: { cols: "12", sm: "6" },
                                        },
                                        [
                                          _c("v-text-field", {
                                            staticClass:
                                              "textFieldOverride analyticsTextFieldClass",
                                            attrs: {
                                              autofocus:
                                                !_vm.currentDefinition.id,
                                              dense: "",
                                              outlined: "",
                                              label: "Configuration Name",
                                              rules: [
                                                _vm.rules.required,
                                                _vm.rules.maxCharName,
                                              ],
                                              hint: "Max 50 characters",
                                              counter: "",
                                            },
                                            model: {
                                              value: _vm.currentDefinition.name,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.currentDefinition,
                                                  "name",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "currentDefinition.name",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "pb-0 pt-1",
                                          attrs: { cols: "12", sm: "6" },
                                        },
                                        [
                                          _c("v-text-field", {
                                            staticClass:
                                              "analyticsTextFieldClass",
                                            attrs: {
                                              dense: "",
                                              outlined: "",
                                              label:
                                                "Configuration Description",
                                              counter: "",
                                              rules: [
                                                _vm.rules.maxCharDescription,
                                              ],
                                              hint: "Max 200 characters",
                                            },
                                            model: {
                                              value:
                                                _vm.currentDefinition
                                                  .description,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.currentDefinition,
                                                  "description",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "currentDefinition.description",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _vm.add
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "py-0",
                                              attrs: { cols: "12", sm: "6" },
                                            },
                                            [
                                              _c("v-select", {
                                                attrs: {
                                                  dense: "",
                                                  outlined: "",
                                                  "menu-props": {
                                                    offsetY: true,
                                                    maxHeight: "210",
                                                  },
                                                  items: _vm.servers,
                                                  "item-text": "name",
                                                  "item-value": "id",
                                                  "return-object": "",
                                                  label: "Server",
                                                  rules: [_vm.rules.required],
                                                },
                                                on: {
                                                  change: _vm.serverSelected,
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "item",
                                                      fn: function ({ item }) {
                                                        return [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "mb-0",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.name
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  false,
                                                  3427839861
                                                ),
                                                model: {
                                                  value: _vm.chosenServer,
                                                  callback: function ($$v) {
                                                    _vm.chosenServer = $$v
                                                  },
                                                  expression: "chosenServer",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm.currentDefinition.server
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "py-0",
                                              attrs: { cols: "12", sm: "6" },
                                            },
                                            [
                                              _c("v-text-field", {
                                                staticClass:
                                                  "textFieldOverride analyticsTextFieldClass",
                                                attrs: {
                                                  autofocus: "",
                                                  dense: "",
                                                  outlined: "",
                                                  disabled: "",
                                                  label: "Server",
                                                },
                                                model: {
                                                  value:
                                                    _vm.currentDefinition.server
                                                      .name,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.currentDefinition
                                                        .server,
                                                      "name",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "currentDefinition.server.name",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.add && _vm.isAdmin
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "py-0",
                                              attrs: { cols: "12", sm: "6" },
                                            },
                                            [
                                              _c("v-select", {
                                                attrs: {
                                                  dense: "",
                                                  outlined: "",
                                                  "menu-props": {
                                                    offsetY: true,
                                                    maxHeight: "210",
                                                  },
                                                  items: _vm.executionTypes,
                                                  "item-text": "text",
                                                  "item-value": "value",
                                                  label: "Execution type",
                                                  rules: [_vm.rules.required],
                                                },
                                                on: {
                                                  change:
                                                    _vm.executionTypeChanged,
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "item",
                                                      fn: function ({ item }) {
                                                        return [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "mb-0",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.text
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  false,
                                                  1739406351
                                                ),
                                                model: {
                                                  value:
                                                    _vm.currentDefinition
                                                      .executionType,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.currentDefinition,
                                                      "executionType",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "currentDefinition.executionType",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.add &&
                                      _vm.isAdmin &&
                                      _vm.currentDefinition.executionType !==
                                        "PROCESS"
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "py-0",
                                              attrs: { cols: "12", sm: "6" },
                                            },
                                            [
                                              _c("v-select", {
                                                attrs: {
                                                  dense: "",
                                                  outlined: "",
                                                  "menu-props": {
                                                    offsetY: true,
                                                    maxHeight: "210",
                                                  },
                                                  items: [
                                                    {
                                                      text: "Analytics",
                                                      value: 1,
                                                    },
                                                    {
                                                      text: "Price Watcher",
                                                      value: 0,
                                                    },
                                                  ],
                                                  "item-text": "text",
                                                  "item-value": "value",
                                                  label: "Application type",
                                                  rules: [_vm.rules.required],
                                                },
                                                on: {
                                                  change:
                                                    _vm.applicationTypeChanged,
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "item",
                                                      fn: function ({ item }) {
                                                        return [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "mb-0",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.text
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  false,
                                                  1739406351
                                                ),
                                                model: {
                                                  value:
                                                    _vm.selectedApplicationType,
                                                  callback: function ($$v) {
                                                    _vm.selectedApplicationType =
                                                      $$v
                                                  },
                                                  expression:
                                                    "selectedApplicationType",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.selectedApplicationType ===
                                        _vm.applicationTypeEnums.general &&
                                      _vm.edit
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "py-0",
                                              attrs: {
                                                cols: "12",
                                                sm: _vm.positionAppEnablers
                                                  ? 12
                                                  : 6,
                                              },
                                            },
                                            [
                                              _c(
                                                "v-row",
                                                [
                                                  _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "pt-2",
                                                      attrs: { cols: "6" },
                                                    },
                                                    [
                                                      _c(
                                                        "v-row",
                                                        {
                                                          class: [
                                                            {
                                                              "mr-1":
                                                                _vm.positionAppEnablers,
                                                            },
                                                            {
                                                              "primary--text":
                                                                _vm.analyticsModel,
                                                            },
                                                          ],
                                                          attrs: {
                                                            justify:
                                                              _vm.positionAppEnablers
                                                                ? "end"
                                                                : "center",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              staticClass:
                                                                "mr-2",
                                                              class: {
                                                                "primary--text":
                                                                  _vm.analyticsModel,
                                                              },
                                                              staticStyle: {
                                                                "font-size":
                                                                  "17px",
                                                                height: "17px",
                                                                "margin-top":
                                                                  "3px",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "icon-analytics-23x23 "
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" Analytics "),
                                                          _c("v-switch", {
                                                            staticClass:
                                                              "always-primary-checkbox alert-card-switch mt-0 pt-0 ml-2",
                                                            staticStyle: {
                                                              width: "40px",
                                                              height: "20px",
                                                            },
                                                            attrs: {
                                                              small: "",
                                                              "hide-details":
                                                                "",
                                                              color: "primary",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.analyticsModel,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.analyticsModel =
                                                                    $$v
                                                                },
                                                              expression:
                                                                "analyticsModel",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "pt-2",
                                                      class: {
                                                        "pl-0":
                                                          _vm.$vuetify
                                                            .breakpoint.xsOnly,
                                                      },
                                                      attrs: { cols: "6" },
                                                    },
                                                    [
                                                      _c(
                                                        "v-row",
                                                        {
                                                          class: [
                                                            {
                                                              "mr-1":
                                                                _vm.positionAppEnablers,
                                                            },
                                                            {
                                                              "primary--text":
                                                                _vm.priceGuardModel,
                                                            },
                                                          ],
                                                          attrs: {
                                                            justify:
                                                              _vm.positionAppEnablers
                                                                ? "start"
                                                                : "center",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              staticClass:
                                                                "mr-2",
                                                              class: {
                                                                "primary--text":
                                                                  _vm.priceGuardModel,
                                                              },
                                                              staticStyle: {
                                                                "font-size":
                                                                  "17px",
                                                                height: "17px",
                                                                "margin-top":
                                                                  "3px",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "icon-price-guard-21x25 "
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(
                                                            " Price Guard "
                                                          ),
                                                          _c("v-switch", {
                                                            staticClass:
                                                              "always-primary-checkbox alert-card-switch mt-0 pt-0 ml-2",
                                                            staticStyle: {
                                                              width: "40px",
                                                              height: "20px",
                                                            },
                                                            attrs: {
                                                              small: "",
                                                              "hide-details":
                                                                "",
                                                              color: "primary",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.priceGuardModel,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.priceGuardModel =
                                                                    $$v
                                                                },
                                                              expression:
                                                                "priceGuardModel",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _vm.selectedApplicationType ===
                                    _vm.applicationTypeEnums.general && _vm.add
                                    ? _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "py-0",
                                              attrs: {
                                                cols: "12",
                                                sm: _vm.positionAppEnablers
                                                  ? 12
                                                  : 6,
                                              },
                                            },
                                            [
                                              _c(
                                                "v-row",
                                                [
                                                  _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "pt-2",
                                                      attrs: { cols: "6" },
                                                    },
                                                    [
                                                      _c(
                                                        "v-row",
                                                        {
                                                          class: [
                                                            {
                                                              "mr-1":
                                                                _vm.positionAppEnablers,
                                                            },
                                                            {
                                                              "primary--text":
                                                                _vm.analyticsModel,
                                                            },
                                                          ],
                                                          attrs: {
                                                            justify:
                                                              _vm.positionAppEnablers
                                                                ? "end"
                                                                : "center",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              staticClass:
                                                                "mr-2",
                                                              class: {
                                                                "primary--text":
                                                                  _vm.analyticsModel,
                                                              },
                                                              staticStyle: {
                                                                "font-size":
                                                                  "17px",
                                                                height: "17px",
                                                                "margin-top":
                                                                  "3px",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "icon-analytics-23x23 "
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" Analytics "),
                                                          _c("v-switch", {
                                                            staticClass:
                                                              "always-primary-checkbox alert-card-switch mt-0 pt-0 ml-2",
                                                            staticStyle: {
                                                              width: "40px",
                                                              height: "20px",
                                                            },
                                                            attrs: {
                                                              small: "",
                                                              "hide-details":
                                                                "",
                                                              color: "primary",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.analyticsModel,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.analyticsModel =
                                                                    $$v
                                                                },
                                                              expression:
                                                                "analyticsModel",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "pt-2",
                                                      class: {
                                                        "pl-0":
                                                          _vm.$vuetify
                                                            .breakpoint.xsOnly,
                                                      },
                                                      attrs: { cols: "6" },
                                                    },
                                                    [
                                                      _c(
                                                        "v-row",
                                                        {
                                                          class: [
                                                            {
                                                              "mr-1":
                                                                _vm.positionAppEnablers,
                                                            },
                                                            {
                                                              "primary--text":
                                                                _vm.priceGuardModel,
                                                            },
                                                          ],
                                                          attrs: {
                                                            justify:
                                                              _vm.positionAppEnablers
                                                                ? "start"
                                                                : "center",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              staticClass:
                                                                "mr-2",
                                                              class: {
                                                                "primary--text":
                                                                  _vm.priceGuardModel,
                                                              },
                                                              staticStyle: {
                                                                "font-size":
                                                                  "17px",
                                                                height: "17px",
                                                                "margin-top":
                                                                  "3px",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "icon-price-guard-21x25 "
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(
                                                            " Price Guard "
                                                          ),
                                                          _c("v-switch", {
                                                            staticClass:
                                                              "always-primary-checkbox alert-card-switch mt-0 pt-0 ml-2",
                                                            staticStyle: {
                                                              width: "40px",
                                                              height: "20px",
                                                            },
                                                            attrs: {
                                                              small: "",
                                                              "hide-details":
                                                                "",
                                                              color: "primary",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.priceGuardModel,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.priceGuardModel =
                                                                    $$v
                                                                },
                                                              expression:
                                                                "priceGuardModel",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm.selectedApplicationType ===
                                        _vm.applicationTypeEnums.pricewatcher &&
                                      _vm.add
                                    ? _c("div", [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "pl-2 pb-4 primary--text",
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                staticClass: "mr-2 mb-1",
                                                staticStyle: {
                                                  "font-size": "17px",
                                                  height: "17px",
                                                  "margin-top": "2px",
                                                },
                                                attrs: { color: "primary" },
                                              },
                                              [_vm._v("fas fa-chart-line ")]
                                            ),
                                            _vm._v(
                                              " Price Watcher Configurations "
                                            ),
                                          ],
                                          1
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm.selectedApplicationType ===
                                  _vm.applicationTypeEnums.general
                                    ? _c(
                                        "v-tabs",
                                        {
                                          staticClass: "accent mt-2",
                                          attrs: {
                                            "slider-color": "accent",
                                            "background-color": "accent",
                                            centered: "",
                                            "hide-slider": "",
                                            "active-class":
                                              "selectedTab-configs",
                                            "slider-size": "height:36",
                                          },
                                          model: {
                                            value: _vm.tab,
                                            callback: function ($$v) {
                                              _vm.tab = $$v
                                            },
                                            expression: "tab",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-tab",
                                            {
                                              staticClass: "accent",
                                              staticStyle: {
                                                height: "36px !important",
                                              },
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "mr-2",
                                                  staticStyle: {
                                                    "font-size": "17px",
                                                    height: "17px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "icon-analytics-23x23 "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" Analytics "),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-tab",
                                            {
                                              staticClass: "accent",
                                              staticStyle: {
                                                height: "36px !important",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.PGTabClicked(
                                                    _vm.currentDefinition.id
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "mr-2",
                                                  staticStyle: {
                                                    "font-size": "17px",
                                                    height: "17px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "icon-price-guard-21x25 "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" Price Guard "),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-tab",
                                            {
                                              staticClass: "accent",
                                              staticStyle: {
                                                height: "36px !important",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.PWTabClicked(
                                                    _vm.currentDefinition.id
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "mr-2",
                                                  staticStyle: {
                                                    "font-size": "17px",
                                                    height: "17px",
                                                  },
                                                },
                                                [_vm._v("fas fa-chart-line ")]
                                              ),
                                              _vm._v(" Price Watcher "),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-tabs-items",
                                            {
                                              staticClass: "accent mt-2",
                                              model: {
                                                value: _vm.tab,
                                                callback: function ($$v) {
                                                  _vm.tab = $$v
                                                },
                                                expression: "tab",
                                              },
                                            },
                                            [
                                              _c(
                                                "v-tab-item",
                                                { staticClass: "pt-2" },
                                                [
                                                  _c(
                                                    "v-row",
                                                    [
                                                      _c(
                                                        "v-col",
                                                        {
                                                          staticClass: "py-0",
                                                          attrs: {
                                                            cols: "12",
                                                            sm: "6",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-tooltip",
                                                            {
                                                              attrs: {
                                                                disabled:
                                                                  _vm.isNotDesktop,
                                                                "content-class":
                                                                  "tooltipClass",
                                                                bottom: "",
                                                              },
                                                              scopedSlots:
                                                                _vm._u(
                                                                  [
                                                                    {
                                                                      key: "activator",
                                                                      fn: function ({
                                                                        on,
                                                                      }) {
                                                                        return [
                                                                          _c(
                                                                            "v-text-field",
                                                                            _vm._g(
                                                                              {
                                                                                staticClass:
                                                                                  "analyticsTextFieldClass",
                                                                                attrs:
                                                                                  {
                                                                                    disabled:
                                                                                      !_vm.analyticsModel,
                                                                                    dense:
                                                                                      "",
                                                                                    outlined:
                                                                                      "",
                                                                                    label:
                                                                                      "Symbol Split Pattern",
                                                                                  },
                                                                                model:
                                                                                  {
                                                                                    value:
                                                                                      _vm
                                                                                        .currentDefinition
                                                                                        .configuration
                                                                                        .Analytics
                                                                                        .SymbolSplitPattern,
                                                                                    callback:
                                                                                      function (
                                                                                        $$v
                                                                                      ) {
                                                                                        _vm.$set(
                                                                                          _vm
                                                                                            .currentDefinition
                                                                                            .configuration
                                                                                            .Analytics,
                                                                                          "SymbolSplitPattern",
                                                                                          $$v
                                                                                        )
                                                                                      },
                                                                                    expression:
                                                                                      "\n                                  currentDefinition.configuration.Analytics\n                                    .SymbolSplitPattern\n                                ",
                                                                                  },
                                                                              },
                                                                              on
                                                                            )
                                                                          ),
                                                                        ]
                                                                      },
                                                                    },
                                                                  ],
                                                                  null,
                                                                  false,
                                                                  3024623535
                                                                ),
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  " The regular expression which will use to extract core symbol "
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-col",
                                                        {
                                                          staticClass: "py-0",
                                                          attrs: {
                                                            cols: "12",
                                                            sm: "6",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-tooltip",
                                                            {
                                                              attrs: {
                                                                disabled:
                                                                  _vm.isNotDesktop,
                                                                "content-class":
                                                                  "tooltipClass",
                                                                bottom: "",
                                                              },
                                                              scopedSlots:
                                                                _vm._u(
                                                                  [
                                                                    {
                                                                      key: "activator",
                                                                      fn: function ({
                                                                        on,
                                                                      }) {
                                                                        return [
                                                                          _c(
                                                                            "v-text-field",
                                                                            _vm._g(
                                                                              {
                                                                                staticClass:
                                                                                  "analyticsTextFieldClass",
                                                                                attrs:
                                                                                  {
                                                                                    disabled:
                                                                                      !_vm.analyticsModel,
                                                                                    dense:
                                                                                      "",
                                                                                    outlined:
                                                                                      "",
                                                                                    label:
                                                                                      "Calculation Currency",
                                                                                    rules:
                                                                                      !_vm.analyticsModel
                                                                                        ? []
                                                                                        : [
                                                                                            _vm
                                                                                              .rules
                                                                                              .required,
                                                                                          ],
                                                                                  },
                                                                                model:
                                                                                  {
                                                                                    value:
                                                                                      _vm
                                                                                        .currentDefinition
                                                                                        .configuration
                                                                                        .Analytics
                                                                                        .CalculationCurrency,
                                                                                    callback:
                                                                                      function (
                                                                                        $$v
                                                                                      ) {
                                                                                        _vm.$set(
                                                                                          _vm
                                                                                            .currentDefinition
                                                                                            .configuration
                                                                                            .Analytics,
                                                                                          "CalculationCurrency",
                                                                                          $$v
                                                                                        )
                                                                                      },
                                                                                    expression:
                                                                                      "\n                                  currentDefinition.configuration.Analytics\n                                    .CalculationCurrency\n                                ",
                                                                                  },
                                                                              },
                                                                              on
                                                                            )
                                                                          ),
                                                                        ]
                                                                      },
                                                                    },
                                                                  ],
                                                                  null,
                                                                  false,
                                                                  3708696739
                                                                ),
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  "The name of the currency to use for calculations"
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-row",
                                                    [
                                                      _c(
                                                        "v-col",
                                                        {
                                                          staticClass: "py-0",
                                                          attrs: {
                                                            cols: "12",
                                                            sm: "6",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-tooltip",
                                                            {
                                                              attrs: {
                                                                disabled:
                                                                  _vm.isNotDesktop,
                                                                "content-class":
                                                                  "tooltipClass",
                                                                bottom: "",
                                                              },
                                                              scopedSlots:
                                                                _vm._u(
                                                                  [
                                                                    {
                                                                      key: "activator",
                                                                      fn: function ({
                                                                        on,
                                                                      }) {
                                                                        return [
                                                                          _c(
                                                                            "v-text-field",
                                                                            _vm._g(
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    disabled:
                                                                                      !_vm.analyticsModel,
                                                                                    dense:
                                                                                      "",
                                                                                    outlined:
                                                                                      "",
                                                                                    label:
                                                                                      "Group Mask",
                                                                                    rules:
                                                                                      !_vm.analyticsModel
                                                                                        ? []
                                                                                        : [
                                                                                            _vm
                                                                                              .rules
                                                                                              .required,
                                                                                          ],
                                                                                  },
                                                                                model:
                                                                                  {
                                                                                    value:
                                                                                      _vm
                                                                                        .currentDefinition
                                                                                        .configuration
                                                                                        .Analytics
                                                                                        .GroupMask,
                                                                                    callback:
                                                                                      function (
                                                                                        $$v
                                                                                      ) {
                                                                                        _vm.$set(
                                                                                          _vm
                                                                                            .currentDefinition
                                                                                            .configuration
                                                                                            .Analytics,
                                                                                          "GroupMask",
                                                                                          $$v
                                                                                        )
                                                                                      },
                                                                                    expression:
                                                                                      "\n                                  currentDefinition.configuration.Analytics\n                                    .GroupMask\n                                ",
                                                                                  },
                                                                              },
                                                                              on
                                                                            )
                                                                          ),
                                                                        ]
                                                                      },
                                                                    },
                                                                  ],
                                                                  null,
                                                                  false,
                                                                  38679236
                                                                ),
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  ' A string e.g. "*,!demo" '
                                                                ),
                                                                _c("br"),
                                                                _vm._v(
                                                                  "Used to include or exclude records "
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-col",
                                                        { staticClass: "py-0" },
                                                        [
                                                          _vm.isAdmin
                                                            ? _c(
                                                                "v-tooltip",
                                                                {
                                                                  staticClass:
                                                                    "mt-3 ml-1",
                                                                  attrs: {
                                                                    disabled:
                                                                      _vm.isNotDesktop,
                                                                    "content-class":
                                                                      "tooltipClassBig",
                                                                    bottom: "",
                                                                  },
                                                                  scopedSlots:
                                                                    _vm._u(
                                                                      [
                                                                        {
                                                                          key: "activator",
                                                                          fn: function ({
                                                                            on,
                                                                          }) {
                                                                            return [
                                                                              _c(
                                                                                "v-text-field",
                                                                                _vm._g(
                                                                                  {
                                                                                    staticClass:
                                                                                      "analyticsTextFieldClass",
                                                                                    attrs:
                                                                                      {
                                                                                        disabled:
                                                                                          !_vm.analyticsModel,
                                                                                        dense:
                                                                                          "",
                                                                                        outlined:
                                                                                          "",
                                                                                        label:
                                                                                          "Execution Period Time",
                                                                                        type: "number",
                                                                                        rules:
                                                                                          [
                                                                                            _vm
                                                                                              .rules
                                                                                              .required,
                                                                                          ],
                                                                                      },
                                                                                    on: {
                                                                                      keydown:
                                                                                        (
                                                                                          ev
                                                                                        ) =>
                                                                                          _vm.setHelperVar(
                                                                                            ev,
                                                                                            "ExecutionPeriodTimeAN"
                                                                                          ),
                                                                                      keypress:
                                                                                        (
                                                                                          ev
                                                                                        ) =>
                                                                                          _vm.setHelperVar(
                                                                                            ev,
                                                                                            "ExecutionPeriodTimeAN"
                                                                                          ),
                                                                                      input:
                                                                                        (
                                                                                          ev
                                                                                        ) =>
                                                                                          _vm.textInput(
                                                                                            ev,
                                                                                            _vm
                                                                                              .currentDefinition
                                                                                              .configuration,
                                                                                            "ExecutionPeriodTime"
                                                                                          ),
                                                                                      focusout:
                                                                                        _vm.clearHelperVar,
                                                                                    },
                                                                                    model:
                                                                                      {
                                                                                        value:
                                                                                          _vm.ExecutionPeriodTimeAN,
                                                                                        callback:
                                                                                          function (
                                                                                            $$v
                                                                                          ) {
                                                                                            _vm.ExecutionPeriodTimeAN =
                                                                                              _vm._n(
                                                                                                $$v
                                                                                              )
                                                                                          },
                                                                                        expression:
                                                                                          "ExecutionPeriodTimeAN",
                                                                                      },
                                                                                  },
                                                                                  on
                                                                                )
                                                                              ),
                                                                            ]
                                                                          },
                                                                        },
                                                                      ],
                                                                      null,
                                                                      false,
                                                                      1571124572
                                                                    ),
                                                                },
                                                                [
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      " The period of time where the application is running in order to produce "
                                                                    ),
                                                                    _c("br"),
                                                                    _vm._v(
                                                                      "all the grids (summary positions, summary exposures), if we set "
                                                                    ),
                                                                    _c("br"),
                                                                    _vm._v(
                                                                      "ExecutionPeriodTime = 5s means that the application will run every 5 seconds repeatedly "
                                                                    ),
                                                                  ]),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-row",
                                                    [
                                                      _c(
                                                        "v-col",
                                                        {
                                                          staticClass: "py-0",
                                                          attrs: {
                                                            cols: "12",
                                                            sm: "6",
                                                          },
                                                        },
                                                        [
                                                          _vm.isAdmin
                                                            ? _c(
                                                                "v-tooltip",
                                                                {
                                                                  attrs: {
                                                                    disabled:
                                                                      _vm.isNotDesktop,
                                                                    "content-class":
                                                                      "tooltipClassBig",
                                                                    bottom: "",
                                                                  },
                                                                  scopedSlots:
                                                                    _vm._u(
                                                                      [
                                                                        {
                                                                          key: "activator",
                                                                          fn: function ({
                                                                            on,
                                                                          }) {
                                                                            return [
                                                                              _c(
                                                                                "div",
                                                                                _vm._g(
                                                                                  {},
                                                                                  on
                                                                                ),
                                                                                [
                                                                                  _c(
                                                                                    "v-select",
                                                                                    _vm._g(
                                                                                      {
                                                                                        attrs:
                                                                                          {
                                                                                            disabled:
                                                                                              !_vm.analyticsModel,
                                                                                            outlined:
                                                                                              "",
                                                                                            dense:
                                                                                              "",
                                                                                            "menu-props":
                                                                                              {
                                                                                                offsetY: true,
                                                                                              },
                                                                                            "item-text":
                                                                                              "text",
                                                                                            label:
                                                                                              "Minify Messages",
                                                                                            items:
                                                                                              [
                                                                                                {
                                                                                                  value: true,
                                                                                                  text: "Yes",
                                                                                                },
                                                                                                {
                                                                                                  value: false,
                                                                                                  text: "No",
                                                                                                },
                                                                                              ],
                                                                                          },
                                                                                        scopedSlots:
                                                                                          _vm._u(
                                                                                            [
                                                                                              {
                                                                                                key: "item",
                                                                                                fn: function ({
                                                                                                  item,
                                                                                                }) {
                                                                                                  return [
                                                                                                    _c(
                                                                                                      "p",
                                                                                                      {
                                                                                                        staticClass:
                                                                                                          "mb-0",
                                                                                                      },
                                                                                                      [
                                                                                                        _vm._v(
                                                                                                          _vm._s(
                                                                                                            item.text
                                                                                                          )
                                                                                                        ),
                                                                                                      ]
                                                                                                    ),
                                                                                                  ]
                                                                                                },
                                                                                              },
                                                                                            ],
                                                                                            null,
                                                                                            true
                                                                                          ),
                                                                                        model:
                                                                                          {
                                                                                            value:
                                                                                              _vm.MinifyANMessages,
                                                                                            callback:
                                                                                              function (
                                                                                                $$v
                                                                                              ) {
                                                                                                _vm.MinifyANMessages =
                                                                                                  $$v
                                                                                              },
                                                                                            expression:
                                                                                              "MinifyANMessages",
                                                                                          },
                                                                                      },
                                                                                      on
                                                                                    )
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              ),
                                                                            ]
                                                                          },
                                                                        },
                                                                      ],
                                                                      null,
                                                                      false,
                                                                      4194927818
                                                                    ),
                                                                },
                                                                [
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      " Determines if publisher analytics messages will be zipped by the agent "
                                                                    ),
                                                                  ]),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-col",
                                                        {
                                                          staticClass: "py-0",
                                                          attrs: {
                                                            cols: "12",
                                                            sm: "6",
                                                          },
                                                        },
                                                        [
                                                          _vm.isAdmin
                                                            ? _c(
                                                                "v-tooltip",
                                                                {
                                                                  attrs: {
                                                                    disabled:
                                                                      _vm.isNotDesktop,
                                                                    "content-class":
                                                                      "tooltipClassBig",
                                                                    bottom: "",
                                                                  },
                                                                  scopedSlots:
                                                                    _vm._u(
                                                                      [
                                                                        {
                                                                          key: "activator",
                                                                          fn: function ({
                                                                            on,
                                                                          }) {
                                                                            return [
                                                                              _c(
                                                                                "div",
                                                                                _vm._g(
                                                                                  {},
                                                                                  on
                                                                                ),
                                                                                [
                                                                                  _c(
                                                                                    "InputWrapper",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          label:
                                                                                            "Enable Recovery Mode",
                                                                                          "container-class":
                                                                                            "ma-0",
                                                                                          "label-background":
                                                                                            "rgb(21, 21, 26)",
                                                                                          dense:
                                                                                            "",
                                                                                        },
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "v-switch",
                                                                                        _vm._g(
                                                                                          {
                                                                                            attrs:
                                                                                              {
                                                                                                disabled:
                                                                                                  !_vm.analyticsModel,
                                                                                                label:
                                                                                                  _vm
                                                                                                    .currentDefinition
                                                                                                    .configuration
                                                                                                    .EnableRecoveryMode ===
                                                                                                  true
                                                                                                    ? "Yes"
                                                                                                    : "No",
                                                                                                outlined:
                                                                                                  "",
                                                                                                dense:
                                                                                                  "",
                                                                                                "hide-details":
                                                                                                  "",
                                                                                              },
                                                                                            model:
                                                                                              {
                                                                                                value:
                                                                                                  _vm
                                                                                                    .currentDefinition
                                                                                                    .configuration
                                                                                                    .EnableRecoveryMode,
                                                                                                callback:
                                                                                                  function (
                                                                                                    $$v
                                                                                                  ) {
                                                                                                    _vm.$set(
                                                                                                      _vm
                                                                                                        .currentDefinition
                                                                                                        .configuration,
                                                                                                      "EnableRecoveryMode",
                                                                                                      $$v
                                                                                                    )
                                                                                                  },
                                                                                                expression:
                                                                                                  "currentDefinition.configuration.EnableRecoveryMode",
                                                                                              },
                                                                                          },
                                                                                          on
                                                                                        )
                                                                                      ),
                                                                                    ],
                                                                                    1
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              ),
                                                                            ]
                                                                          },
                                                                        },
                                                                      ],
                                                                      null,
                                                                      false,
                                                                      1244818609
                                                                    ),
                                                                },
                                                                [
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      " Enable recovery mode "
                                                                    ),
                                                                  ]),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-row",
                                                    [
                                                      _c(
                                                        "v-col",
                                                        {
                                                          staticClass:
                                                            "pb-2 pt-0",
                                                          attrs: {
                                                            cols: "12",
                                                            sm: "6",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-tooltip",
                                                            {
                                                              attrs: {
                                                                disabled:
                                                                  !_vm.analyticsModel ||
                                                                  _vm.isNotDesktop,
                                                                "content-class":
                                                                  "tooltipClass",
                                                                bottom: "",
                                                              },
                                                              scopedSlots:
                                                                _vm._u(
                                                                  [
                                                                    {
                                                                      key: "activator",
                                                                      fn: function ({
                                                                        on,
                                                                      }) {
                                                                        return [
                                                                          _c(
                                                                            "div",
                                                                            _vm._g(
                                                                              {},
                                                                              on
                                                                            ),
                                                                            [
                                                                              _c(
                                                                                "v-select",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      dense:
                                                                                        "",
                                                                                      "menu-props":
                                                                                        {
                                                                                          offsetY: true,
                                                                                          maxHeight:
                                                                                            "250",
                                                                                        },
                                                                                      disabled:
                                                                                        !_vm
                                                                                          .currentDefinition
                                                                                          .configuration
                                                                                          .Analytics
                                                                                          .ExecutionMappings
                                                                                          .length ||
                                                                                        !_vm.analyticsModel,
                                                                                      "return-object":
                                                                                        "",
                                                                                      label:
                                                                                        _vm
                                                                                          .currentDefinition
                                                                                          .configuration
                                                                                          .Analytics
                                                                                          .ExecutionMappings
                                                                                          .length
                                                                                          ? `Select an execution mapping: ${_vm.currentDefinition.configuration.Analytics.ExecutionMappings.length}`
                                                                                          : "No execution mappings yet",
                                                                                      items:
                                                                                        _vm
                                                                                          .currentDefinition
                                                                                          .configuration
                                                                                          .Analytics
                                                                                          .ExecutionMappings,
                                                                                      "item-text":
                                                                                        "Name",
                                                                                      "item-value":
                                                                                        "Id",
                                                                                    },
                                                                                  scopedSlots:
                                                                                    _vm._u(
                                                                                      [
                                                                                        {
                                                                                          key: "item",
                                                                                          fn: function ({
                                                                                            item,
                                                                                          }) {
                                                                                            return [
                                                                                              _c(
                                                                                                "p",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "mb-0",
                                                                                                },
                                                                                                [
                                                                                                  _vm._v(
                                                                                                    _vm._s(
                                                                                                      item.Name
                                                                                                    )
                                                                                                  ),
                                                                                                ]
                                                                                              ),
                                                                                            ]
                                                                                          },
                                                                                        },
                                                                                      ],
                                                                                      null,
                                                                                      true
                                                                                    ),
                                                                                  model:
                                                                                    {
                                                                                      value:
                                                                                        _vm.selectedExecutionMapping,
                                                                                      callback:
                                                                                        function (
                                                                                          $$v
                                                                                        ) {
                                                                                          _vm.selectedExecutionMapping =
                                                                                            $$v
                                                                                        },
                                                                                      expression:
                                                                                        "selectedExecutionMapping",
                                                                                    },
                                                                                }
                                                                              ),
                                                                            ],
                                                                            1
                                                                          ),
                                                                        ]
                                                                      },
                                                                    },
                                                                  ],
                                                                  null,
                                                                  false,
                                                                  689301422
                                                                ),
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  " A list of execution mappings which will match trades "
                                                                ),
                                                                _c("br"),
                                                                _vm._v(
                                                                  "into specific profiles (e.g. A-Book, B-Book) "
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-col",
                                                        {
                                                          staticClass:
                                                            "pb-2 pt-0",
                                                          attrs: {
                                                            cols: "12",
                                                            sm: "6",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-btn",
                                                            {
                                                              staticClass:
                                                                "px-1 mt-1",
                                                              attrs: {
                                                                disabled:
                                                                  !_vm.analyticsModel,
                                                                outlined: "",
                                                                color:
                                                                  "primary",
                                                                small: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.addExecutionMapping(
                                                                      _vm
                                                                        .currentDefinition
                                                                        .configuration
                                                                        .Analytics
                                                                        .ExecutionMappings
                                                                        .length
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  staticClass:
                                                                    "mr-2",
                                                                  staticStyle: {
                                                                    "font-size":
                                                                      "16px",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "fas fa-plus-circle "
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                " Add Mapping "
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _vm.selectedExecutionMapping !=
                                                  null
                                                    ? _c(
                                                        "div",
                                                        [
                                                          _c(
                                                            "v-card",
                                                            {
                                                              staticClass:
                                                                "mb-3 exec-mapping",
                                                              class: {
                                                                opacity0:
                                                                  _vm.addNewMapping,
                                                                opacity1sec:
                                                                  !_vm.addNewMapping,
                                                                "disabled-item":
                                                                  !_vm.analyticsModel,
                                                              },
                                                              attrs: {
                                                                flat: "",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-row",
                                                                {
                                                                  attrs: {
                                                                    "justify-sm":
                                                                      "space-between",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-col",
                                                                    {
                                                                      class: _vm
                                                                        .$vuetify
                                                                        .breakpoint
                                                                        .smAndUp
                                                                        ? "ml-5"
                                                                        : "text-center",
                                                                      attrs: {
                                                                        cols: "11",
                                                                        sm: "5",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "p",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              "font-size":
                                                                                "20px !important",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                _vm
                                                                                  .selectedExecutionMapping
                                                                                  .Name
                                                                              ) +
                                                                              " "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "v-spacer"
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                              _c(
                                                                "v-row",
                                                                {
                                                                  attrs: {
                                                                    justify:
                                                                      "center",
                                                                    "justify-sm":
                                                                      "space-between",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-col",
                                                                    {
                                                                      class: _vm
                                                                        .$vuetify
                                                                        .breakpoint
                                                                        .smAndUp
                                                                        ? "py-0 ml-5"
                                                                        : "py-0",
                                                                      attrs: {
                                                                        cols: "11",
                                                                        sm: "5",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-text-field",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              dense:
                                                                                "",
                                                                              outlined:
                                                                                "",
                                                                              placeholder:
                                                                                "ID",
                                                                              label:
                                                                                "ID",
                                                                              disabled:
                                                                                "",
                                                                            },
                                                                          model:
                                                                            {
                                                                              value:
                                                                                _vm
                                                                                  .selectedExecutionMapping
                                                                                  .Id,
                                                                              callback:
                                                                                function (
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    _vm.selectedExecutionMapping,
                                                                                    "Id",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                              expression:
                                                                                "selectedExecutionMapping.Id",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _c(
                                                                    "v-col",
                                                                    {
                                                                      class: _vm
                                                                        .$vuetify
                                                                        .breakpoint
                                                                        .smAndUp
                                                                        ? "py-0 mr-5"
                                                                        : "py-0",
                                                                      attrs: {
                                                                        cols: "11",
                                                                        sm: "5",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-text-field",
                                                                        {
                                                                          staticClass:
                                                                            "analyticsTextFieldClass",
                                                                          attrs:
                                                                            {
                                                                              disabled:
                                                                                !_vm.analyticsModel,
                                                                              dense:
                                                                                "",
                                                                              outlined:
                                                                                "",
                                                                              placeholder:
                                                                                "Name",
                                                                              label:
                                                                                "Name",
                                                                              rules:
                                                                                [
                                                                                  _vm
                                                                                    .rules
                                                                                    .required,
                                                                                ],
                                                                            },
                                                                          model:
                                                                            {
                                                                              value:
                                                                                _vm
                                                                                  .selectedExecutionMapping
                                                                                  .Name,
                                                                              callback:
                                                                                function (
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    _vm.selectedExecutionMapping,
                                                                                    "Name",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                              expression:
                                                                                "selectedExecutionMapping.Name",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                              _c(
                                                                "v-row",
                                                                {
                                                                  attrs: {
                                                                    justify:
                                                                      "center",
                                                                    "justify-sm":
                                                                      "space-between",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-col",
                                                                    {
                                                                      class: _vm
                                                                        .$vuetify
                                                                        .breakpoint
                                                                        .smAndUp
                                                                        ? "py-0 ml-5"
                                                                        : "py-0",
                                                                      attrs: {
                                                                        cols: "11",
                                                                        sm: "5",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-text-field",
                                                                        {
                                                                          staticClass:
                                                                            "analyticsTextFieldClass",
                                                                          attrs:
                                                                            {
                                                                              disabled:
                                                                                !_vm.analyticsModel,
                                                                              dense:
                                                                                "",
                                                                              outlined:
                                                                                "",
                                                                              placeholder:
                                                                                "Pattern",
                                                                              label:
                                                                                "Symbol Pattern",
                                                                            },
                                                                          model:
                                                                            {
                                                                              value:
                                                                                _vm
                                                                                  .selectedExecutionMapping
                                                                                  .SymbolPattern,
                                                                              callback:
                                                                                function (
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    _vm.selectedExecutionMapping,
                                                                                    "SymbolPattern",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                              expression:
                                                                                "\n                                  selectedExecutionMapping.SymbolPattern\n                                ",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _c(
                                                                    "v-col",
                                                                    {
                                                                      class: _vm
                                                                        .$vuetify
                                                                        .breakpoint
                                                                        .smAndUp
                                                                        ? "py-0 mr-5"
                                                                        : "py-0",
                                                                      attrs: {
                                                                        cols: "11",
                                                                        sm: "5",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-text-field",
                                                                        {
                                                                          staticClass:
                                                                            "analyticsTextFieldClass",
                                                                          attrs:
                                                                            {
                                                                              disabled:
                                                                                !_vm.analyticsModel,
                                                                              dense:
                                                                                "",
                                                                              outlined:
                                                                                "",
                                                                              placeholder:
                                                                                "0",
                                                                              label:
                                                                                "Logins (e.g 3,4)",
                                                                            },
                                                                          model:
                                                                            {
                                                                              value:
                                                                                _vm
                                                                                  .selectedExecutionMapping
                                                                                  .Logins,
                                                                              callback:
                                                                                function (
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    _vm.selectedExecutionMapping,
                                                                                    "Logins",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                              expression:
                                                                                "selectedExecutionMapping.Logins",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                              _c(
                                                                "v-row",
                                                                {
                                                                  attrs: {
                                                                    justify:
                                                                      "center",
                                                                    "justify-sm":
                                                                      "space-between",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-col",
                                                                    {
                                                                      class: _vm
                                                                        .$vuetify
                                                                        .breakpoint
                                                                        .smAndUp
                                                                        ? "py-0 ml-5"
                                                                        : "py-0",
                                                                      attrs: {
                                                                        cols: "11",
                                                                        sm: "5",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-text-field",
                                                                        {
                                                                          staticClass:
                                                                            "analyticsTextFieldClass",
                                                                          attrs:
                                                                            {
                                                                              disabled:
                                                                                !_vm.analyticsModel,
                                                                              dense:
                                                                                "",
                                                                              outlined:
                                                                                "",
                                                                              placeholder:
                                                                                "pattern",
                                                                              label:
                                                                                "Group Pattern",
                                                                            },
                                                                          model:
                                                                            {
                                                                              value:
                                                                                _vm
                                                                                  .selectedExecutionMapping
                                                                                  .GroupPattern,
                                                                              callback:
                                                                                function (
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    _vm.selectedExecutionMapping,
                                                                                    "GroupPattern",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                              expression:
                                                                                "\n                                  selectedExecutionMapping.GroupPattern\n                                ",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _c(
                                                                    "v-col",
                                                                    {
                                                                      class: _vm
                                                                        .$vuetify
                                                                        .breakpoint
                                                                        .smAndUp
                                                                        ? "py-0 mr-5"
                                                                        : "py-0",
                                                                      attrs: {
                                                                        cols: "11",
                                                                        sm: "5",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-text-field",
                                                                        {
                                                                          staticClass:
                                                                            "analyticsTextFieldClass",
                                                                          attrs:
                                                                            {
                                                                              disabled:
                                                                                !_vm.analyticsModel,
                                                                              dense:
                                                                                "",
                                                                              outlined:
                                                                                "",
                                                                              placeholder:
                                                                                "mapping ID",
                                                                              type: "number",
                                                                              label:
                                                                                "Split Execution Mapping ID",
                                                                              rules:
                                                                                [
                                                                                  _vm
                                                                                    .rules
                                                                                    .required,
                                                                                ],
                                                                            },
                                                                          model:
                                                                            {
                                                                              value:
                                                                                _vm
                                                                                  .selectedExecutionMapping
                                                                                  .SplitExecutionMappingId,
                                                                              callback:
                                                                                function (
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    _vm.selectedExecutionMapping,
                                                                                    "SplitExecutionMappingId",
                                                                                    _vm._n(
                                                                                      $$v
                                                                                    )
                                                                                  )
                                                                                },
                                                                              expression:
                                                                                "\n                                  selectedExecutionMapping.SplitExecutionMappingId\n                                ",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                              _c(
                                                                "v-row",
                                                                {
                                                                  attrs: {
                                                                    justify:
                                                                      "center",
                                                                    "justify-sm":
                                                                      "space-between",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-col",
                                                                    {
                                                                      class: _vm
                                                                        .$vuetify
                                                                        .breakpoint
                                                                        .smAndUp
                                                                        ? "py-0 ml-5"
                                                                        : "py-0",
                                                                      attrs: {
                                                                        cols: "11",
                                                                        sm: "5",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-text-field",
                                                                        {
                                                                          staticClass:
                                                                            "analyticsTextFieldClass",
                                                                          attrs:
                                                                            {
                                                                              disabled:
                                                                                !_vm.analyticsModel,
                                                                              dense:
                                                                                "",
                                                                              outlined:
                                                                                "",
                                                                              placeholder:
                                                                                "0",
                                                                              type: "number",
                                                                              label:
                                                                                "Percentage (e.g 100)",
                                                                              rules:
                                                                                [
                                                                                  _vm
                                                                                    .rules
                                                                                    .required,
                                                                                ],
                                                                            },
                                                                          model:
                                                                            {
                                                                              value:
                                                                                _vm
                                                                                  .selectedExecutionMapping
                                                                                  .Percentage,
                                                                              callback:
                                                                                function (
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    _vm.selectedExecutionMapping,
                                                                                    "Percentage",
                                                                                    _vm._n(
                                                                                      $$v
                                                                                    )
                                                                                  )
                                                                                },
                                                                              expression:
                                                                                "\n                                  selectedExecutionMapping.Percentage\n                                ",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _c(
                                                                    "v-col",
                                                                    {
                                                                      staticClass:
                                                                        "mb-2",
                                                                      class: _vm
                                                                        .$vuetify
                                                                        .breakpoint
                                                                        .smAndUp
                                                                        ? "py-0"
                                                                        : "py-0",
                                                                      attrs: {
                                                                        "align-self":
                                                                          "end",
                                                                        cols: "11",
                                                                        sm: "2",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-btn",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              disabled:
                                                                                !_vm.analyticsModel,
                                                                              text: "",
                                                                              color:
                                                                                "#ff1919",
                                                                            },
                                                                          on: {
                                                                            click:
                                                                              _vm.deleteMapping,
                                                                          },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "Delete "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-tab-item",
                                                {
                                                  staticClass: "pt-2",
                                                  staticStyle: {
                                                    "min-height": "85px",
                                                  },
                                                },
                                                [
                                                  _vm.add
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            width: "100%",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-row",
                                                            {
                                                              attrs: {
                                                                justify:
                                                                  "center",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "10",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "p",
                                                                    {
                                                                      staticClass:
                                                                        "mt-7 grey--text text-center",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " Price Guard can be configured once created "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  !_vm.add
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            width: "100%",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-row",
                                                            [
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  staticClass:
                                                                    "py-0",
                                                                  attrs: {
                                                                    cols: "12",
                                                                    sm: "6",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-tooltip",
                                                                    {
                                                                      attrs: {
                                                                        disabled:
                                                                          !_vm.priceGuardModel ||
                                                                          _vm.isNotDesktop,
                                                                        "content-class":
                                                                          "tooltipClassBig",
                                                                        bottom:
                                                                          "",
                                                                      },
                                                                      scopedSlots:
                                                                        _vm._u(
                                                                          [
                                                                            {
                                                                              key: "activator",
                                                                              fn: function ({
                                                                                on,
                                                                              }) {
                                                                                return [
                                                                                  _c(
                                                                                    "div",
                                                                                    _vm._g(
                                                                                      {},
                                                                                      on
                                                                                    ),
                                                                                    [
                                                                                      _c(
                                                                                        "v-text-field",
                                                                                        {
                                                                                          staticClass:
                                                                                            "analyticsTextFieldClass",
                                                                                          attrs:
                                                                                            {
                                                                                              disabled:
                                                                                                !_vm.priceGuardModel,
                                                                                              dense:
                                                                                                "",
                                                                                              outlined:
                                                                                                "",
                                                                                              label:
                                                                                                "Cycle Time",
                                                                                              type: "number",
                                                                                              rules:
                                                                                                [
                                                                                                  _vm
                                                                                                    .rules
                                                                                                    .required,
                                                                                                ],
                                                                                            },
                                                                                          on: {
                                                                                            keydown:
                                                                                              (
                                                                                                ev
                                                                                              ) =>
                                                                                                _vm.setHelperVar(
                                                                                                  ev,
                                                                                                  "CycleTime"
                                                                                                ),
                                                                                            keypress:
                                                                                              (
                                                                                                ev
                                                                                              ) =>
                                                                                                _vm.setHelperVar(
                                                                                                  ev,
                                                                                                  "CycleTime"
                                                                                                ),
                                                                                            input:
                                                                                              (
                                                                                                ev
                                                                                              ) =>
                                                                                                _vm.textInput(
                                                                                                  ev,
                                                                                                  _vm
                                                                                                    .currentDefinition
                                                                                                    .configuration,
                                                                                                  "CycleTime"
                                                                                                ),
                                                                                            focusout:
                                                                                              _vm.clearHelperVar,
                                                                                          },
                                                                                          model:
                                                                                            {
                                                                                              value:
                                                                                                _vm.CycleTime,
                                                                                              callback:
                                                                                                function (
                                                                                                  $$v
                                                                                                ) {
                                                                                                  _vm.CycleTime =
                                                                                                    _vm._n(
                                                                                                      $$v
                                                                                                    )
                                                                                                },
                                                                                              expression:
                                                                                                "CycleTime",
                                                                                            },
                                                                                        }
                                                                                      ),
                                                                                    ],
                                                                                    1
                                                                                  ),
                                                                                ]
                                                                              },
                                                                            },
                                                                          ],
                                                                          null,
                                                                          false,
                                                                          1173734641
                                                                        ),
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            " Time to check for tick updates in milliseconds "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-row",
                                                            {
                                                              attrs: {
                                                                justify:
                                                                  "center",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  staticClass:
                                                                    "pb-0 pt-0 px-3",
                                                                  staticStyle: {
                                                                    "max-height":
                                                                      "95px",
                                                                    "margin-bottom":
                                                                      "-1px",
                                                                  },
                                                                  attrs: {
                                                                    cols: "12",
                                                                    sm: "12",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-text-field",
                                                                    {
                                                                      staticClass:
                                                                        "inputSlot-mb-0",
                                                                      class:
                                                                        _vm.regexSearchPG
                                                                          ? "text-field-top-details"
                                                                          : "hide-error-message",
                                                                      staticStyle:
                                                                        {
                                                                          "z-index":
                                                                            "0",
                                                                        },
                                                                      attrs: {
                                                                        disabled:
                                                                          !_vm.priceGuardModel,
                                                                        value:
                                                                          _vm.searchSymbolPG,
                                                                        outlined:
                                                                          "",
                                                                        placeholder:
                                                                          _vm.regexSearchPG
                                                                            ? "Search with regex"
                                                                            : "Search",
                                                                        "single-line":
                                                                          "",
                                                                        dense:
                                                                          "",
                                                                        rules:
                                                                          _vm.regexSearchPG
                                                                            ? [
                                                                                _vm
                                                                                  .rules
                                                                                  .validRegex,
                                                                              ]
                                                                            : [],
                                                                        "hide-details":
                                                                          !_vm.regexSearchPG,
                                                                      },
                                                                      scopedSlots:
                                                                        _vm._u(
                                                                          [
                                                                            {
                                                                              key: "append",
                                                                              fn: function () {
                                                                                return [
                                                                                  _c(
                                                                                    "v-row",
                                                                                    {
                                                                                      staticClass:
                                                                                        "mx-0",
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "p",
                                                                                        {
                                                                                          staticClass:
                                                                                            "mb-0 mx-2 pt-1 grey--text subtitle-2",
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            " (" +
                                                                                              _vm._s(
                                                                                                _vm.currentPGSymbols
                                                                                              ) +
                                                                                              ") "
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                      _c(
                                                                                        "v-btn",
                                                                                        {
                                                                                          staticClass:
                                                                                            "mb-2",
                                                                                          attrs:
                                                                                            {
                                                                                              icon: "",
                                                                                              small:
                                                                                                "",
                                                                                              color:
                                                                                                _vm.regexSearchPG
                                                                                                  ? "primary"
                                                                                                  : "white",
                                                                                            },
                                                                                          on: {
                                                                                            click:
                                                                                              function (
                                                                                                $event
                                                                                              ) {
                                                                                                _vm.regexSearchPG =
                                                                                                  !_vm.regexSearchPG
                                                                                              },
                                                                                          },
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "div",
                                                                                            {
                                                                                              staticClass:
                                                                                                "absolute",
                                                                                              staticStyle:
                                                                                                {
                                                                                                  left: "12px",
                                                                                                  "font-size":
                                                                                                    "17px",
                                                                                                },
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                " * "
                                                                                              ),
                                                                                            ]
                                                                                          ),
                                                                                          _c(
                                                                                            "div",
                                                                                            {
                                                                                              staticClass:
                                                                                                "absolute",
                                                                                              staticStyle:
                                                                                                {
                                                                                                  left: "5px",
                                                                                                  "font-size":
                                                                                                    "25px",
                                                                                                  "margin-bottom":
                                                                                                    "2px",
                                                                                                },
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                " . "
                                                                                              ),
                                                                                            ]
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                    ],
                                                                                    1
                                                                                  ),
                                                                                ]
                                                                              },
                                                                              proxy: true,
                                                                            },
                                                                          ],
                                                                          null,
                                                                          false,
                                                                          67601731
                                                                        ),
                                                                      model: {
                                                                        value:
                                                                          _vm.searchSymbolPG,
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.searchSymbolPG =
                                                                              $$v
                                                                          },
                                                                        expression:
                                                                          "searchSymbolPG",
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  staticClass:
                                                                    "pt-0 px-3",
                                                                  attrs: {
                                                                    cols: "12",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-data-table",
                                                                    {
                                                                      ref: "PGSymbolsTable",
                                                                      class: {
                                                                        "disabled-table":
                                                                          !_vm.priceGuardModel,
                                                                      },
                                                                      staticStyle:
                                                                        {
                                                                          height:
                                                                            "238px",
                                                                          "overflow-y":
                                                                            "auto",
                                                                          border:
                                                                            "1px solid #47bd96",
                                                                          "z-index":
                                                                            "1",
                                                                        },
                                                                      attrs: {
                                                                        "mobile-breakpoint": 0,
                                                                        id: "selectSymbolsTable",
                                                                        dense:
                                                                          "",
                                                                        search:
                                                                          _vm.searchSymbolPG,
                                                                        "custom-filter":
                                                                          _vm.symbolSearchFilter,
                                                                        "item-key":
                                                                          "symbol",
                                                                        "hide-default-footer":
                                                                          "",
                                                                        "hide-default-header":
                                                                          "",
                                                                        "items-per-page":
                                                                          -1,
                                                                        items:
                                                                          _vm.loadingInstruments
                                                                            ? []
                                                                            : _vm.allPriceguardSymbols,
                                                                        headers:
                                                                          [
                                                                            {
                                                                              text: "",
                                                                              value:
                                                                                "value",
                                                                            },
                                                                          ],
                                                                        "single-select":
                                                                          "",
                                                                      },
                                                                      on: {
                                                                        "current-items":
                                                                          (
                                                                            items
                                                                          ) =>
                                                                            _vm.setCurrentPGSymbols(
                                                                              items
                                                                            ),
                                                                      },
                                                                      scopedSlots:
                                                                        _vm._u(
                                                                          [
                                                                            {
                                                                              key: "no-data",
                                                                              fn: function () {
                                                                                return [
                                                                                  _c(
                                                                                    "v-row",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          justify:
                                                                                            "center",
                                                                                        },
                                                                                    },
                                                                                    [
                                                                                      _vm.loadingInstruments
                                                                                        ? _c(
                                                                                            "v-col",
                                                                                            {
                                                                                              attrs:
                                                                                                {
                                                                                                  cols: "2",
                                                                                                },
                                                                                            },
                                                                                            [
                                                                                              _c(
                                                                                                "v-row",
                                                                                                {
                                                                                                  attrs:
                                                                                                    {
                                                                                                      justify:
                                                                                                        "end",
                                                                                                    },
                                                                                                },
                                                                                                [
                                                                                                  _c(
                                                                                                    "v-progress-circular",
                                                                                                    {
                                                                                                      staticStyle:
                                                                                                        {
                                                                                                          "margin-top":
                                                                                                            "-4px",
                                                                                                        },
                                                                                                      attrs:
                                                                                                        {
                                                                                                          indeterminate:
                                                                                                            "",
                                                                                                          color:
                                                                                                            "primary",
                                                                                                        },
                                                                                                    }
                                                                                                  ),
                                                                                                ],
                                                                                                1
                                                                                              ),
                                                                                            ],
                                                                                            1
                                                                                          )
                                                                                        : _vm._e(),
                                                                                      _c(
                                                                                        "v-col",
                                                                                        {
                                                                                          attrs:
                                                                                            {
                                                                                              cols: _vm.loadingInstruments
                                                                                                ? 5
                                                                                                : 10,
                                                                                            },
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "p",
                                                                                            {
                                                                                              style:
                                                                                                _vm.loadingInstruments
                                                                                                  ? "text-align: left;"
                                                                                                  : "text-align: center;",
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                " " +
                                                                                                  _vm._s(
                                                                                                    _vm.loadingInstruments
                                                                                                      ? "Loading Instruments..."
                                                                                                      : _vm.serverConnected
                                                                                                      ? "An error has occurred.."
                                                                                                      : "Application is not running"
                                                                                                  ) +
                                                                                                  " "
                                                                                              ),
                                                                                            ]
                                                                                          ),
                                                                                          !_vm.serverConnected &&
                                                                                          !_vm.loadingInstruments
                                                                                            ? _c(
                                                                                                "v-btn",
                                                                                                {
                                                                                                  staticStyle:
                                                                                                    {
                                                                                                      "font-weight":
                                                                                                        "400",
                                                                                                    },
                                                                                                  attrs:
                                                                                                    {
                                                                                                      disabled:
                                                                                                        !_vm.priceGuardModel,
                                                                                                      rounded:
                                                                                                        "",
                                                                                                      outlined:
                                                                                                        "",
                                                                                                      color:
                                                                                                        "primary",
                                                                                                    },
                                                                                                  on: {
                                                                                                    click:
                                                                                                      function (
                                                                                                        $event
                                                                                                      ) {
                                                                                                        return _vm.$router.push(
                                                                                                          {
                                                                                                            path: "/applications",
                                                                                                            query:
                                                                                                              {
                                                                                                                add: true,
                                                                                                              },
                                                                                                          }
                                                                                                        )
                                                                                                      },
                                                                                                  },
                                                                                                },
                                                                                                [
                                                                                                  _vm._v(
                                                                                                    "Run Applications "
                                                                                                  ),
                                                                                                ]
                                                                                              )
                                                                                            : _vm._e(),
                                                                                        ],
                                                                                        1
                                                                                      ),
                                                                                    ],
                                                                                    1
                                                                                  ),
                                                                                ]
                                                                              },
                                                                              proxy: true,
                                                                            },
                                                                            {
                                                                              key: "item",
                                                                              fn: function ({
                                                                                item,
                                                                              }) {
                                                                                return [
                                                                                  _c(
                                                                                    "tr",
                                                                                    {
                                                                                      staticClass:
                                                                                        "accent",
                                                                                      on: {
                                                                                        click:
                                                                                          function (
                                                                                            $event
                                                                                          ) {
                                                                                            return _vm.PGSymbolSelected(
                                                                                              item
                                                                                            )
                                                                                          },
                                                                                      },
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "td",
                                                                                        {
                                                                                          staticClass:
                                                                                            "py-1",
                                                                                          class:
                                                                                            !_vm.priceGuardModel
                                                                                              ? "grey--text"
                                                                                              : "primary--text",
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "v-icon",
                                                                                            {
                                                                                              attrs:
                                                                                                {
                                                                                                  color:
                                                                                                    !_vm.priceGuardModel
                                                                                                      ? "grey"
                                                                                                      : "primary",
                                                                                                },
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                " " +
                                                                                                  _vm._s(
                                                                                                    item.checked
                                                                                                      ? "radio_button_checked"
                                                                                                      : "radio_button_unchecked"
                                                                                                  ) +
                                                                                                  " "
                                                                                              ),
                                                                                            ]
                                                                                          ),
                                                                                          _vm._v(
                                                                                            " " +
                                                                                              _vm._s(
                                                                                                item.value
                                                                                              ) +
                                                                                              " "
                                                                                          ),
                                                                                        ],
                                                                                        1
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ]
                                                                              },
                                                                            },
                                                                          ],
                                                                          null,
                                                                          false,
                                                                          2412714267
                                                                        ),
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  !_vm.add
                                                    ? _c(
                                                        "v-row",
                                                        {
                                                          staticClass: "mx-0",
                                                          attrs: {
                                                            justify: "start",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-btn",
                                                            {
                                                              staticStyle: {
                                                                "font-weight":
                                                                  "400",
                                                              },
                                                              attrs: {
                                                                disabled:
                                                                  !_vm
                                                                    .allPriceguardSymbols
                                                                    .length ||
                                                                  !_vm.priceGuardModel,
                                                                color:
                                                                  "primary",
                                                                text: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  _vm.selectAllPGSymbols,
                                                              },
                                                            },
                                                            [_vm._v("Add All ")]
                                                          ),
                                                          _c(
                                                            "v-btn",
                                                            {
                                                              staticStyle: {
                                                                "font-weight":
                                                                  "400",
                                                              },
                                                              attrs: {
                                                                disabled:
                                                                  !_vm
                                                                    .allPriceguardSymbols
                                                                    .length ||
                                                                  !_vm.priceGuardModel,
                                                                color:
                                                                  "primary",
                                                                text: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  _vm.deSelectAllPGSymbols,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Remove All "
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "mb-0 mx-4 pt-2 grey--text subtitle-2",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " Selected: " +
                                                                  _vm._s(
                                                                    _vm.currentPGSelectedSymbols
                                                                  ) +
                                                                  "/" +
                                                                  _vm._s(
                                                                    _vm.currentPGSymbols
                                                                  ) +
                                                                  _vm._s(
                                                                    _vm
                                                                      .allPriceguardSymbols
                                                                      .length >
                                                                      _vm.currentPGSymbols
                                                                      ? `   Total: ${_vm.checkedPGSymbolsCount}/${_vm.allPriceguardSymbols.length}`
                                                                      : ""
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-tab-item",
                                                {
                                                  staticClass: "pt-2",
                                                  staticStyle: {
                                                    "min-height": "85px",
                                                  },
                                                },
                                                [
                                                  _vm.add
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            width: "100%",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-row",
                                                            {
                                                              attrs: {
                                                                justify:
                                                                  "center",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "10",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "p",
                                                                    {
                                                                      staticClass:
                                                                        "mt-7 grey--text text-center",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " Price Watcher can be configured once created "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  !_vm.add
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            width: "100%",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-row",
                                                            {
                                                              attrs: {
                                                                justify:
                                                                  "center",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  staticClass:
                                                                    "pb-0 pt-0 px-3",
                                                                  staticStyle: {
                                                                    "max-height":
                                                                      "95px",
                                                                    "margin-bottom":
                                                                      "-1px",
                                                                  },
                                                                  attrs: {
                                                                    cols: "12",
                                                                    sm: "12",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-text-field",
                                                                    {
                                                                      staticClass:
                                                                        "inputSlot-mb-0",
                                                                      class:
                                                                        _vm.regexSearchPW
                                                                          ? "text-field-top-details"
                                                                          : "hide-error-message",
                                                                      staticStyle:
                                                                        {
                                                                          "z-index":
                                                                            "0",
                                                                        },
                                                                      attrs: {
                                                                        disabled:
                                                                          !_vm.priceGuardModel,
                                                                        value:
                                                                          _vm.searchSymbolPW,
                                                                        outlined:
                                                                          "",
                                                                        placeholder:
                                                                          _vm.regexSearchPW
                                                                            ? "Search with regex"
                                                                            : "Search",
                                                                        "single-line":
                                                                          "",
                                                                        dense:
                                                                          "",
                                                                        rules:
                                                                          _vm.regexSearchPW
                                                                            ? [
                                                                                _vm
                                                                                  .rules
                                                                                  .validRegex,
                                                                              ]
                                                                            : [],
                                                                        "hide-details":
                                                                          !_vm.regexSearchPW,
                                                                      },
                                                                      scopedSlots:
                                                                        _vm._u(
                                                                          [
                                                                            {
                                                                              key: "append",
                                                                              fn: function () {
                                                                                return [
                                                                                  _c(
                                                                                    "v-row",
                                                                                    {
                                                                                      staticClass:
                                                                                        "mx-0",
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "p",
                                                                                        {
                                                                                          staticClass:
                                                                                            "mb-0 mx-2 pt-1 grey--text subtitle-2",
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            " (" +
                                                                                              _vm._s(
                                                                                                _vm.currentPWSymbols
                                                                                              ) +
                                                                                              ") "
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                      _c(
                                                                                        "v-btn",
                                                                                        {
                                                                                          staticClass:
                                                                                            "mb-2",
                                                                                          attrs:
                                                                                            {
                                                                                              icon: "",
                                                                                              small:
                                                                                                "",
                                                                                              color:
                                                                                                _vm.regexSearchPW
                                                                                                  ? "primary"
                                                                                                  : "white",
                                                                                            },
                                                                                          on: {
                                                                                            click:
                                                                                              function (
                                                                                                $event
                                                                                              ) {
                                                                                                _vm.regexSearchPW =
                                                                                                  !_vm.regexSearchPW
                                                                                              },
                                                                                          },
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "div",
                                                                                            {
                                                                                              staticClass:
                                                                                                "absolute",
                                                                                              staticStyle:
                                                                                                {
                                                                                                  left: "12px",
                                                                                                  "font-size":
                                                                                                    "17px",
                                                                                                },
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                " * "
                                                                                              ),
                                                                                            ]
                                                                                          ),
                                                                                          _c(
                                                                                            "div",
                                                                                            {
                                                                                              staticClass:
                                                                                                "absolute",
                                                                                              staticStyle:
                                                                                                {
                                                                                                  left: "5px",
                                                                                                  "font-size":
                                                                                                    "25px",
                                                                                                  "margin-bottom":
                                                                                                    "2px",
                                                                                                },
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                " . "
                                                                                              ),
                                                                                            ]
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                    ],
                                                                                    1
                                                                                  ),
                                                                                ]
                                                                              },
                                                                              proxy: true,
                                                                            },
                                                                          ],
                                                                          null,
                                                                          false,
                                                                          3232620867
                                                                        ),
                                                                      model: {
                                                                        value:
                                                                          _vm.searchSymbolPW,
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.searchSymbolPW =
                                                                              $$v
                                                                          },
                                                                        expression:
                                                                          "searchSymbolPW",
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  staticClass:
                                                                    "pt-0 px-3",
                                                                  attrs: {
                                                                    cols: "12",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-data-table",
                                                                    {
                                                                      ref: "PWSymbolsTable",
                                                                      class: {
                                                                        "disabled-table":
                                                                          !_vm.priceGuardModel,
                                                                      },
                                                                      staticStyle:
                                                                        {
                                                                          height:
                                                                            "238px",
                                                                          "overflow-y":
                                                                            "auto",
                                                                          border:
                                                                            "1px solid #47bd96",
                                                                          "z-index":
                                                                            "1",
                                                                        },
                                                                      attrs: {
                                                                        "mobile-breakpoint": 0,
                                                                        id: "selectSymbolsTable",
                                                                        dense:
                                                                          "",
                                                                        search:
                                                                          _vm.searchSymbolPW,
                                                                        "custom-filter":
                                                                          _vm.symbolSearchFilter,
                                                                        "item-key":
                                                                          "symbol",
                                                                        "hide-default-footer":
                                                                          "",
                                                                        "hide-default-header":
                                                                          "",
                                                                        "items-per-page":
                                                                          -1,
                                                                        items:
                                                                          _vm.allPricewatcherSymbols,
                                                                        headers:
                                                                          [
                                                                            {
                                                                              text: "",
                                                                              value:
                                                                                "value",
                                                                            },
                                                                          ],
                                                                        "single-select":
                                                                          "",
                                                                      },
                                                                      on: {
                                                                        "current-items":
                                                                          (
                                                                            items
                                                                          ) =>
                                                                            _vm.setCurrentPWSymbols(
                                                                              items
                                                                            ),
                                                                      },
                                                                      scopedSlots:
                                                                        _vm._u(
                                                                          [
                                                                            {
                                                                              key: "no-data",
                                                                              fn: function () {
                                                                                return [
                                                                                  _c(
                                                                                    "v-row",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          justify:
                                                                                            "center",
                                                                                        },
                                                                                    },
                                                                                    [
                                                                                      _vm.loadingInstruments
                                                                                        ? _c(
                                                                                            "v-col",
                                                                                            {
                                                                                              attrs:
                                                                                                {
                                                                                                  cols: "2",
                                                                                                },
                                                                                            },
                                                                                            [
                                                                                              _c(
                                                                                                "v-row",
                                                                                                {
                                                                                                  attrs:
                                                                                                    {
                                                                                                      justify:
                                                                                                        "end",
                                                                                                    },
                                                                                                },
                                                                                                [
                                                                                                  _c(
                                                                                                    "v-progress-circular",
                                                                                                    {
                                                                                                      staticStyle:
                                                                                                        {
                                                                                                          "margin-top":
                                                                                                            "-4px",
                                                                                                        },
                                                                                                      attrs:
                                                                                                        {
                                                                                                          indeterminate:
                                                                                                            "",
                                                                                                          color:
                                                                                                            "primary",
                                                                                                        },
                                                                                                    }
                                                                                                  ),
                                                                                                ],
                                                                                                1
                                                                                              ),
                                                                                            ],
                                                                                            1
                                                                                          )
                                                                                        : _vm._e(),
                                                                                      _c(
                                                                                        "v-col",
                                                                                        {
                                                                                          attrs:
                                                                                            {
                                                                                              cols: _vm.loadingInstruments
                                                                                                ? 5
                                                                                                : 10,
                                                                                            },
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "p",
                                                                                            {
                                                                                              style:
                                                                                                _vm.loadingInstruments
                                                                                                  ? "text-align: left;"
                                                                                                  : "text-align: center;",
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                " " +
                                                                                                  _vm._s(
                                                                                                    _vm.loadingInstruments
                                                                                                      ? "Loading Instruments..."
                                                                                                      : _vm.serverConnected
                                                                                                      ? "An error has occurred.."
                                                                                                      : "Application is not running"
                                                                                                  ) +
                                                                                                  " "
                                                                                              ),
                                                                                            ]
                                                                                          ),
                                                                                          !_vm.serverConnected &&
                                                                                          !_vm.loadingInstruments
                                                                                            ? _c(
                                                                                                "v-btn",
                                                                                                {
                                                                                                  staticStyle:
                                                                                                    {
                                                                                                      "font-weight":
                                                                                                        "400",
                                                                                                    },
                                                                                                  attrs:
                                                                                                    {
                                                                                                      disabled:
                                                                                                        !_vm.priceGuardModel,
                                                                                                      rounded:
                                                                                                        "",
                                                                                                      outlined:
                                                                                                        "",
                                                                                                      color:
                                                                                                        "primary",
                                                                                                    },
                                                                                                  on: {
                                                                                                    click:
                                                                                                      function (
                                                                                                        $event
                                                                                                      ) {
                                                                                                        return _vm.$router.push(
                                                                                                          {
                                                                                                            path: "/applications",
                                                                                                            query:
                                                                                                              {
                                                                                                                add: true,
                                                                                                              },
                                                                                                          }
                                                                                                        )
                                                                                                      },
                                                                                                  },
                                                                                                },
                                                                                                [
                                                                                                  _vm._v(
                                                                                                    "Run Applications "
                                                                                                  ),
                                                                                                ]
                                                                                              )
                                                                                            : _vm._e(),
                                                                                        ],
                                                                                        1
                                                                                      ),
                                                                                    ],
                                                                                    1
                                                                                  ),
                                                                                ]
                                                                              },
                                                                              proxy: true,
                                                                            },
                                                                            {
                                                                              key: "item",
                                                                              fn: function ({
                                                                                item,
                                                                              }) {
                                                                                return [
                                                                                  _c(
                                                                                    "tr",
                                                                                    {
                                                                                      staticClass:
                                                                                        "accent",
                                                                                      on: {
                                                                                        click:
                                                                                          function (
                                                                                            $event
                                                                                          ) {
                                                                                            return _vm.PWSymbolSelected(
                                                                                              item
                                                                                            )
                                                                                          },
                                                                                      },
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "td",
                                                                                        {
                                                                                          staticClass:
                                                                                            "py-1",
                                                                                          class:
                                                                                            !_vm.priceGuardModel
                                                                                              ? "grey--text"
                                                                                              : "primary--text",
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "v-icon",
                                                                                            {
                                                                                              attrs:
                                                                                                {
                                                                                                  color:
                                                                                                    !_vm.priceGuardModel
                                                                                                      ? "grey"
                                                                                                      : "primary",
                                                                                                },
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                " " +
                                                                                                  _vm._s(
                                                                                                    item.checked
                                                                                                      ? "radio_button_checked"
                                                                                                      : "radio_button_unchecked"
                                                                                                  ) +
                                                                                                  " "
                                                                                              ),
                                                                                            ]
                                                                                          ),
                                                                                          _vm._v(
                                                                                            " " +
                                                                                              _vm._s(
                                                                                                item.value
                                                                                              ) +
                                                                                              " "
                                                                                          ),
                                                                                        ],
                                                                                        1
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ]
                                                                              },
                                                                            },
                                                                          ],
                                                                          null,
                                                                          false,
                                                                          2959979275
                                                                        ),
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  !_vm.add
                                                    ? _c(
                                                        "v-row",
                                                        {
                                                          staticClass: "mx-0",
                                                          attrs: {
                                                            justify: "start",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-btn",
                                                            {
                                                              staticStyle: {
                                                                "font-weight":
                                                                  "400",
                                                              },
                                                              attrs: {
                                                                disabled:
                                                                  !_vm
                                                                    .allPricewatcherSymbols
                                                                    .length ||
                                                                  !_vm.priceGuardModel,
                                                                color:
                                                                  "primary",
                                                                text: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  _vm.selectAllPWSymbols,
                                                              },
                                                            },
                                                            [_vm._v("Add All ")]
                                                          ),
                                                          _c(
                                                            "v-btn",
                                                            {
                                                              staticStyle: {
                                                                "font-weight":
                                                                  "400",
                                                              },
                                                              attrs: {
                                                                disabled:
                                                                  !_vm
                                                                    .allPricewatcherSymbols
                                                                    .length ||
                                                                  !_vm.priceGuardModel,
                                                                color:
                                                                  "primary",
                                                                text: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  _vm.deSelectAllPWSymbols,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Remove All "
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "mb-0 mx-4 pt-2 grey--text subtitle-2",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " Selected: " +
                                                                  _vm._s(
                                                                    _vm.currentPWSelectedSymbols
                                                                  ) +
                                                                  "/" +
                                                                  _vm._s(
                                                                    _vm.currentPWSymbols
                                                                  ) +
                                                                  _vm._s(
                                                                    _vm
                                                                      .allPricewatcherSymbols
                                                                      .length >
                                                                      _vm.currentPWSymbols
                                                                      ? `   Total: ${_vm.checkedPWSymbolsCount}/${_vm.allPricewatcherSymbols.length}`
                                                                      : ""
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "v-row",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.selectedApplicationType ===
                                            _vm.applicationTypeEnums.general,
                                          expression:
                                            "\n                    selectedApplicationType === applicationTypeEnums.general\n                  ",
                                        },
                                      ],
                                      attrs: { justify: "space-between" },
                                    },
                                    [
                                      _vm.$vuetify.breakpoint.xsOnly
                                        ? _c(
                                            "v-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              _c(
                                                "v-row",
                                                {
                                                  staticClass: "mx-0",
                                                  attrs: { justify: "center" },
                                                },
                                                [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "mb-0 mt-2 pr-1 clickableText",
                                                      staticStyle: {
                                                        color: "#47bd96",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.analyticsConfigModel = 1
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " Advanced Configurations "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticClass:
                                                        "mb-0 mt-2 clickableText",
                                                      staticStyle: {
                                                        "font-size": "14px",
                                                        color: "#47bd96",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.analyticsConfigModel = 1
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("icon-more-23x13 ")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _c("v-col", {
                                        staticClass: "py-2",
                                        attrs: { cols: "12", sm: "6" },
                                      }),
                                      _vm.$vuetify.breakpoint.smAndUp
                                        ? _c(
                                            "v-col",
                                            { attrs: { cols: "6" } },
                                            [
                                              _c(
                                                "v-row",
                                                {
                                                  staticClass: "mx-0",
                                                  attrs: { justify: "end" },
                                                },
                                                [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "mb-0 mt-2 pr-1 clickableText",
                                                      staticStyle: {
                                                        color: "#47bd96",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.analyticsConfigModel = 1
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " Advanced Configurations "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticClass:
                                                        "mb-0 mt-2 pr-2 clickableText",
                                                      staticStyle: {
                                                        "font-size": "14px",
                                                        color: "#47bd96",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.analyticsConfigModel = 1
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("icon-more-23x13 ")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-tab-item",
                                [
                                  _c("div", { staticClass: "pl-2 pb-4" }, [
                                    _vm._v("Common"),
                                  ]),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: {
                                            disabled: _vm.isNotDesktop,
                                            "content-class": "tooltipClassBig",
                                            bottom: "",
                                          },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "activator",
                                              fn: function ({ on }) {
                                                return [
                                                  _c(
                                                    "v-col",
                                                    _vm._g(
                                                      {
                                                        staticClass: "py-0",
                                                        attrs: {
                                                          cols: "12",
                                                          sm: "6",
                                                        },
                                                      },
                                                      on
                                                    ),
                                                    [
                                                      _c("v-text-field", {
                                                        staticClass:
                                                          "analyticsTextFieldClass",
                                                        attrs: {
                                                          dense: "",
                                                          outlined: "",
                                                          label:
                                                            "Reconnection Time",
                                                          type: "number",
                                                          rules: [
                                                            _vm.rules.required,
                                                          ],
                                                        },
                                                        on: {
                                                          keydown: (ev) =>
                                                            _vm.setHelperVar(
                                                              ev,
                                                              "ReconnectTimeAN"
                                                            ),
                                                          keypress: (ev) =>
                                                            _vm.setHelperVar(
                                                              ev,
                                                              "ReconnectTimeAN"
                                                            ),
                                                          input: (ev) =>
                                                            _vm.textInput(
                                                              ev,
                                                              _vm
                                                                .currentDefinition
                                                                .configuration,
                                                              "ReconnectTime"
                                                            ),
                                                          change:
                                                            _vm.clearHelperVar,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.ReconnectTimeAN,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.ReconnectTimeAN =
                                                              _vm._n($$v)
                                                          },
                                                          expression:
                                                            "ReconnectTimeAN",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ]),
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              " Time in milliseconds until the service will try to reconnect "
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _c(
                                        "v-col",
                                        { staticClass: "py-0" },
                                        [
                                          _c(
                                            "v-tooltip",
                                            {
                                              attrs: {
                                                disabled: _vm.isNotDesktop,
                                                "content-class":
                                                  "tooltipClassBig",
                                                bottom: "",
                                              },
                                              scopedSlots: _vm._u([
                                                {
                                                  key: "activator",
                                                  fn: function ({ on }) {
                                                    return [
                                                      _c(
                                                        "v-text-field",
                                                        _vm._g(
                                                          {
                                                            staticClass:
                                                              "analyticsTextFieldClass",
                                                            attrs: {
                                                              dense: "",
                                                              outlined: "",
                                                              label:
                                                                "Maximum Reconnect Retries",
                                                              type: "number",
                                                              rules: [
                                                                _vm.rules
                                                                  .required,
                                                                _vm.rules
                                                                  .maxReconnect,
                                                              ],
                                                            },
                                                            on: {
                                                              keydown: (ev) =>
                                                                _vm.setHelperVar(
                                                                  ev,
                                                                  "MaxReconnectRetriesAN"
                                                                ),
                                                              keypress: (ev) =>
                                                                _vm.setHelperVar(
                                                                  ev,
                                                                  "MaxReconnectRetriesAN"
                                                                ),
                                                              input: (ev) =>
                                                                _vm.textInput(
                                                                  ev,
                                                                  _vm
                                                                    .currentDefinition
                                                                    .configuration,
                                                                  "MaxReconnectRetries"
                                                                ),
                                                              change:
                                                                _vm.clearHelperVar,
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.MaxReconnectRetriesAN,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.MaxReconnectRetriesAN =
                                                                    _vm._n($$v)
                                                                },
                                                              expression:
                                                                "MaxReconnectRetriesAN",
                                                            },
                                                          },
                                                          on
                                                        )
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ]),
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "Maximum reconnection tries until the routine is stoped"
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "py-0",
                                          attrs: { cols: "12", sm: "6" },
                                        },
                                        [
                                          _c(
                                            "v-tooltip",
                                            {
                                              attrs: {
                                                disabled: _vm.isNotDesktop,
                                                "content-class":
                                                  "tooltipClassBig",
                                                bottom: "",
                                              },
                                              scopedSlots: _vm._u([
                                                {
                                                  key: "activator",
                                                  fn: function ({ on }) {
                                                    return [
                                                      _c(
                                                        "v-text-field",
                                                        _vm._g(
                                                          {
                                                            staticClass:
                                                              "analyticsTextFieldClass",
                                                            attrs: {
                                                              dense: "",
                                                              outlined: "",
                                                              label:
                                                                "Server Name",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .currentDefinition
                                                                  .configuration
                                                                  .ServerName,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm
                                                                      .currentDefinition
                                                                      .configuration,
                                                                    "ServerName",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "currentDefinition.configuration.ServerName",
                                                            },
                                                          },
                                                          on
                                                        )
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ]),
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  " A friendly name to identify the data processed by current agent "
                                                ),
                                                _c("br"),
                                                _vm._v(
                                                  "If not set, the server name will be used on connect "
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm.isAdmin
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "py-0",
                                              attrs: { cols: "12", sm: "6" },
                                            },
                                            [
                                              _c(
                                                "v-tooltip",
                                                {
                                                  attrs: {
                                                    disabled: _vm.isNotDesktop,
                                                    "content-class":
                                                      "tooltipClassBig",
                                                    bottom: "",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "activator",
                                                        fn: function ({ on }) {
                                                          return [
                                                            _c(
                                                              "div",
                                                              _vm._g({}, on),
                                                              [
                                                                _c(
                                                                  "v-text-field",
                                                                  {
                                                                    staticClass:
                                                                      "analyticsTextFieldClass",
                                                                    attrs: {
                                                                      dense: "",
                                                                      outlined:
                                                                        "",
                                                                      type: "number",
                                                                      label:
                                                                        "Connection Ping Cycle",
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .currentDefinition
                                                                          .configuration
                                                                          .ConnectionPingCycle,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm
                                                                              .currentDefinition
                                                                              .configuration,
                                                                            "ConnectionPingCycle",
                                                                            _vm._n(
                                                                              $$v
                                                                            )
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "\n                              currentDefinition.configuration\n                                .ConnectionPingCycle\n                            ",
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    false,
                                                    2682352559
                                                  ),
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      " Intended for internal use only "
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _vm.isAdmin
                                    ? _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "py-0",
                                              attrs: { cols: "12", sm: "6" },
                                            },
                                            [
                                              _c(
                                                "v-tooltip",
                                                {
                                                  attrs: {
                                                    disabled: _vm.isNotDesktop,
                                                    "content-class":
                                                      "tooltipClassBig",
                                                    bottom: "",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "activator",
                                                        fn: function ({ on }) {
                                                          return [
                                                            _c(
                                                              "div",
                                                              _vm._g({}, on),
                                                              [
                                                                _c(
                                                                  "v-select",
                                                                  _vm._g(
                                                                    {
                                                                      attrs: {
                                                                        outlined:
                                                                          "",
                                                                        dense:
                                                                          "",
                                                                        "menu-props":
                                                                          {
                                                                            offsetY: true,
                                                                          },
                                                                        "item-text":
                                                                          "text",
                                                                        label:
                                                                          "Compress Messages",
                                                                        items: [
                                                                          {
                                                                            value: true,
                                                                            text: "Yes",
                                                                          },
                                                                          {
                                                                            value: false,
                                                                            text: "No",
                                                                          },
                                                                        ],
                                                                      },
                                                                      scopedSlots:
                                                                        _vm._u(
                                                                          [
                                                                            {
                                                                              key: "item",
                                                                              fn: function ({
                                                                                item,
                                                                              }) {
                                                                                return [
                                                                                  _c(
                                                                                    "p",
                                                                                    {
                                                                                      staticClass:
                                                                                        "mb-0",
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          item.text
                                                                                        )
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ]
                                                                              },
                                                                            },
                                                                          ],
                                                                          null,
                                                                          true
                                                                        ),
                                                                      model: {
                                                                        value:
                                                                          _vm
                                                                            .currentDefinition
                                                                            .configuration
                                                                            .CompressMessages,
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm
                                                                                .currentDefinition
                                                                                .configuration,
                                                                              "CompressMessages",
                                                                              $$v
                                                                            )
                                                                          },
                                                                        expression:
                                                                          "\n                              currentDefinition.configuration.CompressMessages\n                            ",
                                                                      },
                                                                    },
                                                                    on
                                                                  )
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    false,
                                                    1446643747
                                                  ),
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      " Determinates if publisher messages will be zipped by the agent "
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          (_vm.add &&
                                            _vm.chosenServer &&
                                            _vm.chosenServer.version ===
                                              _vm.serverVersions.MTT) ||
                                          (_vm.edit &&
                                            _vm.currentDefinition.server
                                              .version ===
                                              _vm.serverVersions.MTT)
                                            ? _c(
                                                "v-col",
                                                {
                                                  staticClass: "py-0",
                                                  attrs: {
                                                    cols: "12",
                                                    sm: "6",
                                                  },
                                                },
                                                [
                                                  _c("v-select", {
                                                    attrs: {
                                                      outlined: "",
                                                      dense: "",
                                                      "menu-props": {
                                                        offsetY: true,
                                                        maxHeight: "350",
                                                      },
                                                      label: "Quote connection",
                                                      items:
                                                        _vm.availableQuoteConnections,
                                                      "item-color": "#262b2e",
                                                      "return-object": "",
                                                      "hide-selected": "",
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "item",
                                                          fn: function ({}) {
                                                            return [_c("div")]
                                                          },
                                                        },
                                                        {
                                                          key: "no-data",
                                                          fn: function () {
                                                            return [_c("div")]
                                                          },
                                                          proxy: true,
                                                        },
                                                        {
                                                          key: "append-item",
                                                          fn: function () {
                                                            return [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "EodFloatingPnlOffsetTimes-outer pt-2",
                                                                  staticStyle: {
                                                                    "max-height":
                                                                      "348px",
                                                                    "border-top":
                                                                      "none !important",
                                                                  },
                                                                },
                                                                _vm._l(
                                                                  _vm.quoteConnections,
                                                                  function (
                                                                    connection
                                                                  ) {
                                                                    return _c(
                                                                      "v-row",
                                                                      {
                                                                        key: connection.value,
                                                                        staticClass:
                                                                          "pa-1 mx-0",
                                                                        staticStyle:
                                                                          {
                                                                            "margin-top":
                                                                              "-4px",
                                                                            "border-top":
                                                                              "none !important",
                                                                            "background-color":
                                                                              "#262b2e",
                                                                          },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-btn",
                                                                          {
                                                                            staticClass:
                                                                              "mt-1",
                                                                            attrs:
                                                                              {
                                                                                icon: "",
                                                                                small:
                                                                                  "",
                                                                                height: 24,
                                                                                width: 24,
                                                                              },
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.selectQuoteConnection(
                                                                                    connection
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "v-icon",
                                                                              {
                                                                                staticClass:
                                                                                  "mx-2",
                                                                                attrs:
                                                                                  {
                                                                                    small:
                                                                                      "",
                                                                                    color:
                                                                                      connection.enabled
                                                                                        ? "primary"
                                                                                        : "white",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  " " +
                                                                                    _vm._s(
                                                                                      connection.enabled
                                                                                        ? "fas fa-dot-circle"
                                                                                        : "far fa-dot-circle"
                                                                                    ) +
                                                                                    " "
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ],
                                                                          1
                                                                        ),
                                                                        _c(
                                                                          "p",
                                                                          {
                                                                            staticClass:
                                                                              "pl-2 clickable",
                                                                            class:
                                                                              {
                                                                                "grey--text":
                                                                                  !connection.enabled,
                                                                              },
                                                                            staticStyle:
                                                                              {
                                                                                width:
                                                                                  "160px",
                                                                                "padding-top":
                                                                                  "4px",
                                                                              },
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.selectQuoteConnection(
                                                                                    connection
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              " " +
                                                                                _vm._s(
                                                                                  connection.text
                                                                                ) +
                                                                                " "
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _c(
                                                                          "v-spacer"
                                                                        ),
                                                                        _c(
                                                                          "v-btn",
                                                                          {
                                                                            staticClass:
                                                                              "mr-1 mr-4",
                                                                            staticStyle:
                                                                              {
                                                                                "margin-top":
                                                                                  "1px",
                                                                              },
                                                                            attrs:
                                                                              {
                                                                                disabled:
                                                                                  _vm
                                                                                    .quoteConnectionSelected
                                                                                    .value !==
                                                                                  connection.value,
                                                                                small:
                                                                                  "",
                                                                                icon: "",
                                                                              },
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  $event.stopPropagation()
                                                                                  return _vm.editQuoteConnection(
                                                                                    connection
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "span",
                                                                              {
                                                                                class:
                                                                                  _vm
                                                                                    .quoteConnectionSelected
                                                                                    .value !==
                                                                                  connection.value
                                                                                    ? "icon-edit-21x21-disabled"
                                                                                    : "icon-edit-21x21",
                                                                                staticStyle:
                                                                                  {
                                                                                    "font-size":
                                                                                      "27px",
                                                                                    "margin-bottom":
                                                                                      "2px",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "span",
                                                                                  {
                                                                                    staticClass:
                                                                                      "path1 letterSpacing0",
                                                                                  }
                                                                                ),
                                                                                _c(
                                                                                  "span",
                                                                                  {
                                                                                    staticClass:
                                                                                      "path2",
                                                                                  }
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      1
                                                                    )
                                                                  }
                                                                ),
                                                                1
                                                              ),
                                                            ]
                                                          },
                                                          proxy: true,
                                                        },
                                                        {
                                                          key: "selection",
                                                          fn: function ({}) {
                                                            return [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "mr-1",
                                                                },
                                                                [
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm
                                                                          .quoteConnectionSelected
                                                                          .text
                                                                      )
                                                                    ),
                                                                  ]),
                                                                ]
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      false,
                                                      2456240799
                                                    ),
                                                    model: {
                                                      value:
                                                        _vm.quoteConnectionModel,
                                                      callback: function ($$v) {
                                                        _vm.quoteConnectionModel =
                                                          $$v
                                                      },
                                                      expression:
                                                        "quoteConnectionModel",
                                                    },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.analyticsModel
                                    ? _c(
                                        "div",
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "pl-2 pb-4" },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "mr-2 mb-1",
                                                  staticStyle: {
                                                    "font-size": "17px",
                                                    height: "17px",
                                                    "margin-top": "2px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "icon-analytics-23x23 "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" Analytics "),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "h2",
                                            {
                                              staticClass:
                                                "agent-config-category pl-2",
                                            },
                                            [_vm._v("Generic")]
                                          ),
                                          _vm.isAdmin
                                            ? _c(
                                                "v-row",
                                                [
                                                  _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "py-0",
                                                      attrs: {
                                                        cols: "12",
                                                        sm: "6",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              _vm.isNotDesktop,
                                                            "content-class":
                                                              "tooltipClassBig",
                                                            bottom: "",
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "activator",
                                                                fn: function ({
                                                                  on,
                                                                }) {
                                                                  return [
                                                                    _c(
                                                                      "div",
                                                                      _vm._g(
                                                                        {},
                                                                        on
                                                                      ),
                                                                      [
                                                                        _c(
                                                                          "v-text-field",
                                                                          {
                                                                            staticClass:
                                                                              "analyticsTextFieldClass",
                                                                            attrs:
                                                                              {
                                                                                dense:
                                                                                  "",
                                                                                outlined:
                                                                                  "",
                                                                                type: "number",
                                                                                label:
                                                                                  "Acceptable Deviation From Utc",
                                                                              },
                                                                            model:
                                                                              {
                                                                                value:
                                                                                  _vm
                                                                                    .currentDefinition
                                                                                    .configuration
                                                                                    .Analytics
                                                                                    .AcceptableDeviationFromUtc,
                                                                                callback:
                                                                                  function (
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.$set(
                                                                                      _vm
                                                                                        .currentDefinition
                                                                                        .configuration
                                                                                        .Analytics,
                                                                                      "AcceptableDeviationFromUtc",
                                                                                      _vm._n(
                                                                                        $$v
                                                                                      )
                                                                                    )
                                                                                  },
                                                                                expression:
                                                                                  "\n                                currentDefinition.configuration.Analytics\n                                  .AcceptableDeviationFromUtc\n                              ",
                                                                              },
                                                                          }
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            false,
                                                            1109402711
                                                          ),
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              " Max acceptable deviation of server time with local time in seconds "
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "py-0",
                                                      attrs: {
                                                        cols: "12",
                                                        sm: "6",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              _vm.isNotDesktop,
                                                            "content-class":
                                                              "tooltipClassBig",
                                                            bottom: "",
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "activator",
                                                                fn: function ({
                                                                  on,
                                                                }) {
                                                                  return [
                                                                    _c(
                                                                      "v-select",
                                                                      _vm._g(
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              outlined:
                                                                                "",
                                                                              dense:
                                                                                "",
                                                                              "menu-props":
                                                                                {
                                                                                  offsetY: true,
                                                                                },
                                                                              "item-text":
                                                                                "text",
                                                                              label:
                                                                                "Use Journal",
                                                                              items:
                                                                                [
                                                                                  {
                                                                                    value: true,
                                                                                    text: "Yes",
                                                                                  },
                                                                                  {
                                                                                    value: false,
                                                                                    text: "No",
                                                                                  },
                                                                                ],
                                                                            },
                                                                          scopedSlots:
                                                                            _vm._u(
                                                                              [
                                                                                {
                                                                                  key: "item",
                                                                                  fn: function ({
                                                                                    item,
                                                                                  }) {
                                                                                    return [
                                                                                      _c(
                                                                                        "p",
                                                                                        {
                                                                                          staticClass:
                                                                                            "mb-0",
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              item.text
                                                                                            )
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                    ]
                                                                                  },
                                                                                },
                                                                              ],
                                                                              null,
                                                                              true
                                                                            ),
                                                                          model:
                                                                            {
                                                                              value:
                                                                                _vm
                                                                                  .currentDefinition
                                                                                  .configuration
                                                                                  .Analytics
                                                                                  .UseJournal,
                                                                              callback:
                                                                                function (
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    _vm
                                                                                      .currentDefinition
                                                                                      .configuration
                                                                                      .Analytics,
                                                                                    "UseJournal",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                              expression:
                                                                                "\n                              currentDefinition.configuration.Analytics\n                                .UseJournal\n                            ",
                                                                            },
                                                                        },
                                                                        on
                                                                      )
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            false,
                                                            2926384326
                                                          ),
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              " Use journal logs to get data during downtime."
                                                            ),
                                                            _c("br"),
                                                            _vm._v(
                                                              "If allowed the permission to use the journal must be granted "
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "py-0",
                                                  attrs: {
                                                    cols: "12",
                                                    sm: "6",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: {
                                                        disabled:
                                                          _vm.isNotDesktop,
                                                        "content-class":
                                                          "tooltipClassBig",
                                                        bottom: "",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function ({
                                                              on,
                                                            }) {
                                                              return [
                                                                _c(
                                                                  "div",
                                                                  _vm._g(
                                                                    {},
                                                                    on
                                                                  ),
                                                                  [
                                                                    _c(
                                                                      "v-select",
                                                                      _vm._g(
                                                                        {
                                                                          class:
                                                                            {
                                                                              symbolsMultipliersErrorStyle:
                                                                                !_vm.multipliersForm,
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              outlined:
                                                                                "",
                                                                              dense:
                                                                                "",
                                                                              "menu-props":
                                                                                {
                                                                                  offsetY: true,
                                                                                },
                                                                              "item-text":
                                                                                "text",
                                                                              label: `Symbols Multipliers (${_vm.currentDefinition.configuration.Analytics.SymbolsMultipliers.length})`,
                                                                              items:
                                                                                [],
                                                                            },
                                                                          scopedSlots:
                                                                            _vm._u(
                                                                              [
                                                                                {
                                                                                  key: "no-data",
                                                                                  fn: function () {
                                                                                    return [
                                                                                      _c(
                                                                                        "div"
                                                                                      ),
                                                                                    ]
                                                                                  },
                                                                                  proxy: true,
                                                                                },
                                                                                {
                                                                                  key: "append-item",
                                                                                  fn: function () {
                                                                                    return [
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticStyle:
                                                                                            {
                                                                                              "max-height":
                                                                                                "209px",
                                                                                              "border-top":
                                                                                                "none !important",
                                                                                            },
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "v-form",
                                                                                            {
                                                                                              ref: "multipliersAddingForm",
                                                                                              model:
                                                                                                {
                                                                                                  value:
                                                                                                    _vm.multipliersAddingForm,
                                                                                                  callback:
                                                                                                    function (
                                                                                                      $$v
                                                                                                    ) {
                                                                                                      _vm.multipliersAddingForm =
                                                                                                        $$v
                                                                                                    },
                                                                                                  expression:
                                                                                                    "multipliersAddingForm",
                                                                                                },
                                                                                            },
                                                                                            [
                                                                                              _c(
                                                                                                "v-row",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "mx-1 mt-1 mb-0",
                                                                                                  staticStyle:
                                                                                                    {
                                                                                                      "border-top":
                                                                                                        "none !important",
                                                                                                    },
                                                                                                },
                                                                                                [
                                                                                                  _c(
                                                                                                    "v-text-field",
                                                                                                    {
                                                                                                      staticClass:
                                                                                                        "mini-text-field mr-1",
                                                                                                      staticStyle:
                                                                                                        {
                                                                                                          width:
                                                                                                            "100px !important",
                                                                                                        },
                                                                                                      attrs:
                                                                                                        {
                                                                                                          outlined:
                                                                                                            "",
                                                                                                          dense:
                                                                                                            "",
                                                                                                          label:
                                                                                                            "Symbol",
                                                                                                          rules:
                                                                                                            [
                                                                                                              _vm
                                                                                                                .rules
                                                                                                                .required,
                                                                                                            ],
                                                                                                        },
                                                                                                      model:
                                                                                                        {
                                                                                                          value:
                                                                                                            _vm.multipliersSymbol,
                                                                                                          callback:
                                                                                                            function (
                                                                                                              $$v
                                                                                                            ) {
                                                                                                              _vm.multipliersSymbol =
                                                                                                                $$v
                                                                                                            },
                                                                                                          expression:
                                                                                                            "multipliersSymbol",
                                                                                                        },
                                                                                                    }
                                                                                                  ),
                                                                                                  _c(
                                                                                                    "v-text-field",
                                                                                                    {
                                                                                                      staticClass:
                                                                                                        "mini-text-field mx-1",
                                                                                                      staticStyle:
                                                                                                        {
                                                                                                          width:
                                                                                                            "100px !important",
                                                                                                          "border-top":
                                                                                                            "none !important",
                                                                                                        },
                                                                                                      attrs:
                                                                                                        {
                                                                                                          type: "number",
                                                                                                          outlined:
                                                                                                            "",
                                                                                                          dense:
                                                                                                            "",
                                                                                                          label:
                                                                                                            "Multiplier",
                                                                                                          rules:
                                                                                                            [
                                                                                                              _vm
                                                                                                                .rules
                                                                                                                .required,
                                                                                                            ],
                                                                                                        },
                                                                                                      model:
                                                                                                        {
                                                                                                          value:
                                                                                                            _vm.multiplier,
                                                                                                          callback:
                                                                                                            function (
                                                                                                              $$v
                                                                                                            ) {
                                                                                                              _vm.multiplier =
                                                                                                                _vm._n(
                                                                                                                  $$v
                                                                                                                )
                                                                                                            },
                                                                                                          expression:
                                                                                                            "multiplier",
                                                                                                        },
                                                                                                    }
                                                                                                  ),
                                                                                                  _c(
                                                                                                    "v-btn",
                                                                                                    {
                                                                                                      staticClass:
                                                                                                        "primary",
                                                                                                      staticStyle:
                                                                                                        {
                                                                                                          "margin-top":
                                                                                                            "1px",
                                                                                                        },
                                                                                                      attrs:
                                                                                                        {
                                                                                                          small:
                                                                                                            "",
                                                                                                        },
                                                                                                      on: {
                                                                                                        click:
                                                                                                          function (
                                                                                                            $event
                                                                                                          ) {
                                                                                                            _vm.$refs.multipliersAddingForm.validate()
                                                                                                              ? _vm.addCurMultiplier()
                                                                                                              : 0
                                                                                                          },
                                                                                                      },
                                                                                                    },
                                                                                                    [
                                                                                                      _vm._v(
                                                                                                        "Add "
                                                                                                      ),
                                                                                                    ]
                                                                                                  ),
                                                                                                ],
                                                                                                1
                                                                                              ),
                                                                                            ],
                                                                                            1
                                                                                          ),
                                                                                          _vm
                                                                                            .currentDefinition
                                                                                            .configuration &&
                                                                                          _vm
                                                                                            .currentDefinition
                                                                                            .configuration
                                                                                            .Analytics
                                                                                            .SymbolsMultipliers
                                                                                            .length
                                                                                            ? _c(
                                                                                                "p",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "ml-1 mb-1 py-0",
                                                                                                  staticStyle:
                                                                                                    {
                                                                                                      "margin-top":
                                                                                                        "-8px",
                                                                                                      "font-size":
                                                                                                        "14px",
                                                                                                    },
                                                                                                },
                                                                                                [
                                                                                                  _vm._v(
                                                                                                    " List (" +
                                                                                                      _vm._s(
                                                                                                        _vm
                                                                                                          .currentDefinition
                                                                                                          .configuration
                                                                                                          .Analytics
                                                                                                          .SymbolsMultipliers
                                                                                                          .length
                                                                                                      ) +
                                                                                                      "): "
                                                                                                  ),
                                                                                                ]
                                                                                              )
                                                                                            : _vm._e(),
                                                                                          _c(
                                                                                            "v-form",
                                                                                            {
                                                                                              ref: "multipliersForm",
                                                                                              model:
                                                                                                {
                                                                                                  value:
                                                                                                    _vm.multipliersForm,
                                                                                                  callback:
                                                                                                    function (
                                                                                                      $$v
                                                                                                    ) {
                                                                                                      _vm.multipliersForm =
                                                                                                        $$v
                                                                                                    },
                                                                                                  expression:
                                                                                                    "multipliersForm",
                                                                                                },
                                                                                            },
                                                                                            _vm._l(
                                                                                              _vm
                                                                                                .currentDefinition
                                                                                                .configuration
                                                                                                .Analytics
                                                                                                .SymbolsMultipliers,
                                                                                              function (
                                                                                                multiplier
                                                                                              ) {
                                                                                                return _c(
                                                                                                  "v-row",
                                                                                                  {
                                                                                                    key: multiplier.id,
                                                                                                    staticClass:
                                                                                                      "pa-1 mx-0",
                                                                                                    staticStyle:
                                                                                                      {
                                                                                                        "margin-top":
                                                                                                          "-4px",
                                                                                                        "border-top":
                                                                                                          "none !important",
                                                                                                        "background-color":
                                                                                                          "#262b2e",
                                                                                                      },
                                                                                                  },
                                                                                                  [
                                                                                                    _c(
                                                                                                      "v-text-field",
                                                                                                      {
                                                                                                        staticClass:
                                                                                                          "mini-text-field mr-1",
                                                                                                        staticStyle:
                                                                                                          {
                                                                                                            width:
                                                                                                              "100px !important",
                                                                                                          },
                                                                                                        attrs:
                                                                                                          {
                                                                                                            outlined:
                                                                                                              "",
                                                                                                            dense:
                                                                                                              "",
                                                                                                            label:
                                                                                                              "Symbol",
                                                                                                            rules:
                                                                                                              [
                                                                                                                _vm
                                                                                                                  .rules
                                                                                                                  .required,
                                                                                                              ],
                                                                                                          },
                                                                                                        model:
                                                                                                          {
                                                                                                            value:
                                                                                                              multiplier
                                                                                                                .details[0],
                                                                                                            callback:
                                                                                                              function (
                                                                                                                $$v
                                                                                                              ) {
                                                                                                                _vm.$set(
                                                                                                                  multiplier.details,
                                                                                                                  0,
                                                                                                                  $$v
                                                                                                                )
                                                                                                              },
                                                                                                            expression:
                                                                                                              "multiplier.details[0]",
                                                                                                          },
                                                                                                      }
                                                                                                    ),
                                                                                                    _c(
                                                                                                      "v-text-field",
                                                                                                      {
                                                                                                        staticClass:
                                                                                                          "mini-text-field mx-1",
                                                                                                        staticStyle:
                                                                                                          {
                                                                                                            width:
                                                                                                              "100px !important",
                                                                                                            "border-top":
                                                                                                              "none !important",
                                                                                                          },
                                                                                                        attrs:
                                                                                                          {
                                                                                                            type: "number",
                                                                                                            outlined:
                                                                                                              "",
                                                                                                            dense:
                                                                                                              "",
                                                                                                            label:
                                                                                                              "Multiplier",
                                                                                                            rules:
                                                                                                              [
                                                                                                                _vm
                                                                                                                  .rules
                                                                                                                  .required,
                                                                                                              ],
                                                                                                          },
                                                                                                        model:
                                                                                                          {
                                                                                                            value:
                                                                                                              multiplier
                                                                                                                .details[1],
                                                                                                            callback:
                                                                                                              function (
                                                                                                                $$v
                                                                                                              ) {
                                                                                                                _vm.$set(
                                                                                                                  multiplier.details,
                                                                                                                  1,
                                                                                                                  _vm._n(
                                                                                                                    $$v
                                                                                                                  )
                                                                                                                )
                                                                                                              },
                                                                                                            expression:
                                                                                                              "multiplier.details[1]",
                                                                                                          },
                                                                                                      }
                                                                                                    ),
                                                                                                    _c(
                                                                                                      "v-tooltip",
                                                                                                      {
                                                                                                        attrs:
                                                                                                          {
                                                                                                            disabled:
                                                                                                              _vm.isNotDesktop,
                                                                                                            "content-class":
                                                                                                              "tooltipClassBig",
                                                                                                            bottom:
                                                                                                              "",
                                                                                                          },
                                                                                                        scopedSlots:
                                                                                                          _vm._u(
                                                                                                            [
                                                                                                              {
                                                                                                                key: "activator",
                                                                                                                fn: function ({
                                                                                                                  on,
                                                                                                                }) {
                                                                                                                  return [
                                                                                                                    _c(
                                                                                                                      "v-btn",
                                                                                                                      _vm._g(
                                                                                                                        {
                                                                                                                          staticStyle:
                                                                                                                            {
                                                                                                                              "margin-top":
                                                                                                                                "1px",
                                                                                                                            },
                                                                                                                          attrs:
                                                                                                                            {
                                                                                                                              small:
                                                                                                                                "",
                                                                                                                              icon: "",
                                                                                                                            },
                                                                                                                          on: {
                                                                                                                            click:
                                                                                                                              function (
                                                                                                                                $event
                                                                                                                              ) {
                                                                                                                                return _vm.deleteMultiplier(
                                                                                                                                  multiplier.id
                                                                                                                                )
                                                                                                                              },
                                                                                                                          },
                                                                                                                        },
                                                                                                                        on
                                                                                                                      ),
                                                                                                                      [
                                                                                                                        _c(
                                                                                                                          "span",
                                                                                                                          {
                                                                                                                            staticClass:
                                                                                                                              "icon-delete-21x21",
                                                                                                                            staticStyle:
                                                                                                                              {
                                                                                                                                "font-size":
                                                                                                                                  "27px",
                                                                                                                                "margin-bottom":
                                                                                                                                  "2px",
                                                                                                                              },
                                                                                                                          },
                                                                                                                          [
                                                                                                                            _c(
                                                                                                                              "span",
                                                                                                                              {
                                                                                                                                staticClass:
                                                                                                                                  "path1 letterSpacing0",
                                                                                                                              }
                                                                                                                            ),
                                                                                                                            _c(
                                                                                                                              "span",
                                                                                                                              {
                                                                                                                                staticClass:
                                                                                                                                  "path2",
                                                                                                                              }
                                                                                                                            ),
                                                                                                                          ]
                                                                                                                        ),
                                                                                                                      ]
                                                                                                                    ),
                                                                                                                  ]
                                                                                                                },
                                                                                                              },
                                                                                                            ],
                                                                                                            null,
                                                                                                            true
                                                                                                          ),
                                                                                                      },
                                                                                                      [
                                                                                                        _c(
                                                                                                          "span",
                                                                                                          [
                                                                                                            _vm._v(
                                                                                                              " Delete "
                                                                                                            ),
                                                                                                          ]
                                                                                                        ),
                                                                                                      ]
                                                                                                    ),
                                                                                                  ],
                                                                                                  1
                                                                                                )
                                                                                              }
                                                                                            ),
                                                                                            1
                                                                                          ),
                                                                                        ],
                                                                                        1
                                                                                      ),
                                                                                    ]
                                                                                  },
                                                                                  proxy: true,
                                                                                },
                                                                                {
                                                                                  key: "item",
                                                                                  fn: function ({
                                                                                    item,
                                                                                  }) {
                                                                                    return [
                                                                                      _c(
                                                                                        "p",
                                                                                        {
                                                                                          staticClass:
                                                                                            "mb-0",
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              item.text
                                                                                            )
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                    ]
                                                                                  },
                                                                                },
                                                                              ],
                                                                              null,
                                                                              true
                                                                            ),
                                                                        },
                                                                        on
                                                                      )
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        false,
                                                        790846575
                                                      ),
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          " Set custom multipliers for symbols that reference subdivisions"
                                                        ),
                                                        _c("br"),
                                                        _vm._v(
                                                          "of a currency (eg cents instead of GBP) "
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm.isAdmin
                                                ? _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "py-0",
                                                      attrs: {
                                                        cols: "12",
                                                        sm: "6",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              _vm.isNotDesktop,
                                                            "content-class":
                                                              "tooltipClassBig",
                                                            bottom: "",
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "activator",
                                                                fn: function ({
                                                                  on,
                                                                }) {
                                                                  return [
                                                                    _c(
                                                                      "div",
                                                                      _vm._g(
                                                                        {},
                                                                        on
                                                                      ),
                                                                      [
                                                                        _c(
                                                                          "v-text-field",
                                                                          {
                                                                            staticClass:
                                                                              "analyticsTextFieldClass",
                                                                            attrs:
                                                                              {
                                                                                dense:
                                                                                  "",
                                                                                outlined:
                                                                                  "",
                                                                                type: "number",
                                                                                label:
                                                                                  "Calculation Currency Digits",
                                                                              },
                                                                            model:
                                                                              {
                                                                                value:
                                                                                  _vm
                                                                                    .currentDefinition
                                                                                    .configuration
                                                                                    .Analytics
                                                                                    .CalculationCurrencyDigits,
                                                                                callback:
                                                                                  function (
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.$set(
                                                                                      _vm
                                                                                        .currentDefinition
                                                                                        .configuration
                                                                                        .Analytics,
                                                                                      "CalculationCurrencyDigits",
                                                                                      _vm._n(
                                                                                        $$v
                                                                                      )
                                                                                    )
                                                                                  },
                                                                                expression:
                                                                                  "\n                                currentDefinition.configuration.Analytics\n                                  .CalculationCurrencyDigits\n                              ",
                                                                              },
                                                                          }
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            false,
                                                            3104592855
                                                          ),
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              " Digits for CalculationCurrency "
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "h2",
                                            {
                                              staticClass:
                                                "agent-config-category pl-2",
                                            },
                                            [_vm._v("Users")]
                                          ),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "py-0",
                                                  attrs: {
                                                    cols: "12",
                                                    sm: "6",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: {
                                                        disabled:
                                                          _vm.isNotDesktop,
                                                        "content-class":
                                                          "tooltipClassBig",
                                                        bottom: "",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function ({
                                                              on,
                                                            }) {
                                                              return [
                                                                _c(
                                                                  "div",
                                                                  _vm._g(
                                                                    {},
                                                                    on
                                                                  ),
                                                                  [
                                                                    _c(
                                                                      "v-select",
                                                                      _vm._g(
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              outlined:
                                                                                "",
                                                                              dense:
                                                                                "",
                                                                              "menu-props":
                                                                                {
                                                                                  offsetY: true,
                                                                                },
                                                                              "item-text":
                                                                                "text",
                                                                              label:
                                                                                "Extract Personal Information",
                                                                              items:
                                                                                [
                                                                                  {
                                                                                    value: true,
                                                                                    text: "Accepted",
                                                                                  },
                                                                                  {
                                                                                    value: false,
                                                                                    text: "Not Accepted",
                                                                                  },
                                                                                ],
                                                                            },
                                                                          scopedSlots:
                                                                            _vm._u(
                                                                              [
                                                                                {
                                                                                  key: "item",
                                                                                  fn: function ({
                                                                                    item,
                                                                                  }) {
                                                                                    return [
                                                                                      _c(
                                                                                        "p",
                                                                                        {
                                                                                          staticClass:
                                                                                            "mb-0",
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              item.text
                                                                                            )
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                    ]
                                                                                  },
                                                                                },
                                                                              ],
                                                                              null,
                                                                              true
                                                                            ),
                                                                          model:
                                                                            {
                                                                              value:
                                                                                _vm
                                                                                  .currentDefinition
                                                                                  .configuration
                                                                                  .Analytics
                                                                                  .PrivacyPolicyAccepted,
                                                                              callback:
                                                                                function (
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    _vm
                                                                                      .currentDefinition
                                                                                      .configuration
                                                                                      .Analytics,
                                                                                    "PrivacyPolicyAccepted",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                              expression:
                                                                                "\n                                currentDefinition.configuration.Analytics\n                                  .PrivacyPolicyAccepted\n                              ",
                                                                            },
                                                                        },
                                                                        on
                                                                      )
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        false,
                                                        2577492684
                                                      ),
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          " Understand and comply with the terms & conditions of the privacy policy "
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "py-0",
                                                  attrs: {
                                                    cols: "12",
                                                    sm: "6",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: {
                                                        disabled:
                                                          _vm.isNotDesktop,
                                                        "content-class":
                                                          "tooltipClassBig",
                                                        bottom: "",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function ({
                                                              on,
                                                            }) {
                                                              return [
                                                                _c(
                                                                  "div",
                                                                  _vm._g(
                                                                    {},
                                                                    on
                                                                  ),
                                                                  [
                                                                    _c(
                                                                      "v-text-field",
                                                                      {
                                                                        staticClass:
                                                                          "analyticsTextFieldClass",
                                                                        attrs: {
                                                                          dense:
                                                                            "",
                                                                          outlined:
                                                                            "",
                                                                          label:
                                                                            "User Synchronization Cycle",
                                                                          type: "number",
                                                                          rules:
                                                                            [
                                                                              _vm
                                                                                .rules
                                                                                .required,
                                                                            ],
                                                                        },
                                                                        on: {
                                                                          keydown:
                                                                            (
                                                                              ev
                                                                            ) =>
                                                                              _vm.setHelperVar(
                                                                                ev,
                                                                                "UserSynchronizationCycleAN"
                                                                              ),
                                                                          keypress:
                                                                            (
                                                                              ev
                                                                            ) =>
                                                                              _vm.setHelperVar(
                                                                                ev,
                                                                                "UserSynchronizationCycleAN"
                                                                              ),
                                                                          input:
                                                                            (
                                                                              ev
                                                                            ) =>
                                                                              _vm.textInput(
                                                                                ev,
                                                                                _vm
                                                                                  .currentDefinition
                                                                                  .configuration,
                                                                                "UserSynchronizationCycle"
                                                                              ),
                                                                          focusout:
                                                                            _vm.clearHelperVar,
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm.UserSynchronizationCycleAN,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.UserSynchronizationCycleAN =
                                                                                _vm._n(
                                                                                  $$v
                                                                                )
                                                                            },
                                                                          expression:
                                                                            "UserSynchronizationCycleAN",
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        false,
                                                        1683120360
                                                      ),
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          " Period of time in seconds to store a snapshot of users in database "
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "py-0",
                                                  attrs: {
                                                    cols: "12",
                                                    sm: "6",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: {
                                                        disabled:
                                                          _vm.isNotDesktop,
                                                        "content-class":
                                                          "tooltipClassBig",
                                                        bottom: "",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function ({
                                                              on,
                                                            }) {
                                                              return [
                                                                _c(
                                                                  "div",
                                                                  _vm._g(
                                                                    {},
                                                                    on
                                                                  ),
                                                                  [
                                                                    _c(
                                                                      "v-text-field",
                                                                      {
                                                                        staticClass:
                                                                          "analyticsTextFieldClass",
                                                                        attrs: {
                                                                          dense:
                                                                            "",
                                                                          outlined:
                                                                            "",
                                                                          label:
                                                                            "User ID Extraction Regex",
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .currentDefinition
                                                                              .configuration
                                                                              .Analytics
                                                                              .UserIdExtractRegex,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm
                                                                                  .currentDefinition
                                                                                  .configuration
                                                                                  .Analytics,
                                                                                "UserIdExtractRegex",
                                                                                $$v
                                                                              )
                                                                            },
                                                                          expression:
                                                                            "\n                                currentDefinition.configuration.Analytics\n                                  .UserIdExtractRegex\n                              ",
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        false,
                                                        2951639490
                                                      ),
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          " The regular expression which will be used to extract the actual ID from the User ID field "
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm.isAdmin
                                                ? _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "py-0",
                                                      attrs: {
                                                        cols: "12",
                                                        sm: "6",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              _vm.isNotDesktop,
                                                            "content-class":
                                                              "tooltipClassBig",
                                                            bottom: "",
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "activator",
                                                                fn: function ({
                                                                  on,
                                                                }) {
                                                                  return [
                                                                    _c(
                                                                      "div",
                                                                      _vm._g(
                                                                        {},
                                                                        on
                                                                      ),
                                                                      [
                                                                        _c(
                                                                          "v-select",
                                                                          _vm._g(
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  outlined:
                                                                                    "",
                                                                                  dense:
                                                                                    "",
                                                                                  "menu-props":
                                                                                    {
                                                                                      offsetY: true,
                                                                                    },
                                                                                  "item-text":
                                                                                    "text",
                                                                                  label:
                                                                                    "Delete Old Users From The Database",
                                                                                  items:
                                                                                    [
                                                                                      {
                                                                                        value: true,
                                                                                        text: "Yes",
                                                                                      },
                                                                                      {
                                                                                        value: false,
                                                                                        text: "No",
                                                                                      },
                                                                                    ],
                                                                                },
                                                                              scopedSlots:
                                                                                _vm._u(
                                                                                  [
                                                                                    {
                                                                                      key: "item",
                                                                                      fn: function ({
                                                                                        item,
                                                                                      }) {
                                                                                        return [
                                                                                          _c(
                                                                                            "p",
                                                                                            {
                                                                                              staticClass:
                                                                                                "mb-0",
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                _vm._s(
                                                                                                  item.text
                                                                                                )
                                                                                              ),
                                                                                            ]
                                                                                          ),
                                                                                        ]
                                                                                      },
                                                                                    },
                                                                                  ],
                                                                                  null,
                                                                                  true
                                                                                ),
                                                                              model:
                                                                                {
                                                                                  value:
                                                                                    _vm
                                                                                      .currentDefinition
                                                                                      .configuration
                                                                                      .Analytics
                                                                                      .DeleteOldUsersFromDb,
                                                                                  callback:
                                                                                    function (
                                                                                      $$v
                                                                                    ) {
                                                                                      _vm.$set(
                                                                                        _vm
                                                                                          .currentDefinition
                                                                                          .configuration
                                                                                          .Analytics,
                                                                                        "DeleteOldUsersFromDb",
                                                                                        $$v
                                                                                      )
                                                                                    },
                                                                                  expression:
                                                                                    "\n                                currentDefinition.configuration.Analytics\n                                  .DeleteOldUsersFromDb\n                              ",
                                                                                },
                                                                            },
                                                                            on
                                                                          )
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            false,
                                                            1375950195
                                                          ),
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              " If true old users will be deleted form the"
                                                            ),
                                                            _c("br"),
                                                            _vm._v(
                                                              "database on next users persist cycle "
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.isAdmin
                                                ? _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "py-0",
                                                      attrs: {
                                                        cols: "12",
                                                        sm: "6",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              _vm.isNotDesktop,
                                                            "content-class":
                                                              "tooltipClassBig",
                                                            bottom: "",
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "activator",
                                                                fn: function ({
                                                                  on,
                                                                }) {
                                                                  return [
                                                                    _c(
                                                                      "v-select",
                                                                      _vm._g(
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              outlined:
                                                                                "",
                                                                              dense:
                                                                                "",
                                                                              "menu-props":
                                                                                {
                                                                                  offsetY: true,
                                                                                },
                                                                              "item-text":
                                                                                "text",
                                                                              label:
                                                                                "Ignore Unmodified Users",
                                                                              items:
                                                                                [
                                                                                  {
                                                                                    value: true,
                                                                                    text: "Yes",
                                                                                  },
                                                                                  {
                                                                                    value: false,
                                                                                    text: "No",
                                                                                  },
                                                                                ],
                                                                            },
                                                                          scopedSlots:
                                                                            _vm._u(
                                                                              [
                                                                                {
                                                                                  key: "item",
                                                                                  fn: function ({
                                                                                    item,
                                                                                  }) {
                                                                                    return [
                                                                                      _c(
                                                                                        "p",
                                                                                        {
                                                                                          staticClass:
                                                                                            "mb-0",
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              item.text
                                                                                            )
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                    ]
                                                                                  },
                                                                                },
                                                                              ],
                                                                              null,
                                                                              true
                                                                            ),
                                                                          model:
                                                                            {
                                                                              value:
                                                                                _vm
                                                                                  .currentDefinition
                                                                                  .configuration
                                                                                  .Analytics
                                                                                  .IgnoreUnmodifiedUsers,
                                                                              callback:
                                                                                function (
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    _vm
                                                                                      .currentDefinition
                                                                                      .configuration
                                                                                      .Analytics,
                                                                                    "IgnoreUnmodifiedUsers",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                              expression:
                                                                                "\n                              currentDefinition.configuration.Analytics\n                                .IgnoreUnmodifiedUsers\n                            ",
                                                                            },
                                                                        },
                                                                        on
                                                                      )
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            false,
                                                            1265399526
                                                          ),
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              " Indicates where to skip saving users to the db that where not modified since last cycle "
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.isAdmin
                                                ? _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "py-0",
                                                      attrs: {
                                                        cols: "12",
                                                        sm: "6",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              _vm.isNotDesktop,
                                                            "content-class":
                                                              "tooltipClassBig",
                                                            bottom: "",
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "activator",
                                                                fn: function ({
                                                                  on,
                                                                }) {
                                                                  return [
                                                                    _c(
                                                                      "div",
                                                                      _vm._g(
                                                                        {},
                                                                        on
                                                                      ),
                                                                      [
                                                                        _c(
                                                                          "v-text-field",
                                                                          {
                                                                            staticClass:
                                                                              "analyticsTextFieldClass",
                                                                            attrs:
                                                                              {
                                                                                dense:
                                                                                  "",
                                                                                outlined:
                                                                                  "",
                                                                                label:
                                                                                  "Users Prepared Statement Limit",
                                                                                type: "number",
                                                                              },
                                                                            model:
                                                                              {
                                                                                value:
                                                                                  _vm
                                                                                    .currentDefinition
                                                                                    .configuration
                                                                                    .Analytics
                                                                                    .UsersPreparedStatementLimit,
                                                                                callback:
                                                                                  function (
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.$set(
                                                                                      _vm
                                                                                        .currentDefinition
                                                                                        .configuration
                                                                                        .Analytics,
                                                                                      "UsersPreparedStatementLimit",
                                                                                      _vm._n(
                                                                                        $$v
                                                                                      )
                                                                                    )
                                                                                  },
                                                                                expression:
                                                                                  "\n                                currentDefinition.configuration.Analytics\n                                  .UsersPreparedStatementLimit\n                              ",
                                                                              },
                                                                          }
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            false,
                                                            2832143703
                                                          ),
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              " Deciding factor when to use prepared statement or copy for users persistence. "
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "h2",
                                            {
                                              staticClass:
                                                "agent-config-category pl-2",
                                            },
                                            [_vm._v("Daily Reports")]
                                          ),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "py-0",
                                                  attrs: {
                                                    cols: "12",
                                                    sm: "6",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: {
                                                        disabled:
                                                          _vm.isNotDesktop,
                                                        "content-class":
                                                          "tooltipClassBig",
                                                        bottom: "",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function ({
                                                              on,
                                                            }) {
                                                              return [
                                                                _c(
                                                                  "v-text-field",
                                                                  _vm._g(
                                                                    {
                                                                      staticClass:
                                                                        "analyticsTextFieldClass",
                                                                      attrs: {
                                                                        dense:
                                                                          "",
                                                                        outlined:
                                                                          "",
                                                                        label:
                                                                          "Daily reports fetch offset time",
                                                                        type: "number",
                                                                        rules: [
                                                                          _vm
                                                                            .rules
                                                                            .required,
                                                                        ],
                                                                      },
                                                                      on: {
                                                                        keydown:
                                                                          (
                                                                            ev
                                                                          ) =>
                                                                            _vm.setHelperVar(
                                                                              ev,
                                                                              "DailyReportsFetchOffsetTime"
                                                                            ),
                                                                        keypress:
                                                                          (
                                                                            ev
                                                                          ) =>
                                                                            _vm.setHelperVar(
                                                                              ev,
                                                                              "DailyReportsFetchOffsetTime"
                                                                            ),
                                                                        input: (
                                                                          ev
                                                                        ) =>
                                                                          _vm.textInput(
                                                                            ev,
                                                                            _vm
                                                                              .currentDefinition
                                                                              .configuration,
                                                                            "DailyReportsFetchOffsetTime"
                                                                          ),
                                                                        focusout:
                                                                          _vm.clearHelperVar,
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          _vm.DailyReportsFetchOffsetTime,
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.DailyReportsFetchOffsetTime =
                                                                              _vm._n(
                                                                                $$v
                                                                              )
                                                                          },
                                                                        expression:
                                                                          "DailyReportsFetchOffsetTime",
                                                                      },
                                                                    },
                                                                    on
                                                                  )
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        false,
                                                        2694893839
                                                      ),
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          " Duration in minutes to delay fetch daily reports from "
                                                        ),
                                                        _c("br"),
                                                        _vm._v(
                                                          "server, this useful for slow servers that take "
                                                        ),
                                                        _c("br"),
                                                        _vm._v(
                                                          "time to complete roll over operations. "
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "py-0",
                                                  attrs: {
                                                    cols: "12",
                                                    sm: "6",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: {
                                                        disabled:
                                                          _vm.isNotDesktop,
                                                        "content-class":
                                                          "tooltipClassBig",
                                                        bottom: "",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function ({
                                                              on,
                                                            }) {
                                                              return [
                                                                _c(
                                                                  "div",
                                                                  _vm._g(
                                                                    {},
                                                                    on
                                                                  ),
                                                                  [
                                                                    _c(
                                                                      "v-text-field",
                                                                      {
                                                                        staticClass:
                                                                          "analyticsTextFieldClass",
                                                                        attrs: {
                                                                          dense:
                                                                            "",
                                                                          outlined:
                                                                            "",
                                                                          label:
                                                                            "Daily Profit Synchronization Cycle",
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .currentDefinition
                                                                              .configuration
                                                                              .Analytics
                                                                              .DailyProfitSynchronizationCycle,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm
                                                                                  .currentDefinition
                                                                                  .configuration
                                                                                  .Analytics,
                                                                                "DailyProfitSynchronizationCycle",
                                                                                $$v
                                                                              )
                                                                            },
                                                                          expression:
                                                                            "\n                                currentDefinition.configuration.Analytics\n                                  .DailyProfitSynchronizationCycle\n                              ",
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        false,
                                                        1302802474
                                                      ),
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          " Time interval to check and fetch daily reports in seconds "
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "py-0",
                                                  attrs: {
                                                    cols: "12",
                                                    sm: "6",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: {
                                                        disabled:
                                                          _vm.isNotDesktop,
                                                        "content-class":
                                                          "tooltipClassBig",
                                                        bottom: "",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function ({
                                                              on,
                                                            }) {
                                                              return [
                                                                _c(
                                                                  "div",
                                                                  _vm._g(
                                                                    {},
                                                                    on
                                                                  ),
                                                                  [
                                                                    _c(
                                                                      "v-text-field",
                                                                      {
                                                                        staticClass:
                                                                          "analyticsTextFieldClass",
                                                                        attrs: {
                                                                          dense:
                                                                            "",
                                                                          outlined:
                                                                            "",
                                                                          label:
                                                                            "Default Prefetch Daily Reports",
                                                                          type: "number",
                                                                          rules:
                                                                            [
                                                                              _vm
                                                                                .rules
                                                                                .required,
                                                                            ],
                                                                        },
                                                                        on: {
                                                                          keydown:
                                                                            (
                                                                              ev
                                                                            ) =>
                                                                              _vm.setHelperVar(
                                                                                ev,
                                                                                "DefaultPrefetchDailyReports"
                                                                              ),
                                                                          keypress:
                                                                            (
                                                                              ev
                                                                            ) =>
                                                                              _vm.setHelperVar(
                                                                                ev,
                                                                                "DefaultPrefetchDailyReports"
                                                                              ),
                                                                          input:
                                                                            (
                                                                              ev
                                                                            ) =>
                                                                              _vm.textInput(
                                                                                ev,
                                                                                _vm
                                                                                  .currentDefinition
                                                                                  .configuration,
                                                                                "TradesLingerTime"
                                                                              ),
                                                                          focusout:
                                                                            _vm.clearHelperVar,
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .currentDefinition
                                                                              .configuration
                                                                              .Analytics
                                                                              .DefaultPrefetchDailyReports,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm
                                                                                  .currentDefinition
                                                                                  .configuration
                                                                                  .Analytics,
                                                                                "DefaultPrefetchDailyReports",
                                                                                _vm._n(
                                                                                  $$v
                                                                                )
                                                                              )
                                                                            },
                                                                          expression:
                                                                            "\n                                currentDefinition.configuration.Analytics\n                                  .DefaultPrefetchDailyReports\n                              ",
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        false,
                                                        3455304861
                                                      ),
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          " Default number of daily reports to fetch if none exists in the database "
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "py-0",
                                                  attrs: {
                                                    cols: "12",
                                                    sm: "6",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: {
                                                        disabled:
                                                          _vm.isNotDesktop,
                                                        "content-class":
                                                          "tooltipClassBig",
                                                        bottom: "",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function ({
                                                              on,
                                                            }) {
                                                              return [
                                                                _c(
                                                                  "div",
                                                                  _vm._g(
                                                                    {},
                                                                    on
                                                                  ),
                                                                  [
                                                                    _c(
                                                                      "v-select",
                                                                      _vm._g(
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              outlined:
                                                                                "",
                                                                              dense:
                                                                                "",
                                                                              "menu-props":
                                                                                {
                                                                                  offsetY: true,
                                                                                },
                                                                              "item-text":
                                                                                "text",
                                                                              label:
                                                                                "Ignore Empty Daily Reports",
                                                                              items:
                                                                                [
                                                                                  {
                                                                                    value: true,
                                                                                    text: "Ignore",
                                                                                  },
                                                                                  {
                                                                                    value: false,
                                                                                    text: "Don't ignore",
                                                                                  },
                                                                                ],
                                                                            },
                                                                          scopedSlots:
                                                                            _vm._u(
                                                                              [
                                                                                {
                                                                                  key: "item",
                                                                                  fn: function ({
                                                                                    item,
                                                                                  }) {
                                                                                    return [
                                                                                      _c(
                                                                                        "p",
                                                                                        {
                                                                                          staticClass:
                                                                                            "mb-0",
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              item.text
                                                                                            )
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                    ]
                                                                                  },
                                                                                },
                                                                              ],
                                                                              null,
                                                                              true
                                                                            ),
                                                                          model:
                                                                            {
                                                                              value:
                                                                                _vm
                                                                                  .currentDefinition
                                                                                  .configuration
                                                                                  .Analytics
                                                                                  .IgnoreEmptyDailyReports,
                                                                              callback:
                                                                                function (
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    _vm
                                                                                      .currentDefinition
                                                                                      .configuration
                                                                                      .Analytics,
                                                                                    "IgnoreEmptyDailyReports",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                              expression:
                                                                                "\n                                currentDefinition.configuration.Analytics\n                                  .IgnoreEmptyDailyReports\n                              ",
                                                                            },
                                                                        },
                                                                        on
                                                                      )
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        false,
                                                        2112125677
                                                      ),
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          " Ignore storing daily profits for accounts where equity/floating or settle pnl is 0 "
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm.isAdmin
                                            ? _c(
                                                "h2",
                                                {
                                                  staticClass:
                                                    "agent-config-category pl-2",
                                                },
                                                [_vm._v(" Journal ")]
                                              )
                                            : _vm._e(),
                                          _vm.isAdmin
                                            ? _c(
                                                "v-row",
                                                [
                                                  _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "py-0",
                                                      attrs: {
                                                        cols: "12",
                                                        sm: "6",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              _vm.isNotDesktop,
                                                            "content-class":
                                                              "tooltipClass",
                                                            bottom: "",
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "activator",
                                                                fn: function ({
                                                                  on,
                                                                }) {
                                                                  return [
                                                                    _c(
                                                                      "v-text-field",
                                                                      _vm._g(
                                                                        {
                                                                          staticClass:
                                                                            "analyticsTextFieldClass",
                                                                          attrs:
                                                                            {
                                                                              rules:
                                                                                [
                                                                                  _vm
                                                                                    .rules
                                                                                    .required,
                                                                                ],
                                                                              dense:
                                                                                "",
                                                                              outlined:
                                                                                "",
                                                                              label:
                                                                                "Default Prefetch Journal",
                                                                              type: "number",
                                                                            },
                                                                          model:
                                                                            {
                                                                              value:
                                                                                _vm.DefaultPrefetchJournal,
                                                                              callback:
                                                                                function (
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.DefaultPrefetchJournal =
                                                                                    _vm._n(
                                                                                      $$v
                                                                                    )
                                                                                },
                                                                              expression:
                                                                                "DefaultPrefetchJournal",
                                                                            },
                                                                        },
                                                                        on
                                                                      )
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            false,
                                                            2205194857
                                                          ),
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              " How many days of journal logs to fetch on the first run. "
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "py-0",
                                                      attrs: {
                                                        cols: "12",
                                                        sm: "6",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              _vm.isNotDesktop,
                                                            "content-class":
                                                              "tooltipClass",
                                                            bottom: "",
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "activator",
                                                                fn: function ({
                                                                  on,
                                                                }) {
                                                                  return [
                                                                    _c(
                                                                      "v-text-field",
                                                                      _vm._g(
                                                                        {
                                                                          staticClass:
                                                                            "analyticsTextFieldClass",
                                                                          attrs:
                                                                            {
                                                                              rules:
                                                                                [
                                                                                  _vm
                                                                                    .rules
                                                                                    .required,
                                                                                ],
                                                                              dense:
                                                                                "",
                                                                              outlined:
                                                                                "",
                                                                              label:
                                                                                "Journal Fetch Offset Time",
                                                                              type: "number",
                                                                            },
                                                                          model:
                                                                            {
                                                                              value:
                                                                                _vm.JournalFetchOffsetTime,
                                                                              callback:
                                                                                function (
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.JournalFetchOffsetTime =
                                                                                    _vm._n(
                                                                                      $$v
                                                                                    )
                                                                                },
                                                                              expression:
                                                                                "JournalFetchOffsetTime",
                                                                            },
                                                                        },
                                                                        on
                                                                      )
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            false,
                                                            3869917865
                                                          ),
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              " Delay the duration of journal requests by minutes starting from midnight. "
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm.isAdmin
                                            ? _c(
                                                "v-row",
                                                [
                                                  _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "py-0",
                                                      attrs: {
                                                        cols: "12",
                                                        sm: "6",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              _vm.isNotDesktop,
                                                            "content-class":
                                                              "tooltipClassBig",
                                                            bottom: "",
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "activator",
                                                                fn: function ({
                                                                  on,
                                                                }) {
                                                                  return [
                                                                    _c(
                                                                      "div",
                                                                      _vm._g(
                                                                        {},
                                                                        on
                                                                      ),
                                                                      [
                                                                        _c(
                                                                          "v-select",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                items:
                                                                                  [
                                                                                    "Filters",
                                                                                  ],
                                                                                outlined:
                                                                                  "",
                                                                                dense:
                                                                                  "",
                                                                                "menu-props":
                                                                                  {
                                                                                    offsetY: true,
                                                                                    closeOnClick: false,
                                                                                    closeOnContentClick: false,
                                                                                  },
                                                                                "item-text":
                                                                                  "text",
                                                                                label:
                                                                                  "Journal Filters",
                                                                                "hide-selected":
                                                                                  "",
                                                                              },
                                                                            scopedSlots:
                                                                              _vm._u(
                                                                                [
                                                                                  {
                                                                                    key: "item",
                                                                                    fn: function ({}) {
                                                                                      return [
                                                                                        _c(
                                                                                          "div",
                                                                                          {
                                                                                            staticStyle:
                                                                                              {
                                                                                                "border-top":
                                                                                                  "none !important",
                                                                                              },
                                                                                          }
                                                                                        ),
                                                                                      ]
                                                                                    },
                                                                                  },
                                                                                  {
                                                                                    key: "no-data",
                                                                                    fn: function () {
                                                                                      return [
                                                                                        _c(
                                                                                          "div",
                                                                                          {
                                                                                            staticStyle:
                                                                                              {
                                                                                                "border-top":
                                                                                                  "none !important",
                                                                                              },
                                                                                          }
                                                                                        ),
                                                                                      ]
                                                                                    },
                                                                                    proxy: true,
                                                                                  },
                                                                                  {
                                                                                    key: "prepend-item",
                                                                                    fn: function () {
                                                                                      return [
                                                                                        _c(
                                                                                          "v-list-item",
                                                                                          {
                                                                                            staticStyle:
                                                                                              {
                                                                                                "max-height":
                                                                                                  "40px",
                                                                                                "border-bottom":
                                                                                                  "1px solid #7f7f7f",
                                                                                              },
                                                                                            attrs:
                                                                                              {
                                                                                                ripple:
                                                                                                  "",
                                                                                              },
                                                                                            on: {
                                                                                              click:
                                                                                                _vm.addJournalFilter,
                                                                                            },
                                                                                          },
                                                                                          [
                                                                                            _c(
                                                                                              "v-list-item-content",
                                                                                              [
                                                                                                _c(
                                                                                                  "v-list-item-title",
                                                                                                  {
                                                                                                    staticStyle:
                                                                                                      {
                                                                                                        "font-size":
                                                                                                          "14px !important",
                                                                                                        "font-weight":
                                                                                                          "400",
                                                                                                      },
                                                                                                  },
                                                                                                  [
                                                                                                    _c(
                                                                                                      "i",
                                                                                                      {
                                                                                                        staticClass:
                                                                                                          "fas fa-plus-circle mr-1",
                                                                                                        staticStyle:
                                                                                                          {
                                                                                                            color:
                                                                                                              "#47bd96",
                                                                                                          },
                                                                                                      }
                                                                                                    ),
                                                                                                    _vm._v(
                                                                                                      " Add filter "
                                                                                                    ),
                                                                                                  ]
                                                                                                ),
                                                                                              ],
                                                                                              1
                                                                                            ),
                                                                                          ],
                                                                                          1
                                                                                        ),
                                                                                      ]
                                                                                    },
                                                                                    proxy: true,
                                                                                  },
                                                                                  {
                                                                                    key: "append-item",
                                                                                    fn: function () {
                                                                                      return [
                                                                                        _c(
                                                                                          "div",
                                                                                          {
                                                                                            staticStyle:
                                                                                              {
                                                                                                "max-height":
                                                                                                  "209px",
                                                                                                "border-top":
                                                                                                  "none !important",
                                                                                              },
                                                                                          },
                                                                                          _vm._l(
                                                                                            _vm
                                                                                              .currentDefinition
                                                                                              .configuration
                                                                                              .Analytics
                                                                                              .JournalFilters,
                                                                                            function (
                                                                                              filter
                                                                                            ) {
                                                                                              return _c(
                                                                                                "v-row",
                                                                                                {
                                                                                                  key: filter.id,
                                                                                                  staticClass:
                                                                                                    "mx-4 mb-0",
                                                                                                  staticStyle:
                                                                                                    {
                                                                                                      "border-top":
                                                                                                        "none !important",
                                                                                                      height:
                                                                                                        "40px",
                                                                                                    },
                                                                                                },
                                                                                                [
                                                                                                  _c(
                                                                                                    "p",
                                                                                                    {
                                                                                                      staticClass:
                                                                                                        "pt-2 mb-0",
                                                                                                    },
                                                                                                    [
                                                                                                      _vm._v(
                                                                                                        " " +
                                                                                                          _vm._s(
                                                                                                            filter.Name
                                                                                                          ) +
                                                                                                          " "
                                                                                                      ),
                                                                                                    ]
                                                                                                  ),
                                                                                                  _c(
                                                                                                    "v-spacer"
                                                                                                  ),
                                                                                                  _c(
                                                                                                    "v-tooltip",
                                                                                                    {
                                                                                                      attrs:
                                                                                                        {
                                                                                                          disabled:
                                                                                                            _vm.isNotDesktop,
                                                                                                          bottom:
                                                                                                            "",
                                                                                                        },
                                                                                                      scopedSlots:
                                                                                                        _vm._u(
                                                                                                          [
                                                                                                            {
                                                                                                              key: "activator",
                                                                                                              fn: function ({
                                                                                                                on,
                                                                                                              }) {
                                                                                                                return [
                                                                                                                  _c(
                                                                                                                    "v-btn",
                                                                                                                    _vm._g(
                                                                                                                      {
                                                                                                                        staticClass:
                                                                                                                          "pt-2 mr-1",
                                                                                                                        staticStyle:
                                                                                                                          {
                                                                                                                            "margin-top":
                                                                                                                              "1px",
                                                                                                                          },
                                                                                                                        attrs:
                                                                                                                          {
                                                                                                                            small:
                                                                                                                              "",
                                                                                                                            icon: "",
                                                                                                                          },
                                                                                                                        on: {
                                                                                                                          click:
                                                                                                                            function (
                                                                                                                              $event
                                                                                                                            ) {
                                                                                                                              return _vm.editJournalFilter(
                                                                                                                                filter
                                                                                                                              )
                                                                                                                            },
                                                                                                                        },
                                                                                                                      },
                                                                                                                      on
                                                                                                                    ),
                                                                                                                    [
                                                                                                                      _c(
                                                                                                                        "span",
                                                                                                                        {
                                                                                                                          staticClass:
                                                                                                                            "icon-edit-21x21",
                                                                                                                          staticStyle:
                                                                                                                            {
                                                                                                                              "font-size":
                                                                                                                                "27px",
                                                                                                                              "margin-bottom":
                                                                                                                                "2px",
                                                                                                                            },
                                                                                                                        },
                                                                                                                        [
                                                                                                                          _c(
                                                                                                                            "span",
                                                                                                                            {
                                                                                                                              staticClass:
                                                                                                                                "path1 letterSpacing0",
                                                                                                                            }
                                                                                                                          ),
                                                                                                                          _c(
                                                                                                                            "span",
                                                                                                                            {
                                                                                                                              staticClass:
                                                                                                                                "path2",
                                                                                                                            }
                                                                                                                          ),
                                                                                                                        ]
                                                                                                                      ),
                                                                                                                    ]
                                                                                                                  ),
                                                                                                                ]
                                                                                                              },
                                                                                                            },
                                                                                                          ],
                                                                                                          null,
                                                                                                          true
                                                                                                        ),
                                                                                                    },
                                                                                                    [
                                                                                                      _c(
                                                                                                        "span",
                                                                                                        [
                                                                                                          _vm._v(
                                                                                                            " Edit "
                                                                                                          ),
                                                                                                        ]
                                                                                                      ),
                                                                                                    ]
                                                                                                  ),
                                                                                                  _c(
                                                                                                    "v-tooltip",
                                                                                                    {
                                                                                                      attrs:
                                                                                                        {
                                                                                                          disabled:
                                                                                                            _vm.isNotDesktop,
                                                                                                          bottom:
                                                                                                            "",
                                                                                                        },
                                                                                                      scopedSlots:
                                                                                                        _vm._u(
                                                                                                          [
                                                                                                            {
                                                                                                              key: "activator",
                                                                                                              fn: function ({
                                                                                                                on,
                                                                                                              }) {
                                                                                                                return [
                                                                                                                  _c(
                                                                                                                    "v-btn",
                                                                                                                    _vm._g(
                                                                                                                      {
                                                                                                                        staticClass:
                                                                                                                          "pt-2",
                                                                                                                        staticStyle:
                                                                                                                          {
                                                                                                                            "margin-top":
                                                                                                                              "1px",
                                                                                                                          },
                                                                                                                        attrs:
                                                                                                                          {
                                                                                                                            small:
                                                                                                                              "",
                                                                                                                            icon: "",
                                                                                                                          },
                                                                                                                        on: {
                                                                                                                          click:
                                                                                                                            function (
                                                                                                                              $event
                                                                                                                            ) {
                                                                                                                              return _vm.deleteJournalFilter(
                                                                                                                                filter
                                                                                                                              )
                                                                                                                            },
                                                                                                                        },
                                                                                                                      },
                                                                                                                      on
                                                                                                                    ),
                                                                                                                    [
                                                                                                                      _c(
                                                                                                                        "span",
                                                                                                                        {
                                                                                                                          staticClass:
                                                                                                                            "icon-delete-21x21",
                                                                                                                          staticStyle:
                                                                                                                            {
                                                                                                                              "font-size":
                                                                                                                                "27px",
                                                                                                                              "margin-bottom":
                                                                                                                                "2px",
                                                                                                                            },
                                                                                                                        },
                                                                                                                        [
                                                                                                                          _c(
                                                                                                                            "span",
                                                                                                                            {
                                                                                                                              staticClass:
                                                                                                                                "path1 letterSpacing0",
                                                                                                                            }
                                                                                                                          ),
                                                                                                                          _c(
                                                                                                                            "span",
                                                                                                                            {
                                                                                                                              staticClass:
                                                                                                                                "path2",
                                                                                                                            }
                                                                                                                          ),
                                                                                                                        ]
                                                                                                                      ),
                                                                                                                    ]
                                                                                                                  ),
                                                                                                                ]
                                                                                                              },
                                                                                                            },
                                                                                                          ],
                                                                                                          null,
                                                                                                          true
                                                                                                        ),
                                                                                                    },
                                                                                                    [
                                                                                                      _c(
                                                                                                        "span",
                                                                                                        [
                                                                                                          _vm._v(
                                                                                                            " Delete "
                                                                                                          ),
                                                                                                        ]
                                                                                                      ),
                                                                                                    ]
                                                                                                  ),
                                                                                                ],
                                                                                                1
                                                                                              )
                                                                                            }
                                                                                          ),
                                                                                          1
                                                                                        ),
                                                                                      ]
                                                                                    },
                                                                                    proxy: true,
                                                                                  },
                                                                                  {
                                                                                    key: "selection",
                                                                                    fn: function ({}) {
                                                                                      return [
                                                                                        _vm
                                                                                          .currentDefinition
                                                                                          .configuration
                                                                                          .Analytics
                                                                                          .JournalFilters
                                                                                          .length
                                                                                          ? _c(
                                                                                              "div",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "mr-1",
                                                                                              },
                                                                                              [
                                                                                                _c(
                                                                                                  "span",
                                                                                                  [
                                                                                                    _vm._v(
                                                                                                      _vm._s(
                                                                                                        _vm
                                                                                                          .currentDefinition
                                                                                                          .configuration
                                                                                                          .Analytics
                                                                                                          .JournalFilters[0]
                                                                                                          .Name
                                                                                                      )
                                                                                                    ),
                                                                                                  ]
                                                                                                ),
                                                                                              ]
                                                                                            )
                                                                                          : _c(
                                                                                              "label",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "v-label theme--dark",
                                                                                                staticStyle:
                                                                                                  {
                                                                                                    left: "0",
                                                                                                    right:
                                                                                                      "auto",
                                                                                                    position:
                                                                                                      "absolute",
                                                                                                  },
                                                                                              },
                                                                                              [
                                                                                                _vm._v(
                                                                                                  "No Journal Filters"
                                                                                                ),
                                                                                              ]
                                                                                            ),
                                                                                        _vm
                                                                                          .currentDefinition
                                                                                          .configuration
                                                                                          .Analytics
                                                                                          .JournalFilters
                                                                                          .length >
                                                                                        1
                                                                                          ? _c(
                                                                                              "span",
                                                                                              [
                                                                                                _vm._v(
                                                                                                  " (+" +
                                                                                                    _vm._s(
                                                                                                      _vm
                                                                                                        .currentDefinition
                                                                                                        .configuration
                                                                                                        .Analytics
                                                                                                        .JournalFilters
                                                                                                        .length -
                                                                                                        1
                                                                                                    ) +
                                                                                                    ") "
                                                                                                ),
                                                                                              ]
                                                                                            )
                                                                                          : _vm._e(),
                                                                                      ]
                                                                                    },
                                                                                  },
                                                                                ],
                                                                                null,
                                                                                true
                                                                              ),
                                                                            model:
                                                                              {
                                                                                value:
                                                                                  _vm.JournalFiltersModel,
                                                                                callback:
                                                                                  function (
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.JournalFiltersModel =
                                                                                      $$v
                                                                                  },
                                                                                expression:
                                                                                  "JournalFiltersModel",
                                                                              },
                                                                          }
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            false,
                                                            3067715990
                                                          ),
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              " Journal filter configuration "
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "py-0",
                                                      attrs: {
                                                        cols: "12",
                                                        sm: "6",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              _vm.isNotDesktop,
                                                            "content-class":
                                                              "tooltipClass",
                                                            bottom: "",
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "activator",
                                                                fn: function ({
                                                                  on,
                                                                }) {
                                                                  return [
                                                                    _c(
                                                                      "v-text-field",
                                                                      _vm._g(
                                                                        {
                                                                          staticClass:
                                                                            "analyticsTextFieldClass",
                                                                          attrs:
                                                                            {
                                                                              rules:
                                                                                [
                                                                                  _vm
                                                                                    .rules
                                                                                    .required,
                                                                                ],
                                                                              dense:
                                                                                "",
                                                                              outlined:
                                                                                "",
                                                                              label:
                                                                                "Journal Synchronization Cycle",
                                                                              type: "number",
                                                                            },
                                                                          model:
                                                                            {
                                                                              value:
                                                                                _vm.JournalSynchronizationCycle,
                                                                              callback:
                                                                                function (
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.JournalSynchronizationCycle =
                                                                                    _vm._n(
                                                                                      $$v
                                                                                    )
                                                                                },
                                                                              expression:
                                                                                "JournalSynchronizationCycle",
                                                                            },
                                                                        },
                                                                        on
                                                                      )
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            false,
                                                            1598791657
                                                          ),
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              " Time interval to check and persist (if needed)"
                                                            ),
                                                            _c("br"),
                                                            _vm._v(
                                                              "journal record to db in seconds. "
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm.isAdmin
                                            ? _c(
                                                "h2",
                                                {
                                                  staticClass:
                                                    "agent-config-category pl-2",
                                                },
                                                [_vm._v(" Hedge ")]
                                              )
                                            : _vm._e(),
                                          _vm.isAdmin
                                            ? _c(
                                                "v-row",
                                                [
                                                  _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "py-0",
                                                      attrs: {
                                                        cols: "12",
                                                        sm: "6",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              _vm.isNotDesktop,
                                                            "content-class":
                                                              "tooltipClass",
                                                            bottom: "",
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "activator",
                                                                fn: function ({
                                                                  on,
                                                                }) {
                                                                  return [
                                                                    _c(
                                                                      "v-text-field",
                                                                      _vm._g(
                                                                        {
                                                                          staticClass:
                                                                            "analyticsTextFieldClass",
                                                                          attrs:
                                                                            {
                                                                              default: 60,
                                                                              dense:
                                                                                "",
                                                                              outlined:
                                                                                "",
                                                                              label:
                                                                                "Hedge Intel Synchronization Cycle",
                                                                              type: "number",
                                                                            },
                                                                          model:
                                                                            {
                                                                              value:
                                                                                _vm.AiHedgeIntelSynchronizationCycle,
                                                                              callback:
                                                                                function (
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.AiHedgeIntelSynchronizationCycle =
                                                                                    _vm._n(
                                                                                      $$v
                                                                                    )
                                                                                },
                                                                              expression:
                                                                                "AiHedgeIntelSynchronizationCycle",
                                                                            },
                                                                        },
                                                                        on
                                                                      )
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            false,
                                                            2211204333
                                                          ),
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              " Synchronization cycle (in seconds) for dispatching hedge information to ai component. "
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "py-0",
                                                      attrs: {
                                                        cols: "12",
                                                        sm: "6",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              _vm.isNotDesktop,
                                                            "content-class":
                                                              "tooltipClass",
                                                            bottom: "",
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "activator",
                                                                fn: function ({
                                                                  on,
                                                                }) {
                                                                  return [
                                                                    _c(
                                                                      "v-text-field",
                                                                      _vm._g(
                                                                        {
                                                                          staticClass:
                                                                            "analyticsTextFieldClass",
                                                                          attrs:
                                                                            {
                                                                              default:
                                                                                "(?<book>(^A(?<percentage>(\\d+)?))|^B)-Book",
                                                                              dense:
                                                                                "",
                                                                              outlined:
                                                                                "",
                                                                              label:
                                                                                "Validation regex",
                                                                              type: "text",
                                                                            },
                                                                          model:
                                                                            {
                                                                              value:
                                                                                _vm.HedgeBookRegex,
                                                                              callback:
                                                                                function (
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.HedgeBookRegex =
                                                                                    typeof $$v ===
                                                                                    "string"
                                                                                      ? $$v.trim()
                                                                                      : $$v
                                                                                },
                                                                              expression:
                                                                                "HedgeBookRegex",
                                                                            },
                                                                        },
                                                                        on
                                                                      )
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            false,
                                                            1253457102
                                                          ),
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticStyle: {
                                                                "text-align":
                                                                  "left",
                                                              },
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  " Regex in order to validate (and replace) hedge information. "
                                                                ),
                                                                _c("br"),
                                                                _vm._v(
                                                                  " Only the book entries that pass this regex are included in the hedge information. "
                                                                ),
                                                                _c("br"),
                                                                _c("br"),
                                                                _c("strong", [
                                                                  _c("i", [
                                                                    _vm._v(
                                                                      "Make sure to always keep the book and percentage named capture groups since "
                                                                    ),
                                                                    _c("br"),
                                                                    _vm._v(
                                                                      "those are used internally in order to format book in a relevant (to the ai) way"
                                                                    ),
                                                                  ]),
                                                                ]),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm.isAdmin
                                            ? _c(
                                                "h2",
                                                {
                                                  staticClass:
                                                    "agent-config-category pl-2",
                                                },
                                                [_vm._v(" EodFloatingPnl ")]
                                              )
                                            : _vm._e(),
                                          _vm.isAdmin
                                            ? _c(
                                                "v-row",
                                                [
                                                  _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "py-0",
                                                      attrs: {
                                                        cols: "12",
                                                        sm: "6",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              _vm.isNotDesktop,
                                                            "content-class":
                                                              "tooltipClassBig",
                                                            bottom: "",
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "activator",
                                                                fn: function ({
                                                                  on,
                                                                }) {
                                                                  return [
                                                                    _c(
                                                                      "div",
                                                                      _vm._g(
                                                                        {},
                                                                        on
                                                                      ),
                                                                      [
                                                                        _c(
                                                                          "v-select",
                                                                          _vm._g(
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  outlined:
                                                                                    "",
                                                                                  dense:
                                                                                    "",
                                                                                  "menu-props":
                                                                                    {
                                                                                      offsetY: true,
                                                                                      maxHeight:
                                                                                        "350",
                                                                                    },
                                                                                  label:
                                                                                    "EOD Floating Pnl Offset Times",
                                                                                  items:
                                                                                    [
                                                                                      "Days",
                                                                                    ],
                                                                                  "item-text":
                                                                                    "day",
                                                                                  "item-value":
                                                                                    "day",
                                                                                  "item-color":
                                                                                    "#262b2e",
                                                                                  "return-object":
                                                                                    "",
                                                                                  "hide-selected":
                                                                                    "",
                                                                                },
                                                                              scopedSlots:
                                                                                _vm._u(
                                                                                  [
                                                                                    {
                                                                                      key: "item",
                                                                                      fn: function ({}) {
                                                                                        return [
                                                                                          _c(
                                                                                            "div"
                                                                                          ),
                                                                                        ]
                                                                                      },
                                                                                    },
                                                                                    {
                                                                                      key: "selection",
                                                                                      fn: function ({}) {
                                                                                        return [
                                                                                          _vm
                                                                                            .enabledEodFloatingPnlOffsetTimes
                                                                                            .length
                                                                                            ? _c(
                                                                                                "div",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "mr-1",
                                                                                                },
                                                                                                [
                                                                                                  _c(
                                                                                                    "span",
                                                                                                    [
                                                                                                      _vm._v(
                                                                                                        _vm._s(
                                                                                                          _vm
                                                                                                            .enabledEodFloatingPnlOffsetTimes[0]
                                                                                                            .dayName
                                                                                                        )
                                                                                                      ),
                                                                                                    ]
                                                                                                  ),
                                                                                                ]
                                                                                              )
                                                                                            : _c(
                                                                                                "label",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "v-label theme--dark",
                                                                                                  staticStyle:
                                                                                                    {
                                                                                                      left: "0",
                                                                                                      right:
                                                                                                        "auto",
                                                                                                      position:
                                                                                                        "absolute",
                                                                                                    },
                                                                                                },
                                                                                                [
                                                                                                  _vm._v(
                                                                                                    "No times set"
                                                                                                  ),
                                                                                                ]
                                                                                              ),
                                                                                          _vm
                                                                                            .enabledEodFloatingPnlOffsetTimes
                                                                                            .length >
                                                                                          1
                                                                                            ? _c(
                                                                                                "span",
                                                                                                [
                                                                                                  _vm._v(
                                                                                                    " (+" +
                                                                                                      _vm._s(
                                                                                                        _vm
                                                                                                          .enabledEodFloatingPnlOffsetTimes
                                                                                                          .length -
                                                                                                          1
                                                                                                      ) +
                                                                                                      ") "
                                                                                                  ),
                                                                                                ]
                                                                                              )
                                                                                            : _vm._e(),
                                                                                        ]
                                                                                      },
                                                                                    },
                                                                                    {
                                                                                      key: "append-item",
                                                                                      fn: function () {
                                                                                        return [
                                                                                          _c(
                                                                                            "div",
                                                                                            {
                                                                                              staticClass:
                                                                                                "EodFloatingPnlOffsetTimes-outer pt-2",
                                                                                              staticStyle:
                                                                                                {
                                                                                                  "max-height":
                                                                                                    "348px",
                                                                                                  "border-top":
                                                                                                    "none !important",
                                                                                                },
                                                                                            },
                                                                                            _vm._l(
                                                                                              _vm
                                                                                                .currentDefinition
                                                                                                .configuration
                                                                                                .Analytics
                                                                                                .EodFloatingPnlOffsetTimes,
                                                                                              function (
                                                                                                day
                                                                                              ) {
                                                                                                return _c(
                                                                                                  "v-row",
                                                                                                  {
                                                                                                    key: day.dayName,
                                                                                                    staticClass:
                                                                                                      "pa-1 mx-0",
                                                                                                    staticStyle:
                                                                                                      {
                                                                                                        "margin-top":
                                                                                                          "-4px",
                                                                                                        "border-top":
                                                                                                          "none !important",
                                                                                                        "background-color":
                                                                                                          "#262b2e",
                                                                                                      },
                                                                                                  },
                                                                                                  [
                                                                                                    _c(
                                                                                                      "v-btn",
                                                                                                      {
                                                                                                        staticClass:
                                                                                                          "mt-1",
                                                                                                        attrs:
                                                                                                          {
                                                                                                            icon: "",
                                                                                                            small:
                                                                                                              "",
                                                                                                            height: 24,
                                                                                                            width: 24,
                                                                                                          },
                                                                                                        on: {
                                                                                                          click:
                                                                                                            function (
                                                                                                              $event
                                                                                                            ) {
                                                                                                              day.enabled =
                                                                                                                !day.enabled
                                                                                                            },
                                                                                                        },
                                                                                                      },
                                                                                                      [
                                                                                                        _c(
                                                                                                          "v-icon",
                                                                                                          {
                                                                                                            staticClass:
                                                                                                              "mx-2",
                                                                                                            attrs:
                                                                                                              {
                                                                                                                small:
                                                                                                                  "",
                                                                                                                color:
                                                                                                                  day.enabled
                                                                                                                    ? "primary"
                                                                                                                    : "white",
                                                                                                              },
                                                                                                          },
                                                                                                          [
                                                                                                            _vm._v(
                                                                                                              " " +
                                                                                                                _vm._s(
                                                                                                                  day.enabled
                                                                                                                    ? "fas fa-dot-circle"
                                                                                                                    : "far fa-dot-circle"
                                                                                                                ) +
                                                                                                                " "
                                                                                                            ),
                                                                                                          ]
                                                                                                        ),
                                                                                                      ],
                                                                                                      1
                                                                                                    ),
                                                                                                    _c(
                                                                                                      "p",
                                                                                                      {
                                                                                                        staticClass:
                                                                                                          "pl-2 clickable",
                                                                                                        class:
                                                                                                          {
                                                                                                            "grey--text":
                                                                                                              !day.enabled,
                                                                                                          },
                                                                                                        staticStyle:
                                                                                                          {
                                                                                                            width:
                                                                                                              "80px",
                                                                                                            "padding-top":
                                                                                                              "4px",
                                                                                                          },
                                                                                                        on: {
                                                                                                          click:
                                                                                                            function (
                                                                                                              $event
                                                                                                            ) {
                                                                                                              day.enabled =
                                                                                                                !day.enabled
                                                                                                            },
                                                                                                        },
                                                                                                      },
                                                                                                      [
                                                                                                        _vm._v(
                                                                                                          " " +
                                                                                                            _vm._s(
                                                                                                              day.dayName
                                                                                                            ) +
                                                                                                            " "
                                                                                                        ),
                                                                                                      ]
                                                                                                    ),
                                                                                                    _c(
                                                                                                      "v-spacer"
                                                                                                    ),
                                                                                                    _c(
                                                                                                      "v-text-field",
                                                                                                      {
                                                                                                        staticClass:
                                                                                                          "mini-text-field mr-1",
                                                                                                        staticStyle:
                                                                                                          {
                                                                                                            width:
                                                                                                              "74px !important",
                                                                                                          },
                                                                                                        attrs:
                                                                                                          {
                                                                                                            disabled:
                                                                                                              !day.enabled,
                                                                                                            type: "number",
                                                                                                            outlined:
                                                                                                              "",
                                                                                                            dense:
                                                                                                              "",
                                                                                                            label:
                                                                                                              "From (s)",
                                                                                                          },
                                                                                                        model:
                                                                                                          {
                                                                                                            value:
                                                                                                              day.From,
                                                                                                            callback:
                                                                                                              function (
                                                                                                                $$v
                                                                                                              ) {
                                                                                                                _vm.$set(
                                                                                                                  day,
                                                                                                                  "From",
                                                                                                                  _vm._n(
                                                                                                                    $$v
                                                                                                                  )
                                                                                                                )
                                                                                                              },
                                                                                                            expression:
                                                                                                              "day.From",
                                                                                                          },
                                                                                                      }
                                                                                                    ),
                                                                                                    _c(
                                                                                                      "v-text-field",
                                                                                                      {
                                                                                                        staticClass:
                                                                                                          "mini-text-field mx-1",
                                                                                                        staticStyle:
                                                                                                          {
                                                                                                            width:
                                                                                                              "74px !important",
                                                                                                            "border-top":
                                                                                                              "none !important",
                                                                                                          },
                                                                                                        attrs:
                                                                                                          {
                                                                                                            disabled:
                                                                                                              !day.enabled,
                                                                                                            type: "number",
                                                                                                            outlined:
                                                                                                              "",
                                                                                                            dense:
                                                                                                              "",
                                                                                                            label:
                                                                                                              "To (s)",
                                                                                                          },
                                                                                                        model:
                                                                                                          {
                                                                                                            value:
                                                                                                              day.To,
                                                                                                            callback:
                                                                                                              function (
                                                                                                                $$v
                                                                                                              ) {
                                                                                                                _vm.$set(
                                                                                                                  day,
                                                                                                                  "To",
                                                                                                                  _vm._n(
                                                                                                                    $$v
                                                                                                                  )
                                                                                                                )
                                                                                                              },
                                                                                                            expression:
                                                                                                              "day.To",
                                                                                                          },
                                                                                                      }
                                                                                                    ),
                                                                                                  ],
                                                                                                  1
                                                                                                )
                                                                                              }
                                                                                            ),
                                                                                            1
                                                                                          ),
                                                                                        ]
                                                                                      },
                                                                                      proxy: true,
                                                                                    },
                                                                                    {
                                                                                      key: "no-data",
                                                                                      fn: function () {
                                                                                        return [
                                                                                          _c(
                                                                                            "div"
                                                                                          ),
                                                                                        ]
                                                                                      },
                                                                                      proxy: true,
                                                                                    },
                                                                                  ],
                                                                                  null,
                                                                                  true
                                                                                ),
                                                                              model:
                                                                                {
                                                                                  value:
                                                                                    _vm.eodFloatingPnlOffsetTimesModel,
                                                                                  callback:
                                                                                    function (
                                                                                      $$v
                                                                                    ) {
                                                                                      _vm.eodFloatingPnlOffsetTimesModel =
                                                                                        $$v
                                                                                    },
                                                                                  expression:
                                                                                    "eodFloatingPnlOffsetTimesModel",
                                                                                },
                                                                            },
                                                                            on
                                                                          )
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            false,
                                                            2513546298
                                                          ),
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              " Start and end times per day of week for populating eod floating pnl per day. Times are in seconds starting from server midnight. "
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "py-0",
                                                      attrs: {
                                                        cols: "12",
                                                        sm: "6",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              _vm.isNotDesktop,
                                                            "content-class":
                                                              "tooltipClassBig",
                                                            bottom: "",
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "activator",
                                                                fn: function ({
                                                                  on,
                                                                }) {
                                                                  return [
                                                                    _c(
                                                                      "div",
                                                                      _vm._g(
                                                                        {},
                                                                        on
                                                                      ),
                                                                      [
                                                                        _c(
                                                                          "v-select",
                                                                          _vm._g(
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  outlined:
                                                                                    "",
                                                                                  dense:
                                                                                    "",
                                                                                  "menu-props":
                                                                                    {
                                                                                      offsetY: true,
                                                                                    },
                                                                                  "item-text":
                                                                                    "text",
                                                                                  label:
                                                                                    "Group Eod Floating Pnls",
                                                                                  items:
                                                                                    [
                                                                                      {
                                                                                        value: true,
                                                                                        text: "Yes",
                                                                                      },
                                                                                      {
                                                                                        value: false,
                                                                                        text: "No",
                                                                                      },
                                                                                    ],
                                                                                },
                                                                              scopedSlots:
                                                                                _vm._u(
                                                                                  [
                                                                                    {
                                                                                      key: "item",
                                                                                      fn: function ({
                                                                                        item,
                                                                                      }) {
                                                                                        return [
                                                                                          _c(
                                                                                            "p",
                                                                                            {
                                                                                              staticClass:
                                                                                                "mb-0",
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                _vm._s(
                                                                                                  item.text
                                                                                                )
                                                                                              ),
                                                                                            ]
                                                                                          ),
                                                                                        ]
                                                                                      },
                                                                                    },
                                                                                  ],
                                                                                  null,
                                                                                  true
                                                                                ),
                                                                              model:
                                                                                {
                                                                                  value:
                                                                                    _vm
                                                                                      .currentDefinition
                                                                                      .configuration
                                                                                      .Analytics
                                                                                      .GroupEodFloatingPnls,
                                                                                  callback:
                                                                                    function (
                                                                                      $$v
                                                                                    ) {
                                                                                      _vm.$set(
                                                                                        _vm
                                                                                          .currentDefinition
                                                                                          .configuration
                                                                                          .Analytics,
                                                                                        "GroupEodFloatingPnls",
                                                                                        $$v
                                                                                      )
                                                                                    },
                                                                                  expression:
                                                                                    "\n                                currentDefinition.configuration.Analytics\n                                  .GroupEodFloatingPnls\n                              ",
                                                                                },
                                                                            },
                                                                            on
                                                                          )
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            false,
                                                            1893432937
                                                          ),
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              " Group summary items by symbol or batch them as raw records. "
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _c(
                                            "h2",
                                            {
                                              staticClass:
                                                "agent-config-category pl-2",
                                            },
                                            [_vm._v("Exclusions")]
                                          ),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "py-0",
                                                  attrs: {
                                                    cols: "12",
                                                    sm: "6",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: {
                                                        disabled:
                                                          _vm.isNotDesktop,
                                                        "content-class":
                                                          "tooltipClassBig",
                                                        bottom: "",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function ({
                                                              on,
                                                            }) {
                                                              return [
                                                                _c(
                                                                  "div",
                                                                  _vm._g(
                                                                    {},
                                                                    on
                                                                  ),
                                                                  [
                                                                    _c(
                                                                      "v-textarea",
                                                                      {
                                                                        staticClass:
                                                                          "dense-textarea",
                                                                        attrs: {
                                                                          outlined:
                                                                            "",
                                                                          role: "textbox",
                                                                          label:
                                                                            "Logins to exclude (e.g 3,4,15)",
                                                                          dense:
                                                                            "",
                                                                          "min-height": 30,
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .currentDefinition
                                                                              .configuration
                                                                              .Analytics
                                                                              .ExcludeLogins,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm
                                                                                  .currentDefinition
                                                                                  .configuration
                                                                                  .Analytics,
                                                                                "ExcludeLogins",
                                                                                $$v
                                                                              )
                                                                            },
                                                                          expression:
                                                                            "\n                                currentDefinition.configuration.Analytics\n                                  .ExcludeLogins\n                              ",
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        false,
                                                        324029977
                                                      ),
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          " The regular expression which will be used to extract the actual ID from the User ID field "
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm.isAdmin
                                                ? _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "py-0",
                                                      attrs: {
                                                        cols: "12",
                                                        sm: "6",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              _vm.isNotDesktop,
                                                            "content-class":
                                                              "tooltipClassBig",
                                                            bottom: "",
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "activator",
                                                                fn: function ({
                                                                  on,
                                                                }) {
                                                                  return [
                                                                    _c(
                                                                      "div",
                                                                      _vm._g(
                                                                        {},
                                                                        on
                                                                      ),
                                                                      [
                                                                        _c(
                                                                          "v-text-field",
                                                                          {
                                                                            staticClass:
                                                                              "analyticsTextFieldClass",
                                                                            attrs:
                                                                              {
                                                                                dense:
                                                                                  "",
                                                                                outlined:
                                                                                  "",
                                                                                label:
                                                                                  "Exclude Services",
                                                                              },
                                                                            model:
                                                                              {
                                                                                value:
                                                                                  _vm
                                                                                    .currentDefinition
                                                                                    .configuration
                                                                                    .Analytics
                                                                                    .ExcludeServices,
                                                                                callback:
                                                                                  function (
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.$set(
                                                                                      _vm
                                                                                        .currentDefinition
                                                                                        .configuration
                                                                                        .Analytics,
                                                                                      "ExcludeServices",
                                                                                      $$v
                                                                                    )
                                                                                  },
                                                                                expression:
                                                                                  "\n                                currentDefinition.configuration.Analytics\n                                  .ExcludeServices\n                              ",
                                                                              },
                                                                          }
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            false,
                                                            2645664138
                                                          ),
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              " Excludes certain synchronizers and/or schedulers"
                                                            ),
                                                            _c("br"),
                                                            _vm._v(
                                                              "from starting (only valid on application start) "
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            [
                                              _vm.isAdmin
                                                ? _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "py-0",
                                                      attrs: {
                                                        cols: "12",
                                                        sm: "6",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              _vm.isNotDesktop,
                                                            "content-class":
                                                              "tooltipClassBig",
                                                            bottom: "",
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "activator",
                                                                fn: function ({
                                                                  on,
                                                                }) {
                                                                  return [
                                                                    _c(
                                                                      "div",
                                                                      _vm._g(
                                                                        {},
                                                                        on
                                                                      ),
                                                                      [
                                                                        _c(
                                                                          "v-textarea",
                                                                          {
                                                                            staticClass:
                                                                              "dense-textarea",
                                                                            attrs:
                                                                              {
                                                                                outlined:
                                                                                  "",
                                                                                role: "textbox",
                                                                                label:
                                                                                  "Custom User Exclusion",
                                                                                dense:
                                                                                  "",
                                                                                "min-height": 30,
                                                                              },
                                                                            model:
                                                                              {
                                                                                value:
                                                                                  _vm
                                                                                    .currentDefinition
                                                                                    .configuration
                                                                                    .Analytics
                                                                                    .CustomUserExclusion,
                                                                                callback:
                                                                                  function (
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.$set(
                                                                                      _vm
                                                                                        .currentDefinition
                                                                                        .configuration
                                                                                        .Analytics,
                                                                                      "CustomUserExclusion",
                                                                                      $$v
                                                                                    )
                                                                                  },
                                                                                expression:
                                                                                  "\n                                currentDefinition.configuration.Analytics\n                                  .CustomUserExclusion\n                              ",
                                                                              },
                                                                          }
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            false,
                                                            2908850444
                                                          ),
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              " A custom lambda expression used exclude specific users. "
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "h2",
                                            {
                                              staticClass:
                                                "agent-config-category pl-2",
                                            },
                                            [_vm._v("Ticks")]
                                          ),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "py-0",
                                                  attrs: {
                                                    cols: "12",
                                                    sm: "6",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: {
                                                        disabled:
                                                          _vm.isNotDesktop,
                                                        "content-class":
                                                          "tooltipClassBig",
                                                        bottom: "",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function ({
                                                              on,
                                                            }) {
                                                              return [
                                                                _c(
                                                                  "v-text-field",
                                                                  _vm._g(
                                                                    {
                                                                      staticClass:
                                                                        "analyticsTextFieldClass",
                                                                      attrs: {
                                                                        dense:
                                                                          "",
                                                                        outlined:
                                                                          "",
                                                                        label:
                                                                          "Ticks Synchronization Cycle",
                                                                        type: "number",
                                                                        rules: [
                                                                          _vm
                                                                            .rules
                                                                            .required,
                                                                        ],
                                                                      },
                                                                      on: {
                                                                        keydown:
                                                                          (
                                                                            ev
                                                                          ) =>
                                                                            _vm.setHelperVar(
                                                                              ev,
                                                                              "TicksSynchronizationCycleAN"
                                                                            ),
                                                                        keypress:
                                                                          (
                                                                            ev
                                                                          ) =>
                                                                            _vm.setHelperVar(
                                                                              ev,
                                                                              "TicksSynchronizationCycleAN"
                                                                            ),
                                                                        input: (
                                                                          ev
                                                                        ) =>
                                                                          _vm.textInput(
                                                                            ev,
                                                                            _vm
                                                                              .currentDefinition
                                                                              .configuration,
                                                                            "TicksSynchronizationCycle"
                                                                          ),
                                                                        change:
                                                                          _vm.clearHelperVar,
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          _vm.TicksSynchronizationCycleAN,
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.TicksSynchronizationCycleAN =
                                                                              _vm._n(
                                                                                $$v
                                                                              )
                                                                          },
                                                                        expression:
                                                                          "TicksSynchronizationCycleAN",
                                                                      },
                                                                    },
                                                                    on
                                                                  )
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        false,
                                                        1377249248
                                                      ),
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          " Period of time in milliseconds to store a snapshot of ticks in database "
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm.isAdmin
                                                ? _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "py-0",
                                                      attrs: {
                                                        cols: "12",
                                                        sm: "6",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              _vm.isNotDesktop,
                                                            "content-class":
                                                              "tooltipClassBig",
                                                            bottom: "",
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "activator",
                                                                fn: function ({
                                                                  on,
                                                                }) {
                                                                  return [
                                                                    _c(
                                                                      "div",
                                                                      _vm._g(
                                                                        {},
                                                                        on
                                                                      ),
                                                                      [
                                                                        _c(
                                                                          "v-text-field",
                                                                          {
                                                                            staticClass:
                                                                              "analyticsTextFieldClass",
                                                                            attrs:
                                                                              {
                                                                                dense:
                                                                                  "",
                                                                                outlined:
                                                                                  "",
                                                                                type: "number",
                                                                                label:
                                                                                  "Live Ticks Synchronization Cycle",
                                                                              },
                                                                            model:
                                                                              {
                                                                                value:
                                                                                  _vm
                                                                                    .currentDefinition
                                                                                    .configuration
                                                                                    .Analytics
                                                                                    .LiveTicksSynchronizationCycle,
                                                                                callback:
                                                                                  function (
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.$set(
                                                                                      _vm
                                                                                        .currentDefinition
                                                                                        .configuration
                                                                                        .Analytics,
                                                                                      "LiveTicksSynchronizationCycle",
                                                                                      _vm._n(
                                                                                        $$v
                                                                                      )
                                                                                    )
                                                                                  },
                                                                                expression:
                                                                                  "\n                                currentDefinition.configuration.Analytics\n                                  .LiveTicksSynchronizationCycle\n                              ",
                                                                              },
                                                                          }
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            false,
                                                            389919383
                                                          ),
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              " Synchronization cycle for live ticks in ms "
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.isAdmin
                                                ? _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "py-0",
                                                      attrs: {
                                                        cols: "12",
                                                        sm: "6",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              _vm.isNotDesktop,
                                                            "content-class":
                                                              "tooltipClassBig",
                                                            bottom: "",
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "activator",
                                                                fn: function ({
                                                                  on,
                                                                }) {
                                                                  return [
                                                                    _c(
                                                                      "div",
                                                                      _vm._g(
                                                                        {},
                                                                        on
                                                                      ),
                                                                      [
                                                                        _c(
                                                                          "v-text-field",
                                                                          {
                                                                            staticClass:
                                                                              "analyticsTextFieldClass",
                                                                            attrs:
                                                                              {
                                                                                dense:
                                                                                  "",
                                                                                outlined:
                                                                                  "",
                                                                                type: "string",
                                                                                label:
                                                                                  "Additional calculation currencies",
                                                                                "persistent-placeholder":
                                                                                  "",
                                                                              },
                                                                            model:
                                                                              {
                                                                                value:
                                                                                  _vm
                                                                                    .currentDefinition
                                                                                    .configuration
                                                                                    .Analytics
                                                                                    .SecondaryCalculationCurrencies,
                                                                                callback:
                                                                                  function (
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.$set(
                                                                                      _vm
                                                                                        .currentDefinition
                                                                                        .configuration
                                                                                        .Analytics,
                                                                                      "SecondaryCalculationCurrencies",
                                                                                      $$v
                                                                                    )
                                                                                  },
                                                                                expression:
                                                                                  "\n                                currentDefinition.configuration.Analytics\n                                  .SecondaryCalculationCurrencies\n                              ",
                                                                              },
                                                                          }
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            false,
                                                            2928585551
                                                          ),
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              " Additional calculation currencies that the agent should take into account when crafting live ticks "
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.isAdmin
                                                ? _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "py-0",
                                                      attrs: {
                                                        cols: "12",
                                                        sm: "6",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              _vm.isNotDesktop,
                                                            "content-class":
                                                              "tooltipClassBig",
                                                            bottom: "",
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "activator",
                                                                fn: function ({
                                                                  on,
                                                                }) {
                                                                  return [
                                                                    _c(
                                                                      "div",
                                                                      _vm._g(
                                                                        {},
                                                                        on
                                                                      ),
                                                                      [
                                                                        _c(
                                                                          "v-text-field",
                                                                          {
                                                                            staticClass:
                                                                              "analyticsTextFieldClass",
                                                                            attrs:
                                                                              {
                                                                                dense:
                                                                                  "",
                                                                                outlined:
                                                                                  "",
                                                                                type: "string",
                                                                                label:
                                                                                  "Calculation currencies suffixes",
                                                                                "persistent-placeholder":
                                                                                  "",
                                                                              },
                                                                            model:
                                                                              {
                                                                                value:
                                                                                  _vm
                                                                                    .currentDefinition
                                                                                    .configuration
                                                                                    .Analytics
                                                                                    .CalculationCurrenciesSuffixes,
                                                                                callback:
                                                                                  function (
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.$set(
                                                                                      _vm
                                                                                        .currentDefinition
                                                                                        .configuration
                                                                                        .Analytics,
                                                                                      "CalculationCurrenciesSuffixes",
                                                                                      $$v
                                                                                    )
                                                                                  },
                                                                                expression:
                                                                                  "\n                                currentDefinition.configuration.Analytics\n                                  .CalculationCurrenciesSuffixes\n                              ",
                                                                              },
                                                                          }
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            false,
                                                            2253422284
                                                          ),
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              " Suffixes to use when crafting live ticks (e.g. .std) when the actual symbol is not available (e.g. EURUSD does not exist but EURUSD.std does. Note the produced live ticks will not use suffix. It's used to prioritize conversion. Order matters) "
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.isAdmin
                                                ? _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "py-0",
                                                      attrs: {
                                                        cols: "12",
                                                        sm: "6",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              _vm.isNotDesktop,
                                                            "content-class":
                                                              "tooltipClassBig",
                                                            bottom: "",
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "activator",
                                                                fn: function ({
                                                                  on,
                                                                }) {
                                                                  return [
                                                                    _c(
                                                                      "div",
                                                                      _vm._g(
                                                                        {},
                                                                        on
                                                                      ),
                                                                      [
                                                                        _c(
                                                                          "v-text-field",
                                                                          {
                                                                            staticClass:
                                                                              "analyticsTextFieldClass",
                                                                            attrs:
                                                                              {
                                                                                dense:
                                                                                  "",
                                                                                outlined:
                                                                                  "",
                                                                                type: "string",
                                                                                label:
                                                                                  "Default intermediate currency",
                                                                                "persistent-placeholder":
                                                                                  "",
                                                                              },
                                                                            model:
                                                                              {
                                                                                value:
                                                                                  _vm
                                                                                    .currentDefinition
                                                                                    .configuration
                                                                                    .Analytics
                                                                                    .IntermediateCurrencies,
                                                                                callback:
                                                                                  function (
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.$set(
                                                                                      _vm
                                                                                        .currentDefinition
                                                                                        .configuration
                                                                                        .Analytics,
                                                                                      "IntermediateCurrencies",
                                                                                      $$v
                                                                                    )
                                                                                  },
                                                                                expression:
                                                                                  "\n                                currentDefinition.configuration.Analytics.IntermediateCurrencies\n                              ",
                                                                              },
                                                                          }
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            false,
                                                            4202026419
                                                          ),
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              " Default intermediate currency used in order to craft prices for missing symbols (needed for conversions). By default MT4 and MT5 platforms use USD "
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.isAdmin
                                                ? _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "py-0",
                                                      attrs: {
                                                        cols: "12",
                                                        sm: "6",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              _vm.isNotDesktop,
                                                            "content-class":
                                                              "tooltipClassBig",
                                                            bottom: "",
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "activator",
                                                                fn: function ({
                                                                  on,
                                                                }) {
                                                                  return [
                                                                    _c(
                                                                      "div",
                                                                      _vm._g(
                                                                        {},
                                                                        on
                                                                      ),
                                                                      [
                                                                        _c(
                                                                          "v-text-field",
                                                                          {
                                                                            staticClass:
                                                                              "analyticsTextFieldClass",
                                                                            attrs:
                                                                              {
                                                                                dense:
                                                                                  "",
                                                                                outlined:
                                                                                  "",
                                                                                type: "number",
                                                                                label:
                                                                                  "Missing Symbols live ticks synchronization cycles",
                                                                                "persistent-placeholder":
                                                                                  "",
                                                                              },
                                                                            model:
                                                                              {
                                                                                value:
                                                                                  _vm
                                                                                    .currentDefinition
                                                                                    .configuration
                                                                                    .Analytics
                                                                                    .MissingSymbolsToLiveTicksSynchronizationCycleRatio,
                                                                                callback:
                                                                                  function (
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.$set(
                                                                                      _vm
                                                                                        .currentDefinition
                                                                                        .configuration
                                                                                        .Analytics,
                                                                                      "MissingSymbolsToLiveTicksSynchronizationCycleRatio",
                                                                                      _vm._n(
                                                                                        $$v
                                                                                      )
                                                                                    )
                                                                                  },
                                                                                expression:
                                                                                  "\n                                currentDefinition.configuration.Analytics.MissingSymbolsToLiveTicksSynchronizationCycleRatio\n                              ",
                                                                              },
                                                                          }
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            false,
                                                            970741617
                                                          ),
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              " How many live ticks synchronization cycles are needed in order to craft live ticks for missing symbols (needed for conversions) "
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "h2",
                                            {
                                              staticClass:
                                                "agent-config-category pl-2",
                                            },
                                            [_vm._v("Positions")]
                                          ),
                                          _vm.isAdmin
                                            ? _c(
                                                "v-row",
                                                [
                                                  _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "py-0",
                                                      attrs: {
                                                        cols: "12",
                                                        sm: "6",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              _vm.isNotDesktop,
                                                            "content-class":
                                                              "tooltipClassBig",
                                                            bottom: "",
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "activator",
                                                                fn: function ({
                                                                  on,
                                                                }) {
                                                                  return [
                                                                    _c(
                                                                      "div",
                                                                      _vm._g(
                                                                        {},
                                                                        on
                                                                      ),
                                                                      [
                                                                        _c(
                                                                          "v-select",
                                                                          _vm._g(
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  outlined:
                                                                                    "",
                                                                                  dense:
                                                                                    "",
                                                                                  "menu-props":
                                                                                    {
                                                                                      offsetY: true,
                                                                                    },
                                                                                  "item-text":
                                                                                    "text",
                                                                                  label:
                                                                                    "Use dynamic data",
                                                                                  items:
                                                                                    [
                                                                                      {
                                                                                        value: true,
                                                                                        text: "Yes",
                                                                                      },
                                                                                      {
                                                                                        value: false,
                                                                                        text: "No",
                                                                                      },
                                                                                    ],
                                                                                },
                                                                              scopedSlots:
                                                                                _vm._u(
                                                                                  [
                                                                                    {
                                                                                      key: "item",
                                                                                      fn: function ({
                                                                                        item,
                                                                                      }) {
                                                                                        return [
                                                                                          _c(
                                                                                            "p",
                                                                                            {
                                                                                              staticClass:
                                                                                                "mb-0",
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                _vm._s(
                                                                                                  item.text
                                                                                                )
                                                                                              ),
                                                                                            ]
                                                                                          ),
                                                                                        ]
                                                                                      },
                                                                                    },
                                                                                  ],
                                                                                  null,
                                                                                  true
                                                                                ),
                                                                              model:
                                                                                {
                                                                                  value:
                                                                                    _vm
                                                                                      .currentDefinition
                                                                                      .configuration
                                                                                      .Analytics
                                                                                      .UseDynamicData,
                                                                                  callback:
                                                                                    function (
                                                                                      $$v
                                                                                    ) {
                                                                                      _vm.$set(
                                                                                        _vm
                                                                                          .currentDefinition
                                                                                          .configuration
                                                                                          .Analytics,
                                                                                        "UseDynamicData",
                                                                                        $$v
                                                                                      )
                                                                                    },
                                                                                  expression:
                                                                                    "\n                                currentDefinition.configuration.Analytics\n                                  .UseDynamicData\n                              ",
                                                                                },
                                                                            },
                                                                            on
                                                                          )
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            false,
                                                            3026648649
                                                          ),
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              " Use dynamic data cache for positions "
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "py-0",
                                                      attrs: {
                                                        cols: "12",
                                                        sm: "6",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              _vm.isNotDesktop,
                                                            "content-class":
                                                              "tooltipClassBig",
                                                            bottom: "",
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "activator",
                                                                fn: function ({
                                                                  on,
                                                                }) {
                                                                  return [
                                                                    _c(
                                                                      "div",
                                                                      _vm._g(
                                                                        {},
                                                                        on
                                                                      ),
                                                                      [
                                                                        _c(
                                                                          "v-text-field",
                                                                          {
                                                                            staticClass:
                                                                              "analyticsTextFieldClass",
                                                                            attrs:
                                                                              {
                                                                                dense:
                                                                                  "",
                                                                                outlined:
                                                                                  "",
                                                                                type: "number",
                                                                                label:
                                                                                  "Positions prepared statement limit",
                                                                              },
                                                                            model:
                                                                              {
                                                                                value:
                                                                                  _vm
                                                                                    .currentDefinition
                                                                                    .configuration
                                                                                    .Analytics
                                                                                    .PositionsPreparedStatementLimit,
                                                                                callback:
                                                                                  function (
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.$set(
                                                                                      _vm
                                                                                        .currentDefinition
                                                                                        .configuration
                                                                                        .Analytics,
                                                                                      "PositionsPreparedStatementLimit",
                                                                                      _vm._n(
                                                                                        $$v
                                                                                      )
                                                                                    )
                                                                                  },
                                                                                expression:
                                                                                  "\n                                currentDefinition.configuration.Analytics\n                                  .PositionsPreparedStatementLimit\n                              ",
                                                                              },
                                                                          }
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            false,
                                                            3598530327
                                                          ),
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              " Deciding factor when to use prepared statement or copy for positions persistence. Only taken into account if positions cache is enabled. "
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm.isAdmin
                                            ? _c(
                                                "v-row",
                                                [
                                                  _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "py-0",
                                                      attrs: {
                                                        cols: "12",
                                                        sm: "6",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              _vm.isNotDesktop,
                                                            "content-class":
                                                              "tooltipClassBig",
                                                            bottom: "",
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "activator",
                                                                fn: function ({
                                                                  on,
                                                                }) {
                                                                  return [
                                                                    _c(
                                                                      "div",
                                                                      _vm._g(
                                                                        {},
                                                                        on
                                                                      ),
                                                                      [
                                                                        _c(
                                                                          "v-text-field",
                                                                          {
                                                                            staticClass:
                                                                              "analyticsTextFieldClass",
                                                                            attrs:
                                                                              {
                                                                                dense:
                                                                                  "",
                                                                                outlined:
                                                                                  "",
                                                                                type: "number",
                                                                                label:
                                                                                  "Positions Persistence Cycle",
                                                                              },
                                                                            model:
                                                                              {
                                                                                value:
                                                                                  _vm
                                                                                    .currentDefinition
                                                                                    .configuration
                                                                                    .Analytics
                                                                                    .PositionsPersistenceCycle,
                                                                                callback:
                                                                                  function (
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.$set(
                                                                                      _vm
                                                                                        .currentDefinition
                                                                                        .configuration
                                                                                        .Analytics,
                                                                                      "PositionsPersistenceCycle",
                                                                                      _vm._n(
                                                                                        $$v
                                                                                      )
                                                                                    )
                                                                                  },
                                                                                expression:
                                                                                  "\n                                currentDefinition.configuration.Analytics\n                                  .PositionsPersistenceCycle\n                              ",
                                                                              },
                                                                          }
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            false,
                                                            3531450007
                                                          ),
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              " Period of time in seconds to store"
                                                            ),
                                                            _c("br"),
                                                            _vm._v(
                                                              " positions in database. "
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "py-0",
                                                      attrs: {
                                                        cols: "12",
                                                        sm: "6",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              _vm.isNotDesktop,
                                                            "content-class":
                                                              "tooltipClassBig",
                                                            bottom: "",
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "activator",
                                                                fn: function ({
                                                                  on,
                                                                }) {
                                                                  return [
                                                                    _c(
                                                                      "div",
                                                                      _vm._g(
                                                                        {},
                                                                        on
                                                                      ),
                                                                      [
                                                                        _c(
                                                                          "v-select",
                                                                          _vm._g(
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  outlined:
                                                                                    "",
                                                                                  dense:
                                                                                    "",
                                                                                  "menu-props":
                                                                                    {
                                                                                      offsetY: true,
                                                                                    },
                                                                                  "item-text":
                                                                                    "text",
                                                                                  label:
                                                                                    "Recalculate Trade Profit",
                                                                                  items:
                                                                                    [
                                                                                      {
                                                                                        value: true,
                                                                                        text: "Yes",
                                                                                      },
                                                                                      {
                                                                                        value: false,
                                                                                        text: "No",
                                                                                      },
                                                                                    ],
                                                                                },
                                                                              scopedSlots:
                                                                                _vm._u(
                                                                                  [
                                                                                    {
                                                                                      key: "item",
                                                                                      fn: function ({
                                                                                        item,
                                                                                      }) {
                                                                                        return [
                                                                                          _c(
                                                                                            "p",
                                                                                            {
                                                                                              staticClass:
                                                                                                "mb-0",
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                _vm._s(
                                                                                                  item.text
                                                                                                )
                                                                                              ),
                                                                                            ]
                                                                                          ),
                                                                                        ]
                                                                                      },
                                                                                    },
                                                                                  ],
                                                                                  null,
                                                                                  true
                                                                                ),
                                                                              model:
                                                                                {
                                                                                  value:
                                                                                    _vm
                                                                                      .currentDefinition
                                                                                      .configuration
                                                                                      .Analytics
                                                                                      .RecalculateTradeProfit,
                                                                                  callback:
                                                                                    function (
                                                                                      $$v
                                                                                    ) {
                                                                                      _vm.$set(
                                                                                        _vm
                                                                                          .currentDefinition
                                                                                          .configuration
                                                                                          .Analytics,
                                                                                        "RecalculateTradeProfit",
                                                                                        $$v
                                                                                      )
                                                                                    },
                                                                                  expression:
                                                                                    "\n                                currentDefinition.configuration.Analytics\n                                  .RecalculateTradeProfit\n                              ",
                                                                                },
                                                                            },
                                                                            on
                                                                          )
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            false,
                                                            737231081
                                                          ),
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              " Enables more accurate trade profit calculations at the cost"
                                                            ),
                                                            _c("br"),
                                                            _vm._v(
                                                              " of performance. Use if profit mismatch is observed in positions "
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "py-0",
                                                  attrs: {
                                                    cols: "12",
                                                    sm: "6",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: {
                                                        disabled:
                                                          _vm.isNotDesktop,
                                                        "content-class":
                                                          "tooltipClassBig",
                                                        bottom: "",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function ({
                                                              on,
                                                            }) {
                                                              return [
                                                                _c(
                                                                  "div",
                                                                  _vm._g(
                                                                    {},
                                                                    on
                                                                  ),
                                                                  [
                                                                    _c(
                                                                      "v-select",
                                                                      _vm._g(
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              outlined:
                                                                                "",
                                                                              dense:
                                                                                "",
                                                                              "menu-props":
                                                                                {
                                                                                  offsetY: true,
                                                                                },
                                                                              "item-text":
                                                                                "text",
                                                                              label:
                                                                                "Group Summary Items By Symbol",
                                                                              items:
                                                                                [
                                                                                  {
                                                                                    value: true,
                                                                                    text: "Yes",
                                                                                    i: 0,
                                                                                  },
                                                                                  {
                                                                                    value: false,
                                                                                    text: "No",
                                                                                    i: 1,
                                                                                  },
                                                                                ],
                                                                            },
                                                                          scopedSlots:
                                                                            _vm._u(
                                                                              [
                                                                                {
                                                                                  key: "item",
                                                                                  fn: function ({
                                                                                    item,
                                                                                  }) {
                                                                                    return [
                                                                                      item.i ===
                                                                                      0
                                                                                        ? _c(
                                                                                            "p",
                                                                                            {
                                                                                              staticClass:
                                                                                                "mb-0 d-inline",
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                " " +
                                                                                                  _vm._s(
                                                                                                    item.text
                                                                                                  ) +
                                                                                                  " "
                                                                                              ),
                                                                                            ]
                                                                                          )
                                                                                        : _c(
                                                                                            "v-tooltip",
                                                                                            {
                                                                                              attrs:
                                                                                                {
                                                                                                  "content-class":
                                                                                                    "tooltipClassBottom",
                                                                                                  bottom:
                                                                                                    "",
                                                                                                },
                                                                                              scopedSlots:
                                                                                                _vm._u(
                                                                                                  [
                                                                                                    {
                                                                                                      key: "activator",
                                                                                                      fn: function ({
                                                                                                        on,
                                                                                                      }) {
                                                                                                        return [
                                                                                                          _c(
                                                                                                            "div",
                                                                                                            _vm._g(
                                                                                                              {
                                                                                                                staticClass:
                                                                                                                  "pt-2",
                                                                                                                staticStyle:
                                                                                                                  {
                                                                                                                    width:
                                                                                                                      "100%",
                                                                                                                    height:
                                                                                                                      "40px",
                                                                                                                  },
                                                                                                              },
                                                                                                              on
                                                                                                            ),
                                                                                                            [
                                                                                                              _c(
                                                                                                                "p",
                                                                                                                {
                                                                                                                  staticClass:
                                                                                                                    "d-inline",
                                                                                                                },
                                                                                                                [
                                                                                                                  _vm._v(
                                                                                                                    _vm._s(
                                                                                                                      item.text
                                                                                                                    )
                                                                                                                  ),
                                                                                                                ]
                                                                                                              ),
                                                                                                              _c(
                                                                                                                "v-icon",
                                                                                                                {
                                                                                                                  staticClass:
                                                                                                                    "ml-2",
                                                                                                                  staticStyle:
                                                                                                                    {
                                                                                                                      "font-size":
                                                                                                                        "15px",
                                                                                                                      "margin-bottom":
                                                                                                                        "2px",
                                                                                                                    },
                                                                                                                  attrs:
                                                                                                                    {
                                                                                                                      color:
                                                                                                                        "red",
                                                                                                                    },
                                                                                                                },
                                                                                                                [
                                                                                                                  _vm._v(
                                                                                                                    "fas fa-exclamation-circle "
                                                                                                                  ),
                                                                                                                ]
                                                                                                              ),
                                                                                                            ],
                                                                                                            1
                                                                                                          ),
                                                                                                        ]
                                                                                                      },
                                                                                                    },
                                                                                                  ],
                                                                                                  null,
                                                                                                  true
                                                                                                ),
                                                                                            },
                                                                                            [
                                                                                              _c(
                                                                                                "span",
                                                                                                [
                                                                                                  _vm._v(
                                                                                                    " Not recommended for devices with low processing power. "
                                                                                                  ),
                                                                                                  _c(
                                                                                                    "br"
                                                                                                  ),
                                                                                                  _vm._v(
                                                                                                    "e.g old smartphones "
                                                                                                  ),
                                                                                                ]
                                                                                              ),
                                                                                            ]
                                                                                          ),
                                                                                    ]
                                                                                  },
                                                                                },
                                                                              ],
                                                                              null,
                                                                              true
                                                                            ),
                                                                          model:
                                                                            {
                                                                              value:
                                                                                _vm
                                                                                  .currentDefinition
                                                                                  .configuration
                                                                                  .Analytics
                                                                                  .GroupSummaryItemsBySymbol,
                                                                              callback:
                                                                                function (
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    _vm
                                                                                      .currentDefinition
                                                                                      .configuration
                                                                                      .Analytics,
                                                                                    "GroupSummaryItemsBySymbol",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                              expression:
                                                                                "\n                                currentDefinition.configuration.Analytics\n                                  .GroupSummaryItemsBySymbol\n                              ",
                                                                            },
                                                                        },
                                                                        on
                                                                      )
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        false,
                                                        543948564
                                                      ),
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          " Period of time in seconds to store a snapshot of users in database "
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm.isAdmin
                                                ? _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "py-0",
                                                      attrs: {
                                                        cols: "12",
                                                        sm: "6",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              _vm.isNotDesktop,
                                                            "content-class":
                                                              "tooltipClassBig",
                                                            bottom: "",
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "activator",
                                                                fn: function ({
                                                                  on,
                                                                }) {
                                                                  return [
                                                                    _c(
                                                                      "div",
                                                                      _vm._g(
                                                                        {},
                                                                        on
                                                                      ),
                                                                      [
                                                                        _c(
                                                                          "v-text-field",
                                                                          {
                                                                            staticClass:
                                                                              "analyticsTextFieldClass",
                                                                            attrs:
                                                                              {
                                                                                dense:
                                                                                  "",
                                                                                outlined:
                                                                                  "",
                                                                                label:
                                                                                  "Positions Dispatch Cycle",
                                                                                type: "number",
                                                                                rules:
                                                                                  [
                                                                                    _vm
                                                                                      .rules
                                                                                      .required,
                                                                                  ],
                                                                              },
                                                                            on: {
                                                                              keydown:
                                                                                (
                                                                                  ev
                                                                                ) =>
                                                                                  _vm.setHelperVar(
                                                                                    ev,
                                                                                    "PositionsDispatchCycle"
                                                                                  ),
                                                                              keypress:
                                                                                (
                                                                                  ev
                                                                                ) =>
                                                                                  _vm.setHelperVar(
                                                                                    ev,
                                                                                    "PositionsDispatchCycle"
                                                                                  ),
                                                                              input:
                                                                                (
                                                                                  ev
                                                                                ) =>
                                                                                  _vm.textInput(
                                                                                    ev,
                                                                                    _vm
                                                                                      .currentDefinition
                                                                                      .configuration,
                                                                                    "PositionsDispatchCycle"
                                                                                  ),
                                                                              focusout:
                                                                                _vm.clearHelperVar,
                                                                            },
                                                                            model:
                                                                              {
                                                                                value:
                                                                                  _vm
                                                                                    .currentDefinition
                                                                                    .configuration
                                                                                    .Analytics
                                                                                    .PositionsDispatchCycle,
                                                                                callback:
                                                                                  function (
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.$set(
                                                                                      _vm
                                                                                        .currentDefinition
                                                                                        .configuration
                                                                                        .Analytics,
                                                                                      "PositionsDispatchCycle",
                                                                                      _vm._n(
                                                                                        $$v
                                                                                      )
                                                                                    )
                                                                                  },
                                                                                expression:
                                                                                  "\n                                currentDefinition.configuration.Analytics\n                                  .PositionsDispatchCycle\n                              ",
                                                                              },
                                                                          }
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            false,
                                                            3931803212
                                                          ),
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              " Position and exposure dispatch to ui interval in seconds "
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                          _vm.isAdmin
                                            ? _c(
                                                "h2",
                                                {
                                                  staticClass:
                                                    "agent-config-category pl-2",
                                                },
                                                [_vm._v(" Symbols ")]
                                              )
                                            : _vm._e(),
                                          _vm.isAdmin
                                            ? _c(
                                                "v-row",
                                                [
                                                  _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "py-0",
                                                      attrs: {
                                                        cols: "12",
                                                        sm: "6",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              _vm.isNotDesktop,
                                                            "content-class":
                                                              "tooltipClass",
                                                            bottom: "",
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "activator",
                                                                fn: function ({
                                                                  on,
                                                                }) {
                                                                  return [
                                                                    _c(
                                                                      "v-text-field",
                                                                      _vm._g(
                                                                        {
                                                                          staticClass:
                                                                            "analyticsTextFieldClass",
                                                                          attrs:
                                                                            {
                                                                              rules:
                                                                                [
                                                                                  _vm
                                                                                    .rules
                                                                                    .required,
                                                                                ],
                                                                              dense:
                                                                                "",
                                                                              outlined:
                                                                                "",
                                                                              label:
                                                                                "Symbols Persistence Cycle",
                                                                              type: "number",
                                                                            },
                                                                          model:
                                                                            {
                                                                              value:
                                                                                _vm.SymbolsPersistenceCycle,
                                                                              callback:
                                                                                function (
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.SymbolsPersistenceCycle =
                                                                                    _vm._n(
                                                                                      $$v
                                                                                    )
                                                                                },
                                                                              expression:
                                                                                "SymbolsPersistenceCycle",
                                                                            },
                                                                        },
                                                                        on
                                                                      )
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            false,
                                                            3341360553
                                                          ),
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              " The persistence interval of symbols in seconds. "
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _c(
                                            "h2",
                                            {
                                              staticClass:
                                                "agent-config-category pl-2",
                                            },
                                            [_vm._v("Trades")]
                                          ),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "py-0",
                                                  attrs: {
                                                    cols: "12",
                                                    sm: "6",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: {
                                                        disabled:
                                                          _vm.isNotDesktop,
                                                        "content-class":
                                                          "tooltipClass",
                                                        bottom: "",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function ({
                                                              on,
                                                            }) {
                                                              return [
                                                                _c(
                                                                  "v-text-field",
                                                                  _vm._g(
                                                                    {
                                                                      staticClass:
                                                                        "analyticsTextFieldClass",
                                                                      attrs: {
                                                                        dense:
                                                                          "",
                                                                        outlined:
                                                                          "",
                                                                        label:
                                                                          "Initial Synchronization Timestamp",
                                                                        type: "number",
                                                                        rules: [
                                                                          _vm
                                                                            .rules
                                                                            .required,
                                                                        ],
                                                                      },
                                                                      on: {
                                                                        keydown:
                                                                          (
                                                                            ev
                                                                          ) =>
                                                                            _vm.setHelperVar(
                                                                              ev,
                                                                              "InitialSynchronizationTimestampAN"
                                                                            ),
                                                                        keypress:
                                                                          (
                                                                            ev
                                                                          ) =>
                                                                            _vm.setHelperVar(
                                                                              ev,
                                                                              "InitialSynchronizationTimestampAN"
                                                                            ),
                                                                        input: (
                                                                          ev
                                                                        ) =>
                                                                          _vm.textInput(
                                                                            ev,
                                                                            _vm
                                                                              .currentDefinition
                                                                              .configuration,
                                                                            "InitialSynchronizationTimestamp"
                                                                          ),
                                                                        change:
                                                                          _vm.clearHelperVar,
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          _vm.InitialSynchronizationTimestampAN,
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.InitialSynchronizationTimestampAN =
                                                                              _vm._n(
                                                                                $$v
                                                                              )
                                                                          },
                                                                        expression:
                                                                          "InitialSynchronizationTimestampAN",
                                                                      },
                                                                    },
                                                                    on
                                                                  )
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        false,
                                                        1818222918
                                                      ),
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          " Defines the initial synchronization starting point in seconds(epoch) e.g. if set to "
                                                        ),
                                                        _c("br"),
                                                        _vm._v(
                                                          "1262304000 then initial sync will start from Friday, January 1, 2010 12:00:00 AM GMT "
                                                        ),
                                                        _c("br"),
                                                        _vm._v(
                                                          "Zero value means sync everything "
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "py-0",
                                                  attrs: {
                                                    cols: "12",
                                                    sm: "6",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: {
                                                        disabled:
                                                          _vm.isNotDesktop,
                                                        "content-class":
                                                          "tooltipClassBig",
                                                        bottom: "",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function ({
                                                              on,
                                                            }) {
                                                              return [
                                                                _c(
                                                                  "v-text-field",
                                                                  _vm._g(
                                                                    {
                                                                      staticClass:
                                                                        "analyticsTextFieldClass",
                                                                      attrs: {
                                                                        dense:
                                                                          "",
                                                                        outlined:
                                                                          "",
                                                                        label:
                                                                          "Trades Batch Size",
                                                                        type: "number",
                                                                        rules: [
                                                                          _vm
                                                                            .rules
                                                                            .required,
                                                                        ],
                                                                      },
                                                                      on: {
                                                                        keydown:
                                                                          (
                                                                            ev
                                                                          ) =>
                                                                            _vm.setHelperVar(
                                                                              ev,
                                                                              "TradesBatchSizeAN"
                                                                            ),
                                                                        keypress:
                                                                          (
                                                                            ev
                                                                          ) =>
                                                                            _vm.setHelperVar(
                                                                              ev,
                                                                              "TradesBatchSizeAN"
                                                                            ),
                                                                        input: (
                                                                          ev
                                                                        ) =>
                                                                          _vm.textInput(
                                                                            ev,
                                                                            _vm
                                                                              .currentDefinition
                                                                              .configuration,
                                                                            "TradesBatchSize"
                                                                          ),
                                                                        focusout:
                                                                          _vm.clearHelperVar,
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          _vm.TradesBatchSizeAN,
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.TradesBatchSizeAN =
                                                                              _vm._n(
                                                                                $$v
                                                                              )
                                                                          },
                                                                        expression:
                                                                          "TradesBatchSizeAN",
                                                                      },
                                                                    },
                                                                    on
                                                                  )
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        false,
                                                        4164491500
                                                      ),
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          "Intended for internal use only"
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "py-0",
                                                  attrs: {
                                                    cols: "12",
                                                    sm: "6",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: {
                                                        disabled:
                                                          _vm.isNotDesktop,
                                                        "content-class":
                                                          "tooltipClass",
                                                        bottom: "",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function ({
                                                              on,
                                                            }) {
                                                              return [
                                                                _c(
                                                                  "v-text-field",
                                                                  _vm._g(
                                                                    {
                                                                      staticClass:
                                                                        "analyticsTextFieldClass",
                                                                      attrs: {
                                                                        dense:
                                                                          "",
                                                                        outlined:
                                                                          "",
                                                                        label:
                                                                          "Trade Synchronization Cycle",
                                                                        type: "number",
                                                                        rules: [
                                                                          _vm
                                                                            .rules
                                                                            .required,
                                                                        ],
                                                                      },
                                                                      on: {
                                                                        keydown:
                                                                          (
                                                                            ev
                                                                          ) =>
                                                                            _vm.setHelperVar(
                                                                              ev,
                                                                              "SynchronizationCycleAN"
                                                                            ),
                                                                        keypress:
                                                                          (
                                                                            ev
                                                                          ) =>
                                                                            _vm.setHelperVar(
                                                                              ev,
                                                                              "SynchronizationCycleAN"
                                                                            ),
                                                                        input: (
                                                                          ev
                                                                        ) =>
                                                                          _vm.textInput(
                                                                            ev,
                                                                            _vm
                                                                              .currentDefinition
                                                                              .configuration,
                                                                            "SynchronizationCycle"
                                                                          ),
                                                                        change:
                                                                          _vm.clearHelperVar,
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          _vm.SynchronizationCycleAN,
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.SynchronizationCycleAN =
                                                                              _vm._n(
                                                                                $$v
                                                                              )
                                                                          },
                                                                        expression:
                                                                          "SynchronizationCycleAN",
                                                                      },
                                                                    },
                                                                    on
                                                                  )
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        false,
                                                        2960178208
                                                      ),
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          " The period of time in milliseconds where the "
                                                        ),
                                                        _c("br"),
                                                        _vm._v(
                                                          "Synchronization will scan for trade updates "
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "py-0",
                                                  attrs: {
                                                    cols: "12",
                                                    sm: "6",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: {
                                                        disabled:
                                                          _vm.isNotDesktop,
                                                        "content-class":
                                                          "tooltipClassBig",
                                                        bottom: "",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function ({
                                                              on,
                                                            }) {
                                                              return [
                                                                _c(
                                                                  "v-text-field",
                                                                  _vm._g(
                                                                    {
                                                                      staticClass:
                                                                        "analyticsTextFieldClass",
                                                                      attrs: {
                                                                        dense:
                                                                          "",
                                                                        outlined:
                                                                          "",
                                                                        label:
                                                                          "Trades Linger Time",
                                                                        type: "number",
                                                                        rules: [
                                                                          _vm
                                                                            .rules
                                                                            .required,
                                                                        ],
                                                                      },
                                                                      on: {
                                                                        keydown:
                                                                          (
                                                                            ev
                                                                          ) =>
                                                                            _vm.setHelperVar(
                                                                              ev,
                                                                              "TradesLingerTimeAN"
                                                                            ),
                                                                        keypress:
                                                                          (
                                                                            ev
                                                                          ) =>
                                                                            _vm.setHelperVar(
                                                                              ev,
                                                                              "TradesLingerTimeAN"
                                                                            ),
                                                                        input: (
                                                                          ev
                                                                        ) =>
                                                                          _vm.textInput(
                                                                            ev,
                                                                            _vm
                                                                              .currentDefinition
                                                                              .configuration,
                                                                            "TradesLingerTime"
                                                                          ),
                                                                        focusout:
                                                                          _vm.clearHelperVar,
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          _vm.TradesLingerTimeAN,
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.TradesLingerTimeAN =
                                                                              _vm._n(
                                                                                $$v
                                                                              )
                                                                          },
                                                                        expression:
                                                                          "TradesLingerTimeAN",
                                                                      },
                                                                    },
                                                                    on
                                                                  )
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        false,
                                                        2884290043
                                                      ),
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          "Intended for internal use only"
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "v-row",
                                    { staticClass: "pb-2" },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass:
                                            "mb-0 mt-2 ml-3 pl-1 clickableText",
                                          staticStyle: {
                                            color: "#47bd96",
                                            "font-size": "14px",
                                            "-webkit-transform": "scaleX(-1)",
                                            transform: "scaleX(-1)",
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.analyticsConfigModel = 0
                                            },
                                          },
                                        },
                                        [_vm._v("icon-more-23x13 ")]
                                      ),
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "mb-0 mt-2 pl-1 clickableText",
                                          staticStyle: { color: "#47bd96" },
                                          on: {
                                            click: function ($event) {
                                              _vm.analyticsConfigModel = 0
                                            },
                                          },
                                        },
                                        [_vm._v(" General Configurations ")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm.selectedApplicationType ===
                              _vm.applicationTypeEnums.pricewatcher
                                ? _c(
                                    "v-row",
                                    [
                                      !_vm.add
                                        ? _c("symbol-selector", {
                                            staticClass: "mb-3",
                                            attrs: {
                                              PWServerStatus:
                                                _vm.PWServerStatus,
                                              PWSymbolsState:
                                                _vm.PWSymbolsState,
                                              appCode: "PW",
                                            },
                                            model: {
                                              value: _vm.allPricewatcherSymbols,
                                              callback: function ($$v) {
                                                _vm.allPricewatcherSymbols = $$v
                                              },
                                              expression:
                                                "allPricewatcherSymbols",
                                            },
                                          })
                                        : _vm._e(),
                                      _vm.isAdmin
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "pb-0 pt-1",
                                              attrs: { cols: "12", sm: "6" },
                                            },
                                            [
                                              _c(
                                                "v-tooltip",
                                                {
                                                  attrs: {
                                                    disabled: _vm.isNotDesktop,
                                                    "content-class":
                                                      "tooltipClassBig",
                                                    bottom: "",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "activator",
                                                        fn: function ({ on }) {
                                                          return [
                                                            _c(
                                                              "div",
                                                              _vm._g({}, on),
                                                              [
                                                                _c("v-select", {
                                                                  attrs: {
                                                                    outlined:
                                                                      "",
                                                                    dense: "",
                                                                    "menu-props":
                                                                      {
                                                                        offsetY: true,
                                                                      },
                                                                    "item-text":
                                                                      "text",
                                                                    label:
                                                                      "Use debug level",
                                                                    items: [
                                                                      {
                                                                        value: true,
                                                                        text: "Yes",
                                                                      },
                                                                      {
                                                                        value: false,
                                                                        text: "No",
                                                                      },
                                                                    ],
                                                                  },
                                                                  scopedSlots:
                                                                    _vm._u(
                                                                      [
                                                                        {
                                                                          key: "item",
                                                                          fn: function ({
                                                                            item,
                                                                          }) {
                                                                            return [
                                                                              _c(
                                                                                "p",
                                                                                {
                                                                                  staticClass:
                                                                                    "mb-0",
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      item.text
                                                                                    )
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          },
                                                                        },
                                                                      ],
                                                                      null,
                                                                      true
                                                                    ),
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .currentDefinition
                                                                        .priceWatcherConfiguration
                                                                        .use_debug_logs,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm
                                                                            .currentDefinition
                                                                            .priceWatcherConfiguration,
                                                                          "use_debug_logs",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "\n                            currentDefinition.priceWatcherConfiguration\n                              .use_debug_logs\n                          ",
                                                                  },
                                                                }),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    false,
                                                    3199754359
                                                  ),
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      "Set logs to debug level"
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.isAdmin
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "pb-0 pt-1",
                                              attrs: { cols: "12", sm: "6" },
                                            },
                                            [
                                              _c(
                                                "v-tooltip",
                                                {
                                                  attrs: {
                                                    disabled: _vm.isNotDesktop,
                                                    "content-class":
                                                      "tooltipClassBig",
                                                    bottom: "",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "activator",
                                                        fn: function ({ on }) {
                                                          return [
                                                            _c(
                                                              "div",
                                                              _vm._g({}, on),
                                                              [
                                                                _c("v-select", {
                                                                  attrs: {
                                                                    outlined:
                                                                      "",
                                                                    dense: "",
                                                                    "menu-props":
                                                                      {
                                                                        offsetY: true,
                                                                      },
                                                                    "item-text":
                                                                      "text",
                                                                    label:
                                                                      "Send diffs only",
                                                                    items: [
                                                                      {
                                                                        value: true,
                                                                        text: "Yes",
                                                                      },
                                                                      {
                                                                        value: false,
                                                                        text: "No",
                                                                      },
                                                                    ],
                                                                  },
                                                                  scopedSlots:
                                                                    _vm._u(
                                                                      [
                                                                        {
                                                                          key: "item",
                                                                          fn: function ({
                                                                            item,
                                                                          }) {
                                                                            return [
                                                                              _c(
                                                                                "p",
                                                                                {
                                                                                  staticClass:
                                                                                    "mb-0",
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      item.text
                                                                                    )
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          },
                                                                        },
                                                                      ],
                                                                      null,
                                                                      true
                                                                    ),
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .currentDefinition
                                                                        .priceWatcherConfiguration
                                                                        .send_diffs_only,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm
                                                                            .currentDefinition
                                                                            .priceWatcherConfiguration,
                                                                          "send_diffs_only",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "\n                            currentDefinition.priceWatcherConfiguration\n                              .send_diffs_only\n                          ",
                                                                  },
                                                                }),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    false,
                                                    2004358326
                                                  ),
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      "Sent only prices that changed since last time"
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.isAdmin
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "pb-0 pt-1",
                                              attrs: { cols: "12", sm: "6" },
                                            },
                                            [
                                              _c(
                                                "v-tooltip",
                                                {
                                                  attrs: {
                                                    disabled: _vm.isNotDesktop,
                                                    "content-class":
                                                      "tooltipClassBig",
                                                    bottom: "",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "activator",
                                                        fn: function ({ on }) {
                                                          return [
                                                            _c(
                                                              "div",
                                                              _vm._g({}, on),
                                                              [
                                                                _c("v-select", {
                                                                  attrs: {
                                                                    outlined:
                                                                      "",
                                                                    dense: "",
                                                                    "menu-props":
                                                                      {
                                                                        offsetY: true,
                                                                      },
                                                                    "item-text":
                                                                      "text",
                                                                    label:
                                                                      "Ignore empty ticks",
                                                                    items: [
                                                                      {
                                                                        value: true,
                                                                        text: "Yes",
                                                                      },
                                                                      {
                                                                        value: false,
                                                                        text: "No",
                                                                      },
                                                                    ],
                                                                  },
                                                                  scopedSlots:
                                                                    _vm._u(
                                                                      [
                                                                        {
                                                                          key: "item",
                                                                          fn: function ({
                                                                            item,
                                                                          }) {
                                                                            return [
                                                                              _c(
                                                                                "p",
                                                                                {
                                                                                  staticClass:
                                                                                    "mb-0",
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      item.text
                                                                                    )
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          },
                                                                        },
                                                                      ],
                                                                      null,
                                                                      true
                                                                    ),
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .currentDefinition
                                                                        .priceWatcherConfiguration
                                                                        .ignore_empty_ticks,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm
                                                                            .currentDefinition
                                                                            .priceWatcherConfiguration,
                                                                          "ignore_empty_ticks",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "\n                            currentDefinition.priceWatcherConfiguration\n                              .ignore_empty_ticks\n                          ",
                                                                  },
                                                                }),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    false,
                                                    279701174
                                                  ),
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      "Ignore empty ticks. Empty ticks are the ticks with bid/ask 0 and last update 0."
                                                    ),
                                                    _c("br"),
                                                    _vm._v(
                                                      "If SEND_DIFFS_ONLY is set to true empty ticks are never send since the default tick"
                                                    ),
                                                    _c("br"),
                                                    _vm._v(
                                                      "is an empty one thus no change is detected since the last cycle."
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.isAdmin
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "pb-0 pt-1",
                                              attrs: { cols: "12", sm: "6" },
                                            },
                                            [
                                              _c(
                                                "v-tooltip",
                                                {
                                                  attrs: {
                                                    disabled: _vm.isNotDesktop,
                                                    "content-class":
                                                      "tooltipClassBig",
                                                    bottom: "",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "activator",
                                                        fn: function ({ on }) {
                                                          return [
                                                            _c(
                                                              "div",
                                                              _vm._g({}, on),
                                                              [
                                                                _c("v-select", {
                                                                  attrs: {
                                                                    outlined:
                                                                      "",
                                                                    dense: "",
                                                                    "menu-props":
                                                                      {
                                                                        offsetY: true,
                                                                      },
                                                                    "item-text":
                                                                      "text",
                                                                    label:
                                                                      "Use UTC time",
                                                                    items: [
                                                                      {
                                                                        value: true,
                                                                        text: "Yes",
                                                                      },
                                                                      {
                                                                        value: false,
                                                                        text: "No",
                                                                      },
                                                                    ],
                                                                  },
                                                                  scopedSlots:
                                                                    _vm._u(
                                                                      [
                                                                        {
                                                                          key: "item",
                                                                          fn: function ({
                                                                            item,
                                                                          }) {
                                                                            return [
                                                                              _c(
                                                                                "p",
                                                                                {
                                                                                  staticClass:
                                                                                    "mb-0",
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      item.text
                                                                                    )
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          },
                                                                        },
                                                                      ],
                                                                      null,
                                                                      true
                                                                    ),
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .currentDefinition
                                                                        .priceWatcherConfiguration
                                                                        .use_utc_time,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm
                                                                            .currentDefinition
                                                                            .priceWatcherConfiguration,
                                                                          "use_utc_time",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "\n                            currentDefinition.priceWatcherConfiguration\n                              .use_utc_time\n                          ",
                                                                  },
                                                                }),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    false,
                                                    58451286
                                                  ),
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      "Prices are send using utc time. if false they are send in server time"
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.isAdmin
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "pb-0 pt-1",
                                              attrs: { cols: "12", sm: "6" },
                                            },
                                            [
                                              _c(
                                                "v-tooltip",
                                                {
                                                  attrs: {
                                                    disabled: _vm.isNotDesktop,
                                                    "content-class":
                                                      "tooltipClassBig",
                                                    bottom: "",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "activator",
                                                        fn: function ({ on }) {
                                                          return [
                                                            _c(
                                                              "v-text-field",
                                                              _vm._g(
                                                                {
                                                                  staticClass:
                                                                    "analyticsTextFieldClass",
                                                                  attrs: {
                                                                    dense: "",
                                                                    outlined:
                                                                      "",
                                                                    label:
                                                                      "Ping Interval (s)",
                                                                    type: "number",
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .currentDefinition
                                                                        .priceWatcherConfiguration
                                                                        .ping_interval,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm
                                                                            .currentDefinition
                                                                            .priceWatcherConfiguration,
                                                                          "ping_interval",
                                                                          _vm._n(
                                                                            $$v
                                                                          )
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "\n                          currentDefinition.priceWatcherConfiguration\n                            .ping_interval\n                        ",
                                                                  },
                                                                },
                                                                on
                                                              )
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    false,
                                                    1073822506
                                                  ),
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      "DSDP ping interval in seconds"
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.isAdmin
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "pb-0 pt-1",
                                              attrs: { cols: "12", sm: "6" },
                                            },
                                            [
                                              _c(
                                                "v-tooltip",
                                                {
                                                  attrs: {
                                                    disabled: _vm.isNotDesktop,
                                                    "content-class":
                                                      "tooltipClassBig",
                                                    bottom: "",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "activator",
                                                        fn: function ({ on }) {
                                                          return [
                                                            _c(
                                                              "v-text-field",
                                                              _vm._g(
                                                                {
                                                                  staticClass:
                                                                    "analyticsTextFieldClass",
                                                                  attrs: {
                                                                    dense: "",
                                                                    outlined:
                                                                      "",
                                                                    label:
                                                                      "Max DSDP join delay (s)",
                                                                    type: "number",
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .currentDefinition
                                                                        .priceWatcherConfiguration
                                                                        .max_dsdp_join_delay,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm
                                                                            .currentDefinition
                                                                            .priceWatcherConfiguration,
                                                                          "max_dsdp_join_delay",
                                                                          _vm._n(
                                                                            $$v
                                                                          )
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "\n                          currentDefinition.priceWatcherConfiguration\n                            .max_dsdp_join_delay\n                        ",
                                                                  },
                                                                },
                                                                on
                                                              )
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    false,
                                                    4156786762
                                                  ),
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      "Max time in seconds for dsdp join requests"
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.isAdmin
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "pb-0 pt-1",
                                              attrs: { cols: "12", sm: "6" },
                                            },
                                            [
                                              _c(
                                                "v-tooltip",
                                                {
                                                  attrs: {
                                                    disabled: _vm.isNotDesktop,
                                                    "content-class":
                                                      "tooltipClassBig",
                                                    bottom: "",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "activator",
                                                        fn: function ({ on }) {
                                                          return [
                                                            _c(
                                                              "v-text-field",
                                                              _vm._g(
                                                                {
                                                                  staticClass:
                                                                    "analyticsTextFieldClass",
                                                                  attrs: {
                                                                    dense: "",
                                                                    outlined:
                                                                      "",
                                                                    label:
                                                                      "DSDP expire time (s)",
                                                                    type: "number",
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .currentDefinition
                                                                        .priceWatcherConfiguration
                                                                        .dsdp_expire_time,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm
                                                                            .currentDefinition
                                                                            .priceWatcherConfiguration,
                                                                          "dsdp_expire_time",
                                                                          _vm._n(
                                                                            $$v
                                                                          )
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "\n                          currentDefinition.priceWatcherConfiguration\n                            .dsdp_expire_time\n                        ",
                                                                  },
                                                                },
                                                                on
                                                              )
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    false,
                                                    1948767125
                                                  ),
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      "Time in seconds since last msg received from DSDP. After that communication is considered lost and must be re-established before continuing with the rest of the flow"
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.isAdmin
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "pb-0 pt-1",
                                              attrs: { cols: "12", sm: "6" },
                                            },
                                            [
                                              _c(
                                                "v-tooltip",
                                                {
                                                  attrs: {
                                                    disabled: _vm.isNotDesktop,
                                                    "content-class":
                                                      "tooltipClassBig",
                                                    bottom: "",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "activator",
                                                        fn: function ({ on }) {
                                                          return [
                                                            _c(
                                                              "v-select",
                                                              _vm._g(
                                                                {
                                                                  attrs: {
                                                                    outlined:
                                                                      "",
                                                                    dense: "",
                                                                    "menu-props":
                                                                      {
                                                                        offsetY: true,
                                                                      },
                                                                    "item-text":
                                                                      "text",
                                                                    label:
                                                                      "Log prices in stats",
                                                                    items: [
                                                                      {
                                                                        value: true,
                                                                        text: "Yes",
                                                                      },
                                                                      {
                                                                        value: false,
                                                                        text: "No",
                                                                      },
                                                                    ],
                                                                  },
                                                                  scopedSlots:
                                                                    _vm._u(
                                                                      [
                                                                        {
                                                                          key: "item",
                                                                          fn: function ({
                                                                            item,
                                                                          }) {
                                                                            return [
                                                                              _c(
                                                                                "p",
                                                                                {
                                                                                  staticClass:
                                                                                    "mb-0",
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      item.text
                                                                                    )
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          },
                                                                        },
                                                                      ],
                                                                      null,
                                                                      true
                                                                    ),
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .currentDefinition
                                                                        .priceWatcherConfiguration
                                                                        .log_prices_in_stats,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm
                                                                            .currentDefinition
                                                                            .priceWatcherConfiguration,
                                                                          "log_prices_in_stats",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "\n                          currentDefinition.priceWatcherConfiguration\n                            .log_prices_in_stats\n                        ",
                                                                  },
                                                                },
                                                                on
                                                              )
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    false,
                                                    2965176818
                                                  ),
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      "Add prices to the statistics logging"
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.isAdmin
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "pb-0 pt-1",
                                              attrs: { cols: "12", sm: "6" },
                                            },
                                            [
                                              _c(
                                                "v-tooltip",
                                                {
                                                  attrs: {
                                                    disabled: _vm.isNotDesktop,
                                                    "content-class":
                                                      "tooltipClassBig",
                                                    bottom: "",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "activator",
                                                        fn: function ({ on }) {
                                                          return [
                                                            _c(
                                                              "v-text-field",
                                                              _vm._g(
                                                                {
                                                                  staticClass:
                                                                    "analyticsTextFieldClass",
                                                                  attrs: {
                                                                    dense: "",
                                                                    outlined:
                                                                      "",
                                                                    label:
                                                                      "Stats interval",
                                                                    type: "number",
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .currentDefinition
                                                                        .priceWatcherConfiguration
                                                                        .stats_interval,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm
                                                                            .currentDefinition
                                                                            .priceWatcherConfiguration,
                                                                          "stats_interval",
                                                                          _vm._n(
                                                                            $$v
                                                                          )
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "\n                          currentDefinition.priceWatcherConfiguration\n                            .stats_interval\n                        ",
                                                                  },
                                                                },
                                                                on
                                                              )
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    false,
                                                    3139559288
                                                  ),
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      "Interval for statistics logging"
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-card-actions",
                    {
                      staticClass: "card-actions pt-0 overflowXY-hidden",
                      staticStyle: { "max-height": "46px" },
                    },
                    [
                      _c(
                        "v-row",
                        [
                          _c("v-col", {
                            class: `${
                              _vm.$vuetify.breakpoint.xsOnly && !_vm.add
                                ? "pt-4"
                                : "pt-5"
                            } mt-1 pl-3`,
                            attrs: { cols: "5", sm: "8", md: "7" },
                          }),
                          _c(
                            "v-col",
                            {
                              staticClass: "pt-0 pb-3 px-0",
                              attrs: { cols: "7", sm: "4", md: "5" },
                            },
                            [
                              _c(
                                "v-row",
                                {
                                  staticClass: "pr-3 mr-1",
                                  attrs: { justify: "end" },
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "mt-3",
                                      attrs: { text: "" },
                                      on: {
                                        click: function ($event) {
                                          _vm.dialog = !_vm.dialog
                                        },
                                      },
                                    },
                                    [_vm._v("Cancel ")]
                                  ),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "mt-3",
                                      attrs: { color: "primary", text: "" },
                                      on: {
                                        click: function ($event) {
                                          _vm.$refs.confForm.validate() &&
                                          _vm.validateMultipliersForm()
                                            ? _vm.saveHandler()
                                            : 0
                                        },
                                      },
                                    },
                                    [_vm._v("Save ")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.shouldShowConsent === true && this.dialog === true
        ? _c("consent-banner", { on: { submit: _vm.submitConsentHandler } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }